/*============================================================================
  Global - header
==============================================================================*/

var header = {
  init: function(){
    //remove duplicate header on update
    if ($('.mobile-header').length > 1) {
      var nav_menu = $("#nav").data("mmenu");
      nav_menu.close();
      $('.mobile-header:last, #nav:last').remove();
    }
    if ($('.header').length > 1){
      $('.header.mm-slideout').remove();
    }	

    // Only applied when there is a full-width banner across top of page
    var $header = $(".feature_image .header.header-background--false");

    if(typeof promo_messages === 'undefined') {
        window.promo_messages = [
        ];
    }

    //Promo banner
    if ($('.promo_banner').length){

      var promo_banner = $.cookie('promo_banner');
      var promo_banner_height = $('.promo_banner').outerHeight();

      if (promo_banner != 'dismiss') {
        $('body').addClass('promo_banner--true');

        if ($('.promo_banner_mobile').is(':hidden') && $('.header--content-behind').length){
          $('.promo_banner--true').css('padding-top', promo_banner_height + 'px');
        }

        $('.promo_banner .icon-close, .promo_banner_mobile .icon-close').on('click', function(){
          $('.promo_banner--true').attr('style', '');
          $('body').removeClass('promo_banner--true');
          $.cookie('promo_banner', 'dismiss', { path: '/' }, { expires: 30 });
          banner.init();
        });
      }

      var i = 0;
      var promoBanner = setInterval(function(){
        if(window.promo_messages.length >= 1) {
          var messageClasses = _.compact(window.promo_messages.map(x => x.classes)).join(' '),
              messages = window.promo_messages.map(function(record) { return record.message; });

          i = i == window.promo_messages.length ? 0 : i;
          if(typeof window.promo_messages[i].classes !== "undefined") {
            $('.promo_banner, .promo_banner_mobile').html(messages.join('<b>-</b>')).hide().removeClass(messageClasses).show();
          } else {
            $('.promo_banner, .promo_banner_mobile').html(messages.join('<b>-</b>')).hide().removeClass(messageClasses).show();
          }
          i++;
        } else {
          $('.promo_banner').show();
          clearInterval(promoBanner);
        }
        $('.banner-section:visible').first().css('padding-top', $('.header_bar').height());
        if($(window).width() > 768 ) {
          if($('.print-at-home-card-link').length) {
            $('.print-at-home-card-link').fancybox({
              toolbar  : false,
              smallBtn : true,
              helpers: {
                title : {
                  type : 'float'
                }
              },
              maxWidth: 800,
            });
          }
        } else {
          if($('.print-at-home-card-link-mobile').length) {
            $('.print-at-home-card-link-mobile').fancybox({
              toolbar  : false,
              smallBtn : true,
              helpers: {
                title : {
                  type : 'float'
                }
              },
              maxWidth: 800,
            });
          }          
        }
        
      },1000);
    }

    freegiftPromo = setInterval(function(){
      if(typeof gift_promo_messages != 'undefined' && gift_promo_messages.length) {
        let messages = window.gift_promo_messages.map(function(record) { return record.message; }),
            desktop_img = $('.freegift_promo--bar').not('.freegift_promo--bar-mobile').data('href'),
            mobile_img = $('.freegift_promo--bar-mobile').data('href');


        $('.freegift_promo--bar').html(messages.join('<b>-</b>')).show();
        $('.freegift_promo--bar').find('.freegift_promo--fancybox').attr('href', desktop_img);
        $('.freegift_promo--bar-mobile').find('.freegift_promo--fancybox').attr('href', mobile_img);

        $('.freegift_promo--fancybox').fancybox({'scrolling' : 'no'});
        clearInterval(freegiftPromo);
      }
      $('.banner-section:visible').first().css('padding-top', $('.header_bar').height());
    },1000);

    $('#nav').mmenu({
      searchfield : {
        add: $('#header').data('search-enabled'),
        search: false,
        placeholder: "Search"
      },
      navbars: [
        {
         "position": "top",
         "content": [
            "searchfield"
         ]
        },
        {
          "position": "top"
        },
        {
          "position": "bottom",
          "content": [
            $(".js-social-icons").html()
          ]
        }
      ],
      "extensions": [
        "theme-white"
      ],
      offCanvas: { pageSelector: "#content_wrapper" }
    },
    {
      clone: false,
      searchfield: {
        "form": {
          "action": "/search"
        },
        "input": {
          "name": "q"
        }
      }
    });

    
      $('#nav .mm-search').append('<input type="hidden" name="type" value="product" />');
    

    if ($('.mobile-header:hidden') && $('.default-header').hasClass('behind-menu--true')){
      $('.default-header').parent('.header-section').addClass('header--content-behind');
    }

    var $header = $(".header");

    if ($('.default-header').hasClass('mm-fixed-top')) {
      $(window).on("scroll", function() {
        if ($(this).scrollTop()  <= 100 ){
          $('.promo_banner, .promo_banner_mobile, .freegift_promo--bar').removeClass('hidden');
        } else {
          $('.promo_banner, .promo_banner_mobile, .freegift_promo--bar').addClass('hidden');
        }

        if(!$('html').hasClass('mm-opened')) {
          if($header.hasClass("behind-menu--true") && !$header.hasClass("js-no-change")) {
            $header.toggleClass('header_bar', $(window).scrollTop() > 0);
          }
        }
      });
    }

    $('#cart').mmenu({
      navbar: {
        add: false
      },
      navbars: [
        {
            "position": "bottom",
            "content": [
                "<a class='fa fa-envelope' href='#/'></a>",
                "<a class='fa fa-twitter' href='#/'></a>",
                "<a class='fa fa-facebook' href='#/'></a>"
            ]
        }
      ],
      offCanvas: { position: 'right', pageSelector: "#content_wrapper" },
      "extensions": [
        "theme-white"
      ]
    });

    var api = $('#cart').data('mmenu');
    api.bind('opened', function () {
      window.location.hash = 'cartopen';

      // Trigger upsell dataLayer event
      let $drawerUpsell = $('#cart-sidebar').find('.cart-upsell');

      dataLayer.push({
        "event": "productImpressions",
        "ecommerce": {
          "currencyCode": "USD",
          "impressions": [
            {
              "id": $drawerUpsell.find('.cart-upsell-button').data('variant-sku'),
              "name": $drawerUpsell.find('.cart-upsell__content-name').text(),
              "price": $drawerUpsell.find('.cart-upsell-button').data('variant-price'),
              "position": 0,
              "variant": $drawerUpsell.find('.cart-upsell-button').data('variant-id'),
              "list": "Drawer Cart"
            }
          ]
        }
      });
    });

    api.bind('closed', function () {
      window.location.hash = '';
    });

    $('.icon-cart, .icon-menu').on("click", function(e) {
      $('#search').hide();
    });

    $(".icon-search").on('click', function(e) { $(this).parent('form').submit(); });

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) && $(window).width() >= 768) {
      $(document).on('click', '.menu li.sub-menu > a', function(e) {
        e.preventDefault();
        return false;
      });
    }

    $('body').on('mouseover', '.sub-menu', function() {
      $(this).attr('aria-expanded', true);
    });
    $('body').on('mouseout', '.sub-menu', function() {
     $(this).attr('aria-expanded', false);
    });

    banner.init();
  },
  unload: function($target){

  }
}

/*============================================================================
  Home page - banner
==============================================================================*/

var banner = {
  init: function(){

    if ($(window).width() >= 768) { 

      if ($('[data-secondary-logo]').length) {
        $('.header .logo').addClass('secondary-logo--true');
        var totalHeaderHeight = $('.header').outerHeight();
      } else {
        $('.header .logo').addClass('secondary-logo--false');
        var totalHeaderHeight = $('.header').outerHeight();
      }

      if ($('body').hasClass('index') || $('body').hasClass('feature_image') || $('.shopify-section.banner-template-section').length || $('.shopify-section.details-section').length || $('.collection-banner-template-section').length){

        var $banner = $('.banner-section').first();
        var $draggableSection = $('.index-sections .shopify-section, .page-details-section .page-details-block').first();

        if ($draggableSection.length) {
          var $firstSection = $draggableSection.children().first();
        } else {
          var $firstSection = $banner;
        }

        $firstSection.attr('style', '');

        if ((!$firstSection.hasClass('wide_display--false') && $firstSection.find('.slider').length) || !$firstSection.hasClass('wide_display--false') && $firstSection.find('.flexslider').length || !$firstSection.hasClass('wide_display--false') && $('body').hasClass('index')) {

          if ($('.header').hasClass('behind-menu--false') && !$firstSection.hasClass('wide_display--false')){
            $firstSection.css('padding-top', totalHeaderHeight);
            $('.header').parent().removeClass('feature_image');
            $('.header').addClass('header_bar');

            $(window).resize(function() {
              totalHeaderHeight = $('.header').outerHeight();
              if ($(window).width() >= 768 && parseInt($firstSection.css('padding-top'), 10) != parseInt(totalHeaderHeight, 10)) {
                $firstSection.css('padding-top', totalHeaderHeight);
              }
            });
          } else if ($('.header').hasClass('behind-menu--true')){
            $('.header').parent().addClass('feature_image');
            $('.header').removeClass('header_bar js-no-change');
          } else {
            $('.header').parent().addClass('feature_image');
            $('.header').removeClass('header_bar js-no-change').addClass('header_bar behind-menu--false');
            $('.header').removeClass('header_bar js-no-change behind-menu--false').addClass('behind-menu--true');
          }

        } else {
          if ($('.header').hasClass('behind-menu--false')){
            $('.header').addClass('header_bar');
          } else {
            $('.feature_image').removeClass('feature_image');
            $('.header').removeClass('behind-menu--true').addClass('header_bar behind-menu--false');
          }
        }
      }
    }


  },
  unload: function($target){
    $('body').addClass('feature_image');
    $('.banner-section').attr('style', '');
    $target.children().first().attr('style', '');
  }
}

/*============================================================================
  Home page - slideshow
==============================================================================*/

var slideshow = {
  init: function(){
      $('.homepage_slider').each(function (index, value){
        var homepageSlider = $(this);
        var slideshowAnimation = homepageSlider.data('slideshow-animation');
        var slideshowSpeed = homepageSlider.data('slideshow-speed');
        homepageSlider.flexslider({
          touch: true,
          controlNav: true,
          animation: slideshowAnimation,
          slideshowSpeed: slideshowSpeed ? slideshowSpeed*1000 : 10*1000,
          fadeFirstSlide: false
        });

        if($('.slides li', homepageSlider).length == 1) {
          $('.flex-direction-nav', homepageSlider).hide();
        };

      });

  },
  unload: function($target){
    var slider = $target.find('.homepage_slider');
    destroySlider(slider);
  }
}

/*============================================================================
  Home page - video
==============================================================================*/

//check to see if HTML5 video is supported
var supports_video = function(){
  return !!document.createElement('video').canPlayType;
}

var homepageVideo = {
  unload: function($target){
    $target.find('[data-play-video]').off('click');
  },
  getVideoDetails: function(settings){
    var videoDetails = {
        id: settings.header.attr('data-video-src'),
        aspectRatio: settings.header.attr('data-aspect-ratio').split(":"),
        provider: settings.header.attr('data-provider'),
        videoMP4: settings.header.attr('data-video-mp4'),
        videoOGV: settings.header.attr('data-video-ogv')
    }
    return videoDetails;
  },
  createFrame: function(settings, videoDetails){

    if(videoDetails.provider === 'youtube') {
      if (settings.autoloop){
        var autoloop = '1&iv_load_policy=3&playlist='+videoDetails.id;
      } else {
        var autoloop = 0;
      }

      var html = '<iframe data-src="//www.youtube.com/embed/'+videoDetails.id+'?&autoplay=1&loop='+autoloop+'&rel=0&hd=1&showinfo=0&color=white&controls=0" class="lazyload" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
    }
    else if(videoDetails.provider === 'vimeo') {
      if (settings.autoloop){
        var autoloop = 1;
      } else {
        var autoloop = 0;
      }
      var html = '<iframe data-src="//player.vimeo.com/video/'+videoDetails.id+'?loop='+autoloop+'&amp;title=0&amp;byline=0&amp;portrait=0&amp;color=3d96d2&autoplay=1" class="lazyload" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
    }
    else if(videoDetails.provider === 'html5') {
      if (settings.autoloop){
        var autoloop = 'loop="loop"';
      }

      var html = '<video autoplay="true" '+autoloop+' id="video" class="lazyload" preload="none"><source src="'+videoDetails.videoMP4+'" type="video/mp4"><source src="'+videoDetails.videoOGV+'" type="video/ogg" ></video>';
    }
    else if(videoDetails.provider === 'empty') {
      if (settings.autoloop){
        var autoloop = '1&iv_load_policy=3&playlist='+'_9VUPq3SxOc';
      } else {
        var autoloop = 0;
      }

      var html = '<iframe data-src="//www.youtube.com/embed/'+'_9VUPq3SxOc'+'?&autoplay=1&loop='+autoloop+'&rel=0&hd=1&showinfo=0&color=white&controls=0" class="lazyload" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>';
    }
    return html;
  },
  appendFrame: function(settings, videoDetails){
    var addVideo = function(){
      //only add video if there are no videos already in the section
      if (settings.container.find('.mediaWrapper').length < 1 && settings.container.find('#video').length < 1){
        settings.container.append(homepageVideo.createFrame(settings, videoDetails));
      }

      if (videoDetails.provider != 'html5'){
        settings.container.find('iframe').mediaWrapper({
          intrinsic: false,
          baseWidth : videoDetails.aspectRatio[0],
          baseHeight: videoDetails.aspectRatio[1]
        });
      }
    }

    if(!homepageVideo.isMobile()) {
      addVideo();
      var mediaWrapper = settings.container.find('.mediaWrapper');
      settings.container.height(mediaWrapper.outerHeight());
      settings.posterImage.addClass('fadeOut animated');

      if (settings.bannerVideoText){
        settings.videoText.addClass('text-on-video');
      } else {
        settings.videoText.hide();
      }

      settings.header.next().fadeIn('slow');
      if (videoDetails.provider != 'html5'){
        mediaWrapper.find('iframe').show();
      } else {
        settings.header.next().show();
        settings.container.find('.homepage-video__placeholder').hide();
        settings.container.find('.homepage-video__image').hide();
      }

      settings.videoTrigger.removeAttr('data-play-video');

    }
  },
  isMobile: function(){
    return false; //initiate as false
    // device detection
    if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
        || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) return true;
  }
}

var video = {
  init: function(){

    //Check for videos that are set to autoplay
    $('.homepage-video').each(function (index, value) {
      if ($('.homepage-video').length && supports_video()) {

        var $videoElement = $(this);
        var settings = {
          container: $videoElement,
          header: $videoElement.find('.homepage-video--media'),
          posterImage: $videoElement.find('.homepage-video img[data-play-video]'),
          videoText: $videoElement.find('.homepage-video--media .caption'),
          videoTrigger: $videoElement.find("[data-play-video]"),
          autoPlayVideo: $videoElement.data('autoplay'),
          bannerVideoText: $videoElement.data('video-text'),
          autoloop: $videoElement.data('autoloop')
        }
        var videoDetails = homepageVideo.getVideoDetails(settings);

        if (settings.autoPlayVideo && !homepageVideo.isMobile()){
          homepageVideo.appendFrame(settings, videoDetails);
        }

      }
    });

    //Attach event listener for videos
    $(document).on('click', '[data-play-video]', function(e) {
      var $videoElement = $(this).parents('.homepage-video');
      var settings = {
        container: $videoElement,
        header: $videoElement.find('.homepage-video--media'),
        posterImage: $videoElement.find('.homepage-video img[data-play-video]'),
        videoText: $videoElement.find('.homepage-video--media .caption'),
        videoTrigger: $videoElement.find("[data-play-video]"),
        autoPlayVideo: $videoElement.data('autoplay'),
        bannerVideoText: $videoElement.data('video-text'),
        autoloop: $videoElement.data('autoloop')
      }
      var videoDetails = homepageVideo.getVideoDetails(settings);

      homepageVideo.appendFrame(settings, videoDetails);
    });
  }
}

/*============================================================================
  Home page - testimonials
==============================================================================*/

var testimonials = {
  init: function(){
      $('.testimonial_slider').each(function (index, value){
        var testimonialSlider = $(this);
        var slideshowAnimation = testimonialSlider.data('slideshow-animation');
        var slideshowSpeed = testimonialSlider.data('slideshow-speed');

        testimonialSlider.flexslider({
          touch: true,
          controlNav: true,
          animation: 'slide',
          slideshowSpeed: slideshowSpeed ? slideshowSpeed*1000 : 10*1000,
          fadeFirstSlide: false
        });

        if($('.slides li', testimonialSlider).length == 1) {
          $('.flex-direction-nav', testimonialSlider).hide();
        };

      });

  },
  unload: function($target){
    var slider = $target.find('.testimonial_slider');
    destroySlider(slider);
  }
}


/*============================================================================
  Home page - featured products
==============================================================================*/
var featuredProducts = {
  init: function() {

    $('.featured-products__slider').each(function (index, value){
      var testimonialSlider = $(this);
      var slideshowAnimation = testimonialSlider.data('slideshow-animation');
      var slideshowSpeed = testimonialSlider.data('slideshow-speed');

      testimonialSlider.flexslider({
        touch: true,
        controlNav: true,
        animation: 'slide',
        slideshowSpeed: slideshowSpeed ? slideshowSpeed*1000 : 10*1000,
        fadeFirstSlide: false,


        itemWidth: 380,
        itemMargin: 10,
        minItems: 3,
        maxItems: 3
      });

      if($('.slides li', testimonialSlider).length == 1) {
        $('.flex-direction-nav', testimonialSlider).hide();
      };

    });
  },
  unload: function($target){
    var slider = $target.find('.featured-products__slider');
    destroySlider(slider);
  }
}

/*============================================================================
  Home page - social media
==============================================================================*/

var social = {
  twitter: function(){
    if (window.twttr) {
      window.twttr.ready(function (twttr) {
        twttr.widgets.load();
      });
    }
  },
  unload: function(){

  }
}

/*============================================================================
  Product
==============================================================================*/

var product = {
  init: function(){
    this.initSlider();
    this.initOptionSelectors();
    this.initNotifyForm();
    this.initSwatches();
    this.initAccordion();
    this.initAdd2ToCart();
    this.initKeepsakeBox();
    this.initCrossedPath();
    this.initCustomCoords();
    this.initCoordsSet();
    this.initDateSet();
    this.initCrossedSet();
    this.initHeartSet(); 
    this.initNameSet();
    this.initInfinitySet();
    this.initWingedHeart();
    this.initCustomInfinity();
    this.initCustomDate();
    this.initCustomCross();
    this.initCustomWord();
    this.initCustomAnchor();
    this.initGiftSets();
    this.initMobileConfigurator();
    this.initBuffaloBoneModal();
    this.initPrintCardModal();
    this.initAnnouncementModal();
    this.hijackQuestionButton();
    this.initAccordionFitGuideImages();
  },
  initSlider: function($target, variant) {
    var $slider = $('.product_slider', $target);

    // If a scope is not defined, init all .product_sliders
    if( $target == undefined ) {
      $slider = $('.product_slider', $target);
    }

    var productSlideItemsHtml = $slider.parents('.product_section').find('.product-slide-items-object').html(),
        $productSlideItems = $(productSlideItemsHtml),
        thumbnailPosition = $slider.parents('.product_section').data('thumbnail'),
        slideshowAnimation = $slider.parents('.product_section').data('slideshow-animation'),
        slideshowSpeed = $slider.parents('.product_section').data('slideshow-speed');

    if ( $(window).width() < 480 && !$slider.hasClass('keep-thumbnails')) {
      thumbnailPosition = 'no-thumbnails';
    }

    // Destroy fancybox
    // $('.product_slider a').unbind('fancybox').unbind('click');

    if( variant == undefined ) {
      // Display all slides if this is a simple product
      $slider.find('.slides').html( $productSlideItems.find('li') );
    } else {
      // Alter slide items if needed
      var productTitle = variant.name.replace(' - ' + variant.title, ''),
          slideAltParts = [];

      for( var i=1 ; i<=3 ; i++ ) {
        if( variant['option' + i] != null ) {
          slideAltParts.push(variant['option' + i]);
        }
      }
      $slider.find('.slides').html( $productSlideItems.find('li').filter('[data-alt*="' + slideAltParts.join(' ') + '"], [data-alt*="' + slideAltParts.reverse().join(' ') + '"]' ) );
      $slider.find('.slides').append( $productSlideItems.find('li').filter('[data-alt*="' + productTitle + '"]') );
      $slider.find('.slides').append( $productSlideItems.find('li').filter('[data-alt="All"]') );
      $slider.find('.slides').append( $productSlideItems.find('li').filter('[data-alt^="Dynamic Custom"]') );
    }

    if (slideshowAnimation == 'zoom'){
      CloudZoom.quickStart();
    }

    var player = document.querySelectorAll('#youtube_player');

    function addEvent(element, eventName, callback) {
        if (element.addEventListener) {
          element.addEventListener(eventName, callback, false)
        } else {
          element.attachEvent(eventName, callback, false);
        }
    }


    if(player.length > 0) {

        $slider.flexslider({
            startAt: parseInt($('.featured_image', $(this)).data('index'), 10),
            touch: false,
            pauseOnHover: true,
            controlNav: thumbnailPosition == "no-thumbnails" ? false : "thumbnails",
            directionNav: thumbnailPosition == "no-thumbnails" ? true : false,
            animation: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? 'fade' : slideshowAnimation,
            slideshow: false,
            smoothHeight: true,
            slideshowSpeed: slideshowSpeed ? slideshowSpeed*1000 : 10*1000,
            init: function(slider){
              $("li.flex-active-slide .image__container > img").on('load', function() {
                setTimeout(()=> {
                  $('.product_gallery_wrapper').css('opacity', 1);
                }, 100);
              });
            },
            start: function(slider){
                slider.resize();

                // smoothHeight page load fix
                var maxAttempts = 10,
                failCount = 0,
                heightValidation = setInterval(function() {
                    if ($(slider).height() < 250 && failCount < maxAttempts) {
                        $(window).resize();
                        failCount += 1;
                    } else {
                        clearInterval(heightValidation);
                    }
                });

                // Show arrows
                if ( $(window).width() < 480) {
                  $('.flex-direction-nav').show();
                  $('.flex-direction-nav').addClass('slider-option-one');
                }
            },
            // Lazyload in iframe video
            after: function(slider){
              if (document.querySelector("li.flex-active-slide").children[0].classList.contains("video-container-wrapper")) {
                $("iframe.lazy").each(function(){
                  var src = $(this).attr("data-src");
                  $(this).attr("src", src).removeAttr("data-src").removeClass("lazy");
                });
              }
            }
        });
    } else {
        $slider.flexslider({
            startAt: parseInt($('.featured_image', $(this)).data('index'), 10),
            touch: false,
            pauseOnHover: true,
            controlNav: thumbnailPosition == "no-thumbnails" ? false : "thumbnails",
            directionNav: true,
            animation: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? 'fade' : slideshowAnimation,
            slideshow: false,
            slideshowSpeed: slideshowSpeed ? slideshowSpeed*1000 : 10*1000,
            init: function(slider){
              $("li.flex-active-slide .image__container > img").on('load', function() {
                setTimeout(()=> {
                  $('.product_gallery_wrapper').css('opacity', 1);
                }, 100);
              });
            },
            start: function(slider){
                slider.resize();

                // smoothHeight page load fix
                var maxAttempts = 10,
                failCount = 0,
                heightValidation = setInterval(function() {
                    if ($(slider).height() < 250 && failCount < maxAttempts) {
                        $(window).resize();
                        failCount += 1;
                    } else {
                        clearInterval(heightValidation);
                    }
                });

                // Show arrows
                if ( $(window).width() < 480) {
                  $('.flex-direction-nav').show();
                  $('.flex-direction-nav').addClass('slider-option-one');
                }
            }
        });
    }

    // Reinitialize fancybox
    //$('.product_slider .fancybox').fancybox();

    if (slideshowAnimation == 'slide'){
      if($('img', $slider).data("index") == 0) {
        $('.flex-direction-nav', $slider).hide()
      }
    } else {
      if($('img', $slider).length == 1) {
        $('.flex-direction-nav', $slider).hide()
      }
    }
  },
  initOptionSelectors: function() {
    $('.product_form.product_form_options.init').each(function() {
      new Shopify.OptionSelectors($(this).data("select-id"), {
        product: $(this).data("product"),
        onVariantSelected: selectCallback,
        enableHistoryState: $(this).data("enable-state")
      });
    });
  },
  initNotifyForm: function() {
    var $notify_form = $('.notify_form .contact-form');
    $notify_form.each(function() {
      var $nf = $(this);
      $nf.on("submit", function (e) {
        if($('input[name="challenge"]', $nf).val() !== "true") {
          $.ajax({
            type: $nf.attr('method'),
            url: $nf.attr('action'),
            data: $nf.serialize(),
            success: function (data) {
              $nf.fadeOut("slow", function(){
                $nf.prev('.message').html("Thanks! We will notify you when this product becomes available!");
              });
            },
            error: function(data) {
              $('input[name="challenge"]', $nf).val('true');
              $nf.submit();
            }
          });
          e.preventDefault();
        }
      });
    });
  },
  initSwatches: function() {
    
      $('.product_form').addClass('is-visible');
      $('.swatch :radio').change(function(event) {
        var optionIndex = $(this).closest('.swatch').attr('data-option-index');
        var optionValue = $(this).val();

        if ($('.product-name-zodiac-signs-bracelet').length && $(this).attr('name') == 'option-0') {
          var $cForm = $(this).closest('form');
          setTimeout(function() {
            $cForm
              .find('.single-option-selector')
              .eq(optionIndex)
              .val(optionValue)
              .trigger('change');
          }, 200);
          $cForm.find('.black-swatch').prev().prop('checked', true).trigger('change');
        } else {
          $(this)
            .closest('form')
            .find('.single-option-selector')
            .eq(optionIndex)
            .val(optionValue)
            .trigger('change');
        }
      });
    
  },
  initAccordion: function() {
    $('body').on( 'selectCallback', function( event, variant ) {
      if( !variant ) {
        return;
      }
      $('.product__fit-guide__item').hide();
      for( var i=0 ; i<variant.options.length ; i++ ) {
        var option = variant.options[i];
        $('.product__fit-guide__item').filter('[data-value="' + option + '"]').show();
      }
    });
  },
  initAccordionFitGuideImages: function() {
    $('.product__fit-guide__item').find('img').each(function(){
      var src = $(this).data('src');
      $(this).attr('src', src).css('opacity', 1);
    });
  },
  initAdd2ToCart: function() {
    var $add2ToCart = $('.add_2_to_cart');
    if( !$add2ToCart.length ) {
      return;
    }
    $add2ToCart.click(function(e){
      e.preventDefault();
      var $productForm = $(this).closest('.product_form'),
          $quantity = $productForm.find('[name="quantity"]'),
          $addToCart = $productForm.find('button.add_to_cart');
      $quantity.val(2).change();
      $addToCart.click();
    })
  },
  initKeepsakeBox: function() {
    var selectors = {
      container: '.keepsake-box',
      textareaContainer: '.keepsake-box__textarea-container',
      textarea: '.keepsake-box__textarea',
      propertiesInput: '.keepsake-box__input',
      timestampInput: '.keepsake-box__timestamp',
      type: 'input.type',
      customBundleStepBack: '.product__custom__prev',
      addToCartBtn: '.add_to_cart',
      navLinkConfirm: '.mobile-configurator__nav__link--confirm',
      navLinkAddToCart: '.mobile-configurator__nav__link--add-to-cart',
      textLimit: '.char-limit'
    };

    var defaults = {
        maxCharactersRound: 250,
        maxCharactersSquare: 250
    };

    if( !$( selectors.container ).length || $('.engraved_frame').length ) {
      return;
    }
    
    if(($('.product-form-wrapper select.single-option-selector').val() == "Custom" || $('.product-form-wrapper select[name="id"] option[selected="selected"]').text() == "Custom" ) && $('.keepsake-box__textarea').val() == "") 
      $('.product-form-wrapper').find('.swatch_options .swatch__element[data-value="Normal"] img').trigger('click');

    var updatePreviewUrl = function (path) {
      let $slidesToUpdate = $('.flexslider .slides > li');
      let navThumb = $('.flex-control-nav > li');
      let itLoaded = false;
      let firstSlide;
      let secondSlide;
      let index;

      let $target = $slidesToUpdate.filter('[data-alt="Dynamic Custom Keepsake Box"]');

      if ($target.length) {
        firstSlide = $target.not('.clone')[0];
        secondSlide = $target.filter('.clone')[0];
        index = $slidesToUpdate.not('.clone').index(firstSlide);
      } else {
        firstSlide = $slidesToUpdate[1];
        secondSlide = $slidesToUpdate[$slidesToUpdate.length - 1];
        index = 0;
      }

      if (firstSlide){
        let $firstImage = $(firstSlide).find('img');
        $(firstSlide).data('thumb', path);
        $firstImage.attr('src', path);
        $firstImage.attr('data-src', path);
        $firstImage.attr('srcset', '');
        $firstImage.attr('data-srcset', '');
        var imageLoading = $firstImage;
        imageLoading.off('load').on('load', function(){
          itLoaded = true;
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        });
      }
      if (secondSlide){
        let $secondImage = $(secondSlide).find('img');
        $(secondSlide).data('thumb', path);
        $secondImage.attr('src', path);
        $secondImage.attr('data-src', path);
        $secondImage.attr('srcset', '');
        $secondImage.attr('data-srcset', '');
      }
      if (navThumb && navThumb.length > index)
        $(navThumb[index]).find('img').attr('src', path);
      var slider = $('.flexslider');
      if (slider) {
        slider.flexslider(index);
      }

      //$('.mobile-configurator__panel__body .crossed-paths__input-bg').css('background-image', 'url(' + path + ')');

      setTimeout(function() {
        // fallback in case it's taking too slow to load the first image
        if (!itLoaded){
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        }
      }, 3000);
    };

    // Keys will be concatenated values of text
    var cache = {};

    var createKeepsakeBoxPreview = function (text, type = "round") {
      $('.product_gallery').addClass('is-loading');
      $('.swatch_options').addClass('is-loading');

      // Don't wait for response to assign the preview url
      var path = 'https://w.sellry.com/keepsake-box-preview/?'+
                'text='+encodeURIComponent(text)+'&'+
                'type='+type+'&'+
                'action=preview';
      $('.box-preview-url').attr('value', path);

      if ( cache[text+type] ) {
        setTimeout(function(){
          updatePreviewUrl(cache[text+type]);
        }, 500);
      } else {
        $.ajax({
          url: 'https://w.sellry.com/keepsake-box-preview/',
          dataType: 'json',
          cache: false,
          type: 'get',
          data: {text: text, type: type, action: 'preview'},
          error: function(xhr) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if(contentType !== 'image/jpeg') {
              $('.product_gallery').removeClass('is-loading');
              $('.swatch_options').removeClass('is-loading');
            }
          },
          complete: function(xhr) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if(contentType === 'image/jpeg') {
              cache[text+type] = path;
              setTimeout(function(){
                updatePreviewUrl(path);
              }, 500);
            } else {
              $('.product_gallery').removeClass('is-loading');
              $('.swatch_options').removeClass('is-loading');
            }
          }
        });
      }
    }

    let $keepsakeBoxForm = $( selectors.container ).closest('form');
    let $keepsakeBoxTextarea = $( selectors.textarea );
    let $keepsakeTextLimit = $( selectors.textLimit );
    let $type = $( selectors.type );
    $keepsakeBoxForm.on('submit', function(e){
        if(!$(this).hasClass('validated')){
            e.preventDefault();

            if ($('.keepsake-notice').length) $('.keepsake-notice').remove();
            let val = $keepsakeBoxTextarea.val().replace(/[^a-zA-Z [\!@#\$%\^&\*\(\)_\-\+=\{\}\[\]\|;:,\.\?\\\]\d\r\n\\?\!\.\-]/g, '').clearEmojis();

            name = $keepsakeBoxTextarea.attr('name');

            $keepsakeBoxTextarea.filter('[name="' + name + '"]').val( val ).trigger('updateMirrorInput');

            if( val == '' ) {
                if($('.product-form-wrapper select.single-option-selector').val() == "With Personal Message Engraved") {
                    $keepsakeBoxTextarea.closest('.product-form-wrapper').find('.swatch_options .swatch__element[data-value="Without"] img').trigger('click');
                    $('.mobile-configurator__nav__link--add-to-cart[data-name="With Personal Message Engraved"]').hide();
                    $('.mobile-configurator__nav__link--add-to-cart[data-name="Without"]').show();
                }
            }

            let text = val || '';
            if (text){
                textPreview = [text];
                type = $type.val();
                if($('.product-form-wrapper select.single-option-selector').val() == "Without") {
                  $keepsakeBoxTextarea.closest('.product-form-wrapper').find('.swatch_options .swatch__element[data-value="With Personal Message Engraved"] img').trigger('click');
                  $('.mobile-configurator__nav__link--add-to-cart[data-name="With Personal Message Engraved"]').show();
                  $('.mobile-configurator__nav__link--add-to-cart[data-name="Without"]').hide();
                }
            }

            $(this).addClass('validated').submit();
        }
    });

    $('body').on( 'selectCallback', function( event, variant ) {
      if( !variant || !$(selectors.container).length) {
        return;
      }

      // Update keepsake text input name & timestamp
      let currentTimeStamp = Math.round((new Date()).getTime() / 1000);

      $(selectors.propertiesInput).attr('name', 'attributes[' + variant.sku + '_' + currentTimeStamp + '_Text]');
      $(selectors.timestampInput).val(currentTimeStamp);
    });

    $keepsakeBoxTextarea.on('keyup', function(e){
        $(selectors.navLinkConfirm).prop('disabled', false);
        $(selectors.addToCartBtn).prop('disabled', false);        

        // Disallow any emoji input & arrow keys
        var val = $(this).val();

        if(val.length > 250) {
          val = val.substring(0, 250);
        }

        // Disallow any emoji input & arrow keys
        $(this).val(val.clearEmojisKeepNumbers().replace(/[^\x00-\x7F]/g, ""));
        //$(this).val(this.value.clearEmojis());
        if ([37, 38, 39, 40].indexOf(e.keyCode) > -1 || e.keyCode == 32) {
          $(this).val(val.length == 1 ? '' : val);
          e.preventDefault();
          return;
        }

        let maxInputLength = 250;
        if($(this).val()!= "" ) {
            if($('.product-form-wrapper select.single-option-selector').val() == "Without") {
              $keepsakeBoxTextarea.closest('.product-form-wrapper').find('.swatch_options .swatch__element[data-value="With Personal Message Engraved"] img').trigger('click');
              $('.mobile-configurator__nav__link--add-to-cart[data-name="With Personal Message Engraved"]').show();
              $('.mobile-configurator__nav__link--add-to-cart[data-name="Without"]').hide();
            }

            let cleanIput = $(this).val().replace(/\r\n|\r|\n/g, '');

            if( cleanIput.length > maxInputLength ) {
              $(this).val($(this).val().substring(0, maxInputLength));
            }

            $keepsakeTextLimit.find('em').text(parseInt(maxInputLength - $(this).val().length + ($(this).val().match(/\r\n|\r|\n/g) || []).length));
            $(selectors.propertiesInput).val(cleanIput);

        } else {
            $(selectors.propertiesInput).val('');
            $('.char-limit em').text(maxInputLength);

            if($('.product-form-wrapper select.single-option-selector').val() == "With Personal Message Engraved") {              
              $keepsakeBoxTextarea.closest('.product-form-wrapper').find('.swatch_options .swatch__element[data-value="Without"] img').trigger('click');              
              $('.mobile-configurator__nav__link--add-to-cart[data-name="With Personal Message Engraved"]').hide();
              $('.mobile-configurator__nav__link--add-to-cart[data-name="Without"]').show();
            }
            return;
        }
    }).trigger('keyup');

    $type.on('change', function(e){
      let maxCharactersAllowed = $(this).val() == "round" ? defaults.maxCharactersRound : defaults.maxCharactersSquare;

      $keepsakeTextLimit.find('span').text(maxCharactersAllowed);
      $keepsakeBoxTextarea.filter(':visible').trigger('keyup');
    });
  },
  initCrossedPath: function() {

    var selectors = {
      container: '.crossed-paths',
      inputGroup: '.crossed-paths__input-group',
      input: '.crossed-paths__input',
      customBundleStepBack: '.product__custom__prev',
      navLinkConfirm: '.mobile-configurator__nav__link--confirm'
    };

    if( !$( selectors.container ).length || $('.crossed-paths-set').length ) {
      return;
    }

    var currentColor = '';
    var lastInitials = []; // left, right, up, down

    $('body').on( 'selectCallback', function( event, variant ) {
      if( !variant ) {
        return;
      }

      currentColor = variant.option2;

      if( lastInitials.length ){
        createCrossedPathPreview(
          lastInitials[0],
          lastInitials[1],
          lastInitials[2],
          lastInitials[3],
          currentColor
        );
      }
    });

    var customBundleStepBack = function() {
      var $customFormContainer = $('.product__custom');
      var $customCoordinates = $('.product__custom-coords');
      var $customCrossedPaths = $('.product__crossed-paths');
      var currentStep = parseInt($customFormContainer.attr('data-current-step'));

      // Lock form container height
      $customFormContainer.css('height', $customCrossedPaths.outerHeight());
      // Fade first step out and animate container height to height of second step
      $customCrossedPaths.fadeOut(400, function() {
        $customFormContainer.animate({
          'height': $customCoordinates.outerHeight()
        }, 400, function() {
          // Update current step
          $customFormContainer.attr('data-current-step', currentStep - 1);
          // Unlock first step
          $customCrossedPaths.removeClass('is-locked');
          // Fade in second step, lock it in place and reset container height
          $customCoordinates.fadeIn(400, function() {
            $customCoordinates.addClass('is-locked');
            $customFormContainer.css('height', '');
          });
        });
      });
    };

    var updatePreviewUrl = function (path) {
      let $slidesToUpdate = $('.flexslider .slides > li');
      let navThumb = $('.flex-control-nav > li');
      let itLoaded = false;
      let firstSlide;
      let secondSlide;
      let index;
      
      let $target = $slidesToUpdate.filter('[data-alt="Dynamic Custom Crossed Paths"]');

      if ($target.length) {
        firstSlide = $target.not('.clone')[0];
        secondSlide = $target.filter('.clone')[0];
        index = $slidesToUpdate.not('.clone').index(firstSlide);
      } else {
        firstSlide = $slidesToUpdate[1];
        secondSlide = $slidesToUpdate[$slidesToUpdate.length - 1];
        index = 0;
      }

      if (firstSlide){
        let $firstImage = $(firstSlide).find('img');
        $(firstSlide).data('thumb', path);
        $firstImage.attr('src', path);
        $firstImage.attr('data-src', path);
        $firstImage.attr('srcset', '');
        $firstImage.attr('data-srcset', '');
        var imageLoading = $firstImage;
        imageLoading.off('load').on('load', function(){
          itLoaded = true;
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        });
      }
      if (secondSlide){
        let $secondImage = $(secondSlide).find('img');
        $(secondSlide).data('thumb', path);
        $secondImage.attr('src', path);
        $secondImage.attr('data-src', path);
        $secondImage.attr('srcset', '');
        $secondImage.attr('data-srcset', '');
      }
      if (navThumb && navThumb.length > index)
        $(navThumb[index]).find('img').attr('src', path);
      var slider = $('.flexslider');
      if (slider) {
        slider.flexslider(index);
      }

      $('.mobile-configurator__panel__body .crossed-paths__input-bg').css('background-image', 'url(' + path + ')');

      setTimeout(function() {
        // fallback in case it's taking too slow to load the first image
        if (!itLoaded){
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        }
      }, 3000);
    };

    // Keys will be concatenated values of left, right, up, down, color
    var cache = {};

    var createCrossedPathPreview = function (left, right, up, down, color) {
      if (!color || color.indexOf('Gift Pack') > -1 || color.indexOf('Button') > -1 || color.indexOf('Tassel') > -1){
        color = 'Black';
      }
      $('.product_gallery').addClass('is-loading');
      $('.swatch_options').addClass('is-loading');

      // Don't wait for response to assign the preview url
      var path = encodeURI('https://w.sellry.com/crossed-path-preview/?'+
                'left='+left+'&'+
                'right='+right+'&'+
                'up='+up+'&'+
                'down='+down+'&'+
                'color='+color+'&'+
                'action=preview');
      $('.bracelet-preview-url').attr('value', path);

      if ( cache[left+right+up+down+color] ) {
        setTimeout(function(){
          updatePreviewUrl(cache[left+right+up+down+color]);
        }, 500);
      } else {
        $.ajax({
          url: 'https://w.sellry.com/crossed-path-preview/',
          dataType: 'json',
          cache: false,
          type: 'get',
          data: {left: left, right: right, up: up, down: down, color: color, action: 'preview'},
          error: function(xhr) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if(contentType !== 'image/jpeg') {
              $('.product_gallery').removeClass('is-loading');
              $('.swatch_options').removeClass('is-loading');
            }
          },
          complete: function(xhr) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if(contentType === 'image/jpeg') {
              cache[left+right+up+down+color] = path;
              setTimeout(function(){
                updatePreviewUrl(path);
              }, 500);
            } else {
              $('.product_gallery').removeClass('is-loading');
              $('.swatch_options').removeClass('is-loading');
            }
          }
        });
      }

      return {
        valid : true,
        message : 'Preview image has been generated'
      };
    }

    var $crossedPathsInput = $( selectors.input );
    $crossedPathsInput.on('keyup', function(event){
      lastInitials = [];
      var val = $(this).val();

      // Disallow any emoji input, arrow keys & blank space
      $(this).val(val.clearEmojis());
      if ([37, 38, 39, 40, 32].indexOf(event.keyCode) > -1 || event.keyCode == 32) {
        $(this).val(val.length == 1 ? '' : val);
        event.preventDefault();
        return;
      }

      var val = $(this).val().replace(/[^a-zA-Z]/g, '').toUpperCase(),
          name = $(this).attr('name');

      if (val){
        val = val.slice(-1);
      }

      $crossedPathsInput.filter('[name="' + name + '"]').val( val ).trigger('updateMirrorInput');

      if( val == '' ) {
        return;
      }

      var $nextInput = $(this).closest( selectors.inputGroup ).next().find( selectors.input );
      if( $nextInput.length ) {
        $nextInput.focus();
      }
      var crossedElements = $(this).closest('.crossed-paths__input-groups').find(selectors.input);
      if (crossedElements && crossedElements.length === 4) {
        var left = $(crossedElements[0]).val() || '',
            right = $(crossedElements[1]).val() || '',
            up = $(crossedElements[2]).val() || '',
            down = $(crossedElements[3]).val() || '';
        if (left && right && up && down){
          lastInitials = [left, right, up, down];
          previewImage = createCrossedPathPreview(left, right, up, down, currentColor);

          if( previewImage.valid === true) {
            $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', false);
            $('body').trigger('braceletcomplete');
          } else {
            if(previewImage.code == 'badformat'){
                $(selectors.errorContainer).html(previewImage.message).addClass('visible');
            }
            $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', true);
            $(selectors.container).find(selectors.addToCartBtn).prop('disabled', true);
          }
        } else {
          $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', true);
        }
      }

    }).trigger('keyup');

    $(selectors.customBundleStepBack).click(function(e) {
      e.preventDefault();
      customBundleStepBack();
    });
  },
  initWingedHeart: function () {

    var selectors = {
      container: '.winged-heart',
      inputGroup: '.winged-heart__input-group',
      input: '.winged-heart__input',
      customBundleStepBack: '.product__custom__prev',
      navLinkConfirm: '.mobile-configurator__nav__link--confirm'
    };

    if( !$( selectors.container ).length || $('.heart-set').length || $('.custom-infinity').length ) {
      return;
    }

    var currentColor = '';
    var lastInitials = []; // up, middle, down

    $('body').on( 'selectCallback', function( event, variant ) {
      if( !variant ) {
        return;
      }
      currentColor = variant.option1;

      if( lastInitials.length ){
        createWingedHeartPreview(
          lastInitials[0],
          lastInitials[1],
          lastInitials[2],
          currentColor
        );
      }
    });

    $('.product_form.product_form_options').each(function() {
        let product = $(this).data("product");
        let variantId = $('[name="id"]').val();
        if(typeof product.variants !== "undefined") {
            let default_variant = product.variants.filter(variant => {
                return variant.id == variantId
            }); 
            
            if(Array.isArray(default_variant) && default_variant.length) {
                $('body').trigger( 'selectCallback', default_variant);
            }
        }
    });

    var updatePreviewUrl = function (path) {
      let $slidesToUpdate = $('.flexslider .slides > li');
      let navThumb = $('.flex-control-nav > li');
      let itLoaded = false;
      let firstSlide;
      let secondSlide;
      let index;

      let $target = $slidesToUpdate.filter('[data-alt="Dynamic Custom Winged Heart"]');

      if ($target.length) {
        firstSlide = $target.not('.clone')[0];
        secondSlide = $target.filter('.clone')[0];
        index = $slidesToUpdate.not('.clone').index(firstSlide);
      } else {
        firstSlide = $slidesToUpdate[1];
        secondSlide = $slidesToUpdate[$slidesToUpdate.length - 1];
        index = 0;
      }

      if (firstSlide){
        let $firstImage = $(firstSlide).find('img');
        $(firstSlide).data('thumb', path);
        $firstImage.attr('src', path);
        $firstImage.attr('data-src', path);
        $firstImage.attr('srcset', '');
        $firstImage.attr('data-srcset', '');
        var imageLoading = $firstImage;
        imageLoading.off('load').on('load', function(){
          itLoaded = true;
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        });
      }
      if (secondSlide){
        let $secondImage = $(secondSlide).find('img');
        $(secondSlide).data('thumb', path);
        $secondImage.attr('src', path);
        $secondImage.attr('data-src', path);
        $secondImage.attr('srcset', '');
        $secondImage.attr('data-srcset', '');
      }
      if (navThumb && navThumb.length > index)
        $(navThumb[index]).find('img').attr('src', path);
      var slider = $('.flexslider');
      if (slider) {
        slider.flexslider(index);
      }

      $('.mobile-configurator__panel__body .winged-heart__input-bg').css('background-image', 'url(' + path + ')');

      setTimeout(function() {
        // fallback in case it's taking too slow to load the first image
        if (!itLoaded){
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        }
      }, 3000);
    };

    // Keys will be concatenated values of left, right, up, down, color
    var cache = {};

    var createWingedHeartPreview = function (up, middle, down, color) {
      if (!color || color.indexOf('Gift Pack') > -1 || color.indexOf('Button') > -1 || color.indexOf('Tassel') > -1){
        color = 'Black';
      }
      $('.product_gallery').addClass('is-loading');
      $('.swatch_options').addClass('is-loading');

      // Don't wait for response to assign the preview url
      var path = encodeURI('https://w.sellry.com/winged-heart-preview/?'+
                'up='+encodeURIComponent(up)+'&'+
                'middle='+encodeURIComponent(middle)+'&'+
                'down='+encodeURIComponent(down)+'&'+
                'color='+color+'&'+
                'action=preview');
      $('.bracelet-preview-url').attr('value', path);

      if ( cache[up+middle+down+color] ) {
        setTimeout(function(){
          updatePreviewUrl(cache[up+middle+down+color]);
        }, 500);
      } else {
        $.ajax({
          url: 'https://w.sellry.com/winged-heart-preview/',
          dataType: 'json',
          cache: false,
          type: 'get',
          data: {up: up, middle: middle, down: down, color: color, action: 'preview'},
          error: function(xhr) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if(contentType !== 'image/jpeg') {
              $('.product_gallery').removeClass('is-loading');
              $('.swatch_options').removeClass('is-loading');
            }
          },
          complete: function(xhr) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if(contentType === 'image/jpeg') {
              cache[up+middle+down+color] = path;
              setTimeout(function(){
                updatePreviewUrl(path);
              }, 500);
            } else {
              $('.product_gallery').removeClass('is-loading');
              $('.swatch_options').removeClass('is-loading');
            }
          }
        });
      }

      if(up.length > 0 && middle.length > 0 && down.length > 0) {
        return {
            valid : true,
            message : 'Preview image has been generated'
        };
      } else {
        return {
            valid : false,
            code : 'incomplete',
            message : 'Looks like there are some characters missing'
        };
      }
    }

    var $wingedHeartInput = $( selectors.input );
    $wingedHeartInput.on('keyup', function(event){
      lastInitials = [];
       var code = event.keyCode || event.which;

      if($(this).val().match(/[^a-zA-Z0-9&+]/g)){
        $('.winged-heart__input-error').html('Unfortunately this character is not available for this product').addClass('visible');
      }


      var val = $(this).val().replace(/[^a-zA-Z0-9&+]/g, '').toUpperCase(),
          name = $(this).attr('name');

      if (val){
        val = val.slice(-1);
        $('.winged-heart__input-error').html('').removeClass('visible');
      }

      $wingedHeartInput.filter('[name="' + name + '"]').val( val ).trigger('updateMirrorInput');

      if( val == '' && code != 8 ) {
        return;
      }

      var $nextInput = $(this).closest( selectors.inputGroup ).next().find( selectors.input );
      if( $nextInput.length && code != 8 ) {
        $nextInput.focus();
      }
      var wingedHeartElements = $(this).closest('.winged-heart__input-groups').find(selectors.input);
      if (wingedHeartElements && wingedHeartElements.length === 3) {
        var up = $(wingedHeartElements[0]).val() || '',
            middle = $(wingedHeartElements[1]).val() || '',
            down = $(wingedHeartElements[2]).val() || '';
        if (up || middle || down){
          lastInitials = [up, middle, down];

          if( (up && !middle && !down) || (!up && !middle && down) ) {
            middle = up ? up : down;
            up = down = '';
          } else if( (up && middle && !down) || (!up && middle && down) || (up && !middle && down) ) {
            up = up ? up : middle;
            middle = down ? down : middle;
            down = '';
          }

          previewImage = createWingedHeartPreview(up, middle, down, currentColor);

          // AddToCart disabled by default before preview confirms
          $(selectors.container).find(selectors.addToCartBtn).prop('disabled', true);
          $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', true);

          if(!previewImage.valid) {
            if(previewImage.code == 'incomplete'){
                $(selectors.container).find(selectors.addToCartBtn).prop('disabled', false);
                $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', false);
            }
            return;
          }

          $('body').trigger('braceletcomplete');

        } else {
          $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', true);
        }
      }

    }).trigger('keyup');

    var $wingedHeartForm = $( selectors.container ).closest('form');
    $wingedHeartForm.on('submit', function(e){
        if(!$(this).hasClass('validated')){
            e.preventDefault();

            var $winhedHeartEl = $($wingedHeartForm).find('.winged-heart__input.mirror-input');

            var up = $winhedHeartEl[0].value;
            var middle = $winhedHeartEl[1].value;
            var down = $winhedHeartEl[2].value;

            if( (up && !middle && !down) || (!up && !middle && down) ) {
              middle = up ? up : down;
              up = down = '';
            } else if( (up && middle && !down) || (!up && middle && down) || (up && !middle && down) ) {
              up = up ? up : middle;
              middle = down ? down : middle;
              down = '';
            }

            $winhedHeartEl[0].value = $winhedHeartEl[3].value = up;
            $winhedHeartEl[1].value = $winhedHeartEl[4].value = middle;
            $winhedHeartEl[2].value = $winhedHeartEl[5].value = down;

            var filledOptions = 0;
            $.each($winhedHeartEl, function(i, element){
              var wingedHeartInitials = $(element).val();
              if (wingedHeartInitials) {
                filledOptions += 1;
              };
            });

            isValid = filledOptions > 0 ? true : false;

            if(!isValid) {
                $('.winged-heart__input-error').html('Looks like you forgot to add your initials.').addClass('visible');
                return false;
            }

            $(this).addClass('validated').submit();
        }
    });

  },
  initCustomInfinity: function () {

    var selectors = {
      container: '.custom-infinity',
      inputGroup: '.winged-heart__input-group',
      input: '.winged-heart__input',
      customBundleStepBack: '.product__custom__prev',
      navLinkConfirm: '.mobile-configurator__nav__link--confirm'
    };

    if( !$( selectors.container ).length ) {
      return;
    }

    var currentColor = '';
    var lastInitials = []; // up, middle, down

    $('body').on( 'selectCallback', function( event, variant ) {
      if( !variant ) {
        return;
      }
      currentColor = variant.option1;

      if( lastInitials.length ){
        createWingedHeartPreview(
          lastInitials[0],
          lastInitials[1],
          lastInitials[2],
          currentColor
        );
      }
    });

    $('.product_form.product_form_options').each(function() {
        let product = $(this).data("product");
        let variantId = $('[name="id"]').val();
        if(typeof product.variants !== "undefined") {
            let default_variant = product.variants.filter(variant => {
                return variant.id == variantId
            }); 
            
            if(Array.isArray(default_variant) && default_variant.length) {
                $('body').trigger( 'selectCallback', default_variant);
            }
        }
    });

    var updatePreviewUrl = function (path) {
      let $slidesToUpdate = $('.flexslider .slides > li');
      let navThumb = $('.flex-control-nav > li');
      let itLoaded = false;
      let firstSlide;
      let secondSlide;
      let index;

      let $target = $slidesToUpdate.filter('[data-alt="Dynamic Custom Winged Heart"]');

      if ($target.length) {
        firstSlide = $target.not('.clone')[0];
        secondSlide = $target.filter('.clone')[0];
        index = $slidesToUpdate.not('.clone').index(firstSlide);
      } else {
        firstSlide = $slidesToUpdate[1];
        secondSlide = $slidesToUpdate[$slidesToUpdate.length - 1];
        index = 0;
      }

      if (firstSlide){
        let $firstImage = $(firstSlide).find('img');
        $(firstSlide).data('thumb', path);
        $firstImage.attr('src', path);
        $firstImage.attr('data-src', path);
        $firstImage.attr('srcset', '');
        $firstImage.attr('data-srcset', '');
        var imageLoading = $firstImage;
        imageLoading.off('load').on('load', function(){
          itLoaded = true;
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        });
      }
      if (secondSlide){
        let $secondImage = $(secondSlide).find('img');
        $(secondSlide).data('thumb', path);
        $secondImage.attr('src', path);
        $secondImage.attr('data-src', path);
        $secondImage.attr('srcset', '');
        $secondImage.attr('data-srcset', '');
      }
      if (navThumb && navThumb.length > index)
        $(navThumb[index]).find('img').attr('src', path);
      var slider = $('.flexslider');
      if (slider) {
        slider.flexslider(index);
      }

      $('.mobile-configurator__panel__body .winged-heart__input-bg').css('background-image', 'url(' + path + ')');

      setTimeout(function() {
        // fallback in case it's taking too slow to load the first image
        if (!itLoaded){
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        }
      }, 3000);
    };

    // Keys will be concatenated values of left, right, up, down, color
    var cache = {};

    var createWingedHeartPreview = function (up, middle, down, color) {
      if (!color || color.indexOf('Gift Pack') > -1 || color.indexOf('Button') > -1 || color.indexOf('Tassel') > -1){
        color = 'Black';
      }
      $('.product_gallery').addClass('is-loading');
      $('.swatch_options').addClass('is-loading');

      // Don't wait for response to assign the preview url
      var path = encodeURI('https://w.sellry.com/custom-infinity-preview/?'+
                'up='+encodeURIComponent(up)+'&'+
                'middle='+encodeURIComponent(middle)+'&'+
                'down='+encodeURIComponent(down)+'&'+
                'color='+color+'&'+
                'action=preview');
      $('.bracelet-preview-url').attr('value', path);

      if ( cache[up+middle+down+color] ) {
        setTimeout(function(){
          updatePreviewUrl(cache[up+middle+down+color]);
        }, 500);
      } else {
        $.ajax({
          url: 'https://w.sellry.com/custom-infinity-preview/',
          dataType: 'json',
          cache: false,
          type: 'get',
          data: {up: up, middle: middle, down: down, color: color, action: 'preview'},
          error: function(xhr) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if(contentType !== 'image/jpeg') {
              $('.product_gallery').removeClass('is-loading');
              $('.swatch_options').removeClass('is-loading');
            }
          },
          complete: function(xhr) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if(contentType === 'image/jpeg') {
              cache[up+middle+down+color] = path;
              setTimeout(function(){
                updatePreviewUrl(path);
              }, 500);
            } else {
              $('.product_gallery').removeClass('is-loading');
              $('.swatch_options').removeClass('is-loading');
            }
          }
        });
      }

      if(up.length > 0 && middle.length > 0 && down.length > 0) {
        return {
            valid : true,
            message : 'Preview image has been generated'
        };
      } else {
        return {
            valid : false,
            code : 'incomplete',
            message : 'Looks like there are some characters missing'
        };
      }
    }

    var $wingedHeartInput = $( selectors.input );
    $wingedHeartInput.on('keyup', function(event){
      lastInitials = [];
      
      var code = event.keyCode || event.which;

      var val = $(this).val().toUpperCase();

      // Disallow any emoji input & arrow keys
      var char = String.fromCharCode(event.which);
      if (char.match(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])|\s/) || [37, 38, 39, 40].indexOf(event.keyCode) > -1 || event.keyCode == 32) {
        $(this).val(val.length == 1 ? '' : val);
        event.preventDefault();
        return;
      }

      var rx = /[^A-Z0-9!@#%&*+()]+/gi;

      val = val.replace(rx, '');

      if (val){
        val = val.slice(-1);
        $('.winged-heart__input-error').html('').removeClass('visible');
      }

      
      $(this).val(val)

      $wingedHeartInput.filter('[name="' + name + '"]').val( val ).trigger('updateMirrorInput');

      if( val == '' || val.length === 0 ) {
        return;
      }


      var $nextInput = $(this).closest( selectors.inputGroup ).next().find( selectors.input );
      if( $nextInput.length && code != 8  && val.length > 0 ) {
        $nextInput.focus();
      }
      var wingedHeartElements = $(this).closest('.winged-heart__input-groups').find(selectors.input);
      if (wingedHeartElements && wingedHeartElements.length === 3) {
        var up = $(wingedHeartElements[0]).val() || '',
            middle = $(wingedHeartElements[1]).val() || '',
            down = $(wingedHeartElements[2]).val() || '';
        if (up || middle || down){
          lastInitials = [up, middle, down];

          if( (up && !middle && !down) || (!up && !middle && down) ) {
            middle = up ? up : down;
            up = down = '';
          } else if( (up && middle && !down) || (!up && middle && down) || (up && !middle && down) ) {
            up = up ? up : middle;
            middle = down ? down : middle;
            down = '';
          }

          previewImage = createWingedHeartPreview(up, middle, down, currentColor);

          // AddToCart disabled by default before preview confirms
          $(selectors.container).find(selectors.addToCartBtn).prop('disabled', true);
          $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', true);

          if(!previewImage.valid) {
            if(previewImage.code == 'incomplete'){
                $(selectors.container).find(selectors.addToCartBtn).prop('disabled', false);
                $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', false);
            }
            return;
          }

          $('body').trigger('braceletcomplete');

        } else {
          $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', true);
        }
      }

    }).trigger('keyup');

    var $wingedHeartForm = $( selectors.container ).closest('form');
    $wingedHeartForm.on('submit', function(e){
        if(!$(this).hasClass('validated')){
            e.preventDefault();

            var $winhedHeartEl = $($wingedHeartForm).find('.winged-heart__input.mirror-input');

            var up = $winhedHeartEl[0].value;
            var middle = $winhedHeartEl[1].value;
            var down = $winhedHeartEl[2].value;

            if( (up && !middle && !down) || (!up && !middle && down) ) {
              middle = up ? up : down;
              up = down = '';
            } else if( (up && middle && !down) || (!up && middle && down) || (up && !middle && down) ) {
              up = up ? up : middle;
              middle = down ? down : middle;
              down = '';
            }

            $winhedHeartEl[0].value = $winhedHeartEl[3].value = up;
            $winhedHeartEl[1].value = $winhedHeartEl[4].value = middle;
            $winhedHeartEl[2].value = $winhedHeartEl[5].value = down;

            var filledOptions = 0;
            $.each($winhedHeartEl, function(i, element){
              var wingedHeartInitials = $(element).val();
              if (wingedHeartInitials) {
                filledOptions += 1;
              };
            });

            isValid = filledOptions > 0 ? true : false;

            if(!isValid) {
                $('.winged-heart__input-error').html('Looks like you forgot to add your initials.').addClass('visible');
                return false;
            }

            $(this).addClass('validated').submit();
        }
    });

  },
  initCustomDate: function() {
    var selectors = {
      container: '.custom-date',
      errorContainer: '.custom-date__input-error',
      inputGroup: '.custom-date__input-group',
      input: '.custom-date__input',
      navLinkConfirm: '.mobile-configurator__nav__link--confirm',
      addToCartBtn: '.add_to_cart'
    };

    if( !$( selectors.container ).length || $('.custom-date-set').length ) {
      return;
    }

    var currentColor = '';
    var lastColor = '';
    var lastCustomDate = [];

    var refreshDatePreview = function() {
      if (lastCustomDate.length) {
        lastColor = currentColor;
        createCustomDatePreview(
          lastCustomDate[0],
          lastCustomDate[1],
          lastCustomDate[2],
          currentColor
        );
      }
    };

    $('body').on( 'selectCallback', function( event, variant ) {
      if( !variant ) {
        return;
      }

      if (!lastColor) {
        lastColor = variant.option2;
      }
      currentColor = variant.option2;
      refreshDatePreview();
    });

    var updatePreviewUrl = function (path) {
      let $slidesToUpdate = $('.flexslider .slides > li');
      let navThumb = $('.flex-control-nav > li');
      let itLoaded = false;
      let firstSlide;
      let secondSlide;
      let index;

      firstSlide = $slidesToUpdate[1];
      secondSlide = $slidesToUpdate[$slidesToUpdate.length - 1];
      index = 0;

      if (firstSlide){
        let $firstImage = $(firstSlide).find('img');
        $(firstSlide).data('thumb', path);
        $firstImage.attr('src', path);
        $firstImage.attr('data-src', path);
        $firstImage.attr('srcset', '');
        $firstImage.attr('data-srcset', '');
        var imageLoading = $firstImage;
        imageLoading.off('load').on('load', function(){
          itLoaded = true;
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        });
      }
      if (secondSlide){
        let $secondImage = $(secondSlide).find('img');
        $(secondSlide).data('thumb', path);
        $secondImage.attr('src', path);
        $secondImage.attr('data-src', path);
        $secondImage.attr('srcset', '');
        $secondImage.attr('data-srcset', '');
      }
      if (navThumb && navThumb.length > index)
        $(navThumb[index]).find('img').attr('src', path);
      var slider = $('.flexslider');
      if (slider) {
        slider.flexslider(index);
      }

      $('.mobile-configurator__panel__body .custom-date__input-bg').css('background-image', 'url(' + path + ')');

      setTimeout(function() {
        // fallback in case it's taking too slow to load the first image
        if (!itLoaded){
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        }
      }, 3000);

    };

    var cache = {};

    var braceletBaseUrl = 'https://w.sellry.com/date-bracelet-preview';

    var createCustomDatePreview = function (left, right, bottom, color) {
      if (!color) {
        color = 'Black';
      }
      $('.product_gallery').addClass('is-loading');
      $('.swatch_options').addClass('is-loading');

      var cacheKey = left + right + bottom + color;

      // Don't wait for response to assign the preview url
      var path = encodeURI(braceletBaseUrl + '/?' +
                'left='+left+'&'+
                'right='+right+'&'+
                'bottom='+bottom+'&'+
                'color='+color+'&'+
                'action=preview');

      $('.bracelet-preview-url').attr('value', path);

      if ( cache[cacheKey] ) {
        setTimeout(function(){
          updatePreviewUrl(cache[left+right+bottom+color]);
        }, 500);
      } else {
        $.ajax({
          url: braceletBaseUrl + '/',
          dataType: 'json',
          cache: false,
          type: 'get',
          data: {left: left, right: right, bottom: bottom, color: color, action: 'preview'},
          error: function(xhr) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if(contentType !== 'image/jpeg') {
              $('.product_gallery').removeClass('is-loading');
              $('.swatch_options').removeClass('is-loading');
            }
          },
          complete: function(xhr) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if(contentType === 'image/jpeg') {
              cache[cacheKey] = path;
              setTimeout(function(){
                updatePreviewUrl(path);
              }, 500);
            } else {
              $('.product_gallery').removeClass('is-loading');
              $('.swatch_options').removeClass('is-loading');
            }
          }
        });
      }
    };

    var $customDateInput = $( selectors.input );

    var handleReloadImage = function(input) {
      var customDateElements = input.closest('.custom-date__input-groups').find(selectors.input);
      if (customDateElements && customDateElements.length === 3) {
        var left = $(customDateElements[0]).val() || '',
            right = $(customDateElements[1]).val() || '',
            bottom = $(customDateElements[2]).val() || '';

        if(left.length === 2 && right.length === 2 && bottom.length === 4) {
          lastCustomDate = [left, right, bottom];
          createCustomDatePreview(left, right, bottom, currentColor);
          return {
              valid : true,
              message : 'Preview image has been generated'
          };
        } else {
          lastCustomDate = [left, right, bottom];
          createCustomDatePreview(left, right, bottom, currentColor);
          return {
              valid : false,
              code : 'incomplete',
              message : 'Looks like you are entering less characters'
          };
        }
      }

      return {
        valid : false,
        code : 'general',
        message : 'Something went wrong while generating the preview image'
      };
    };

    $customDateInput.on('keydown', function(event) {
      // Prevent shift key since its not needed
      if (event.shiftKey == true) {
        event.preventDefault();
      }
      // Allow Only: keyboard 0-9, numpad 0-9, backspace, tab, left arrow, right arrow, delete
      if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 37 || event.keyCode == 39 || event.keyCode == 46) {
      // Allow normal operation
      } else {
        // Prevent the rest
        event.preventDefault();
      }
    });

    $customDateInput.on('keyup', function(){

      lastCustomDate = [];

      var val = $(this).val();
      var name = $(this).attr('name');

      var parsedNum = parseInt(val, 10);

      if (isNaN(parseInt(val, 10)) === true || parsedNum < 0) {
        val = '';
      }

      $customDateInput.filter('[name="' + name + '"]').val( val ).trigger('updateMirrorInput');

      if (val == '' || /^\d+$/.test(val) === false) {
        $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', true);
        return;
      }

      $(selectors.errorContainer).html('').removeClass('visible');

      var $nextInput = $(this).closest( selectors.inputGroup ).next().find( selectors.input );
      var maxLength = parseInt($(this).attr('maxLength'), 10);

      if( maxLength === val.length && $nextInput.length ) {
        $nextInput.focus();
      }

      if(val.length > maxLength) {
        $(this).val( $(this).val().substr(0, maxLength) );
        return;
      }

      previewImage = handleReloadImage($(this));

      if(!previewImage.valid) {
        if(previewImage.code == 'incomplete'){
            $(selectors.addToCartBtn).prop('disabled', false);
            $(selectors.navLinkConfirm).prop('disabled', false);
        }
        return;
      }

      $('body').trigger('braceletcomplete');
    }).trigger('keyup');
  },
  initCustomCross: function() {
    var selectors = {
      container: '.custom-cross',
      inputGroup: '.custom-word__input-group',
      inputColor: '.custom-word__color',
      input: '.custom-word__input',
      navLinkConfirm: '.mobile-configurator__nav__link--confirm',
      addToCartBtn: '.mobile-configurator__nav__link--add-multibracelet'
    };

    if (!$( selectors.container ).length) {
      return;
    }

    $(selectors.navLinkConfirm).prop('disabled', true);

    var currentColor = '';
    var lastColor = '';
    var lastCustomWord = '';

    var refreshWordPreview = function() {
      if (lastCustomWord.length) {
        lastColor = currentColor;
        createCustomWordPreview(
          lastCustomWord,
          currentColor
        );
      }
    };

    $('body').on('selectCallback', function(event, variant) {
      if (!variant) {
        return;
      }

      if (!lastColor) {
        lastColor = variant.option1;
      }

      currentColor = variant.option1;
      refreshWordPreview();
    });

    var updatePreviewUrl = function (path) {
      let $slidesToUpdate = $('.flexslider .slides > li');
      let navThumb = $('.flex-control-nav > li');
      let itLoaded = false;
      let firstSlide;
      let secondSlide;
      let index;

      let $target = $slidesToUpdate.filter('[data-alt="Dynamic Custom Word"]');

      if ($target.length) {
        firstSlide = $target.not('.clone')[0];
        secondSlide = $target.filter('.clone')[0];
        index = $slidesToUpdate.not('.clone').index(firstSlide);
      } else {
        firstSlide = $slidesToUpdate[1];
        secondSlide = $slidesToUpdate[$slidesToUpdate.length - 1];
        index = 0;
      }

      if (firstSlide) {
        let $firstImage = $(firstSlide).find('img');
        $(firstSlide).data('thumb', path);
        $firstImage.attr('src', path);
        $firstImage.attr('data-src', path);
        $firstImage.attr('srcset', '');
        $firstImage.attr('data-srcset', '');
        var imageLoading = $firstImage;
        imageLoading.off('load').on('load', function(){
          itLoaded = true;
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        });
      }

      if (secondSlide) {
        let $secondImage = $(secondSlide).find('img');
        $(secondSlide).data('thumb', path);
        $secondImage.attr('src', path);
        $secondImage.attr('data-src', path);
        $secondImage.attr('srcset', '');
        $secondImage.attr('data-srcset', '');
      }

      if (navThumb && navThumb.length > index) {
        $(navThumb[index]).find('img').attr('src', path);
      }

      var slider = $('.flexslider');
      if (slider) {
        slider.flexslider(index);
      }

      $('.mobile-configurator__panel__body .custom-word__input-bg').css('background-image', 'url(' + path + ')');

      setTimeout(function() {
        // fallback in case it's taking too slow to load the first image
        if (!itLoaded) {
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        }
      }, 3000);
    };

    var cache = {};

    var braceletBaseUrl = 'https://w.sellry.com/custom-cross-preview';

    var createCustomWordPreview = function (word, color) {
      if (!color) {
        if( $(selectors.inputColor).length > 0 ) {
            color = $(selectors.inputColor).val();
        } else {
            color = 'Black';
        }
      }

      $('.product_gallery').addClass('is-loading');
      $('.swatch_options').addClass('is-loading');

      var cacheKey = word + color;

      // Don't wait for response to assign the preview url
      var path = braceletBaseUrl + '/?' +
                'word='+ encodeURIComponent(word) +'&'+
                'color='+ encodeURIComponent(color) +'&'+
                'action=preview';

      $('.bracelet-preview-url').attr('value', path);

      if ( cache[cacheKey] ) {
        setTimeout(function() {
          updatePreviewUrl(cache[word+color]);
        }, 500);
      } else {
        $.ajax({
          url: braceletBaseUrl + '/',
          dataType: 'json',
          cache: false,
          type: 'get',
          data: {word: word, color: color, action: 'preview'},
          error: function(xhr) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if (contentType !== 'image/jpeg') {
              $('.product_gallery').removeClass('is-loading');
              $('.swatch_options').removeClass('is-loading');
            }
          },
          complete: function(xhr) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if (contentType === 'image/jpeg') {
              cache[cacheKey] = path;
              setTimeout(function() {
                updatePreviewUrl(path);
              }, 500);
            } else {
              $('.product_gallery').removeClass('is-loading');
              $('.swatch_options').removeClass('is-loading');
            }
          }
        });
      }
    };

    var $customWordInput = $(selectors.input);

    var handleReloadImage = function(input) {
      var customWordElement = input.closest('.custom-word__input-group').find(selectors.input);
      if (customWordElement) {
        var word = $(customWordElement).val() || '';
        if (word.length > 0){
            lastCustomWord = word;
            createCustomWordPreview(word, currentColor);
          
            if(word.length < 11) {
                return {
                    valid : false,
                    code : 'incomplete',
                    message : 'Looks like you have not reached input limit yet'
                };              
            } else {
                return {
                    valid : true,
                    message : 'Preview image has been generated'
                };
            }
        }
      }

      return {
        valid : false,
        code : 'general',
        message : 'Something went wrong while generating the preview image'
      };
    };

    $customWordInput.not('.readonly').on('keydown', function(event) {
        if (event.which === 32 && event.target.selectionStart === 0) {
            return false;
        }
    });

    $customWordInput.not('.readonly').on('keyup', function(event) {
      lastCustomWord = '';
      var val = $(this).val().toUpperCase();

      // Disallow any emoji input & arrow keys
      var char = String.fromCharCode(event.which);
      if (char.match(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])|\s/) || [37, 38, 39, 40].indexOf(event.keyCode) > -1 || event.keyCode == 32) {
        $(this).val(val.length == 1 ? '' : val);
        event.preventDefault();
        return;
      }

      var val = $(this).val().toUpperCase();
      var name = $(this).attr('name');
      var rx = /[^A-Z0-9@!*&#%+.:;,\-()\s]+/gi;

      val = val.replace(rx, '');

      $customWordInput.filter('[name="' + name + '"]').val( val ).trigger('updateMirrorInput');

      previewImage = handleReloadImage($(this));

      // AddToCart disabled by default before preview confirms
      $(selectors.addToCartBtn).prop('disabled', true);
      $(selectors.navLinkConfirm).prop('disabled', true);

      if(!previewImage.valid) {
        if(previewImage.code == 'incomplete'){
            $(selectors.addToCartBtn).prop('disabled', false);
            $(selectors.navLinkConfirm).prop('disabled', false);
        }
        return;
      }

      $('body').trigger('braceletcomplete');

    }).trigger('keyup');
  },
  initCustomWord: function() {
    var selectors = {
      container: '.custom-word',
      inputGroup: '.custom-word__input-group',
      inputColor: '.custom-word__color',
      input: '.custom-word__input',
      navLinkConfirm: '.mobile-configurator__nav__link--confirm'
    };

    if (!$( selectors.container ).length && !$('.name-set').length) {
      return;
    }

    if ($('.custom-cross').length) {
      return;
    }

    var currentColor = '';
    var lastColor = '';
    var lastCustomWord = '';

    var refreshWordPreview = function() {
      if (lastCustomWord.length) {
        lastColor = currentColor;
        createCustomWordPreview(
          lastCustomWord,
          currentColor
        );
      }
    };

    $('body').on('selectCallback', function(event, variant) {
      if (!variant) {
        return;
      }

      if (!lastColor) {
        lastColor = variant.option1;
      }

      currentColor = variant.option1;
      refreshWordPreview();
    });

    var updatePreviewUrl = function (path) {
      let $slidesToUpdate = $('.flexslider .slides > li');
      let navThumb = $('.flex-control-nav > li');
      let itLoaded = false;
      let firstSlide;
      let secondSlide;
      let index;

      let $target = $slidesToUpdate.filter('[data-alt="Dynamic Custom Word"]');

      if ($target.length) {
        firstSlide = $target.not('.clone')[0];
        secondSlide = $target.filter('.clone')[0];
        index = $slidesToUpdate.not('.clone').index(firstSlide);
      } else {
        firstSlide = $slidesToUpdate[1];
        secondSlide = $slidesToUpdate[$slidesToUpdate.length - 1];
        index = 0;
      }

      if (firstSlide) {
        let $firstImage = $(firstSlide).find('img');
        $(firstSlide).data('thumb', path);
        $firstImage.attr('src', path);
        $firstImage.attr('data-src', path);
        $firstImage.attr('srcset', '');
        $firstImage.attr('data-srcset', '');
        var imageLoading = $firstImage;
        imageLoading.off('load').on('load', function(){
          itLoaded = true;
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        });
      }

      if (secondSlide) {
        let $secondImage = $(secondSlide).find('img');
        $(secondSlide).data('thumb', path);
        $secondImage.attr('src', path);
        $secondImage.attr('data-src', path);
        $secondImage.attr('srcset', '');
        $secondImage.attr('data-srcset', '');
      }

      if (navThumb && navThumb.length > index) {
        $(navThumb[index]).find('img').attr('src', path);
      }

      var slider = $('.flexslider');
      if (slider) {
        slider.flexslider(index);
      }

      $('.mobile-configurator__panel__body .custom-word__input-bg').css('background-image', 'url(' + path + ')');

      setTimeout(function() {
        // fallback in case it's taking too slow to load the first image
        if (!itLoaded) {
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        }
      }, 3000);
    };

    var cache = {};

    var braceletBaseUrl = 'https://w.sellry.com/word-bracelet-preview';

    var createCustomWordPreview = function (word, color) {
      if (!color) {
        if( $(selectors.inputColor).length > 0 ) {
            color = $(selectors.inputColor).val();
        } else {
            color = 'Black';
        }
      }

      $('.product_gallery').addClass('is-loading');
      $('.swatch_options').addClass('is-loading');

      var cacheKey = word + color;

      // Don't wait for response to assign the preview url
      var path = braceletBaseUrl + '/?' +
                'word='+ encodeURIComponent(word) +'&'+
                'color='+ encodeURIComponent(color) +'&'+
                'action=preview';

      $('.bracelet-preview-url').attr('value', path);

      if ( cache[cacheKey] ) {
        setTimeout(function() {
          updatePreviewUrl(cache[word+color]);
        }, 500);
      } else {
        $.ajax({
          url: braceletBaseUrl + '/',
          dataType: 'json',
          cache: false,
          type: 'get',
          data: {word: word, color: color, action: 'preview'},
          error: function(xhr) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if (contentType !== 'image/jpeg') {
              $('.product_gallery').removeClass('is-loading');
              $('.swatch_options').removeClass('is-loading');
            }
          },
          complete: function(xhr) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if (contentType === 'image/jpeg') {
              cache[cacheKey] = path;
              setTimeout(function() {
                updatePreviewUrl(path);
              }, 500);
            } else {
              $('.product_gallery').removeClass('is-loading');
              $('.swatch_options').removeClass('is-loading');
            }
          }
        });
      }
    };

    var $customWordInput = $(selectors.input);

    var handleReloadImage = function(input) {
      var customWordElement = input.closest('.custom-word__input-group').find(selectors.input);
      if (customWordElement) {
        var word = $(customWordElement).val() || '';
        if (word.length > 0){
            lastCustomWord = word;
            createCustomWordPreview(word, currentColor);
          
            if(word.length < 11) {
                return {
                    valid : false,
                    code : 'incomplete',
                    message : 'Looks like you have not reached input limit yet'
                };              
            } else {
                return {
                    valid : true,
                    message : 'Preview image has been generated'
                };
            }
        }
      }

      return {
        valid : false,
        code : 'general',
        message : 'Something went wrong while generating the preview image'
      };
    };

    $customWordInput.not('.readonly').on('keydown', function(event) {
        if (event.which === 32 && event.target.selectionStart === 0) {
            return false;
        }
    });

    $customWordInput.not('.readonly').on('keyup', function(event) {
      lastCustomWord = '';
      var val = $(this).val();

      // Disallow any emoji input & arrow keys
      var char = String.fromCharCode(event.which);
      if (char.match(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])|\s/) || [37, 38, 39, 40].indexOf(event.keyCode) > -1 || event.keyCode == 32) {
        $(this).val(val.length == 1 ? '' : val);
        event.preventDefault();
        return;
      }

      var val = $(this).val().trim();
      var name = $(this).attr('name');
      var rx = /[^a-zA-Z0-9!@#$%^&*\-_=+()[\]{}<>?"':;.,/~ ]+/gi;

      val = val.replace(rx, '');

      $customWordInput.filter('[name="' + name + '"]').val( val ).trigger('updateMirrorInput');

      previewImage = handleReloadImage($(this));

      // AddToCart disabled by default before preview confirms
      $(selectors.addToCartBtn).prop('disabled', true);
      $(selectors.navLinkConfirm).prop('disabled', true);

      if(!previewImage.valid) {
        if(previewImage.code == 'incomplete'){
            $(selectors.addToCartBtn).prop('disabled', false);
            $(selectors.navLinkConfirm).prop('disabled', false);
        }
        return;
      }

      $('body').trigger('braceletcomplete');

    }).trigger('keyup');
  },
  initCustomAnchor: function() {
    var selectors = {
      container: '.custom-anchor',
      inputGroup: '.custom-anchor__input-group',
      inputColor: '.custom-anchor__color',
      input: '.custom-anchor__input',
      navLinkConfirm: '.mobile-configurator__nav__link--confirm'
    };

    if (!$( selectors.container ).length) {
      return;
    }

    var $customAnchorForm = $(selectors.container).closest('form');
    var $customAnchorInput = $(selectors.input);

    $customAnchorInput.on('keydown', function(event) {
        if (event.which === 32 && event.target.selectionStart === 0) {
            return false;
        }
    });


    $customAnchorForm.on('submit', function(e){
        var self = $(this);
        if(!self.hasClass('validated')){
          e.preventDefault();

          var val = $customAnchorInput.val().clearEmojis();
          var name = $customAnchorInput.attr('name');

          $customAnchorInput.filter('[name="' + name + '"]').val( val ).trigger('updateMirrorInput');

          if( val == '' || val == 'blank' ) {
            $.fancyConfirm({
              title     : "Are you sure you don&#39;t want to add customization?",
              message   : "",
              okButton  : "Yes",
              noButton  : "No",
              callback  : function (value) {                
                  if (value) {
                    self.addClass('validated').submit();                    
                  } else {
                    $customAnchorInput.focus();
                  }
                }
              });
          } else {
            self.addClass('validated').submit();
          }            
        }
    });

    $customAnchorInput.on('keyup', function(event) {
      var val = $(this).val();

      // Disallow any emoji input & arrow keys
      $(this).val(val.clearEmojis());
      if ([37, 38, 39, 40].indexOf(event.keyCode) > -1 || event.keyCode == 32) {
        $(this).val(val.length == 1 ? '' : val);
        event.preventDefault();
        return;
      }

      var val = $(this).val().trim();
      var name = $(this).attr('name');
      var rx = /[^a-zA-Z0-9!@#$%^&*\-_=+()[\]{}<>?"':;.,/~ ]+/gi;

      val = val.replace(rx, '');

      $customAnchorInput.filter('[name="' + name + '"]').val( val ).trigger('updateMirrorInput');

      // AddToCart disabled by default before preview confirms
      $(selectors.addToCartBtn).prop('disabled', true);
      $(selectors.navLinkConfirm).prop('disabled', true);

      // 5 characters max
      if(val.length == 5) {
        $('body').trigger('braceletcomplete');
      }

    }).trigger('keyup');
  },
  initGiftSets: function() {
    var selectors = {
        product: '.product__gift-set',
        productWrap: '.product-is-custom-gift-set',
        productSteps : '.gift-set__steps',
        productStep : '.gift-set__step',
        productError : '.gift-set__error',
        stepActionBtn : '.gift-set__step-next',
        stepBackBtn: '.gift-set__step-back',
        stepCounter: '.gift-set__step-counter',
        addToCartBtn: '.add_to_cart',
        textareaContainer: '.keepsake-box__textarea-container',
        textarea: '.keepsake-box__textarea',
        keepsakeInput: '.keepsake-box__input',
        keepsakeType: '.keepsake-box__type',
        requiredFields: 'input[required]',
        type: 'input.type'        
    };

    var personalizationProducts = [
      {
        type: 'custom-date',
        requiredfields: 3
      },
      {
        type: 'crossed-paths',
        requiredfields: 4
      },
      {
        type: 'custom-coordinates',
        requiredfields: 3
      },
      {
        type: 'custom-word',
        requiredfields: 1
      },
      {
        type: 'winged-heart',
        requiredfields: 1
      },
      {
        type: 'custom-infinity',
        requiredfields: 1
      },
      {
        type: 'custom-cross',
        requiredfields: 1 
      }
    ];

    // variables
    currentStep = 0;

    if(!$('.product__gift-set').length) {
      return;
    }

    // Step control listener
    $('body').on('stepchange', function(event, step){
        $(selectors.productStep).removeClass('active').hide();
        $(selectors.productStep).eq(step).addClass('active').show();

        activeStep = $(selectors.productStep).filter('.active');
        isFirstStep = activeStep.is(':first-child');
        isLastStep = activeStep.is(':last-child');

        if(!isFirstStep) {
          $(selectors.stepBackBtn).show();
        } else {
          $(selectors.stepBackBtn).hide();
        }

        if(isLastStep) {
          $(selectors.stepActionBtn).hide();
        } else {
          $(selectors.stepActionBtn).show();
        }

        currentStep = step;
        $(selectors.stepCounter).html(++step);
    });

    // Enable first step on load
    $('body').trigger('stepchange', [currentStep]);
    $('.purchase-details').hide();
    $('.next_step_button').show();

    // Disable addToCart buttons
    $(selectors.product).find(selectors.addToCartBtn).prop('disabled', true);

    $(selectors.product).on('click', selectors.stepActionBtn, function(event){
        event.preventDefault();   
        var customized = true;

        if( currentStep == ($(selectors.productStep).length - 1) ) {
            return false;
        }

        // Check if current step has been skipped
        let productTypes = $(selectors.product).attr('data-product-types').split('|'),
          validationRules = personalizationProducts.filter(x => productTypes.includes(x.type)),
          filledCount = 0;

        $.each(validationRules, function(i, validationRule) {
          let mandatoryFields = $(selectors.productStep).filter('.active').find('input');
          $.each(mandatoryFields, function(i, field) {
            if (field.value != '')
              filledCount += 1;
          });

          if(filledCount < validationRule.requiredfields) {
            $(selectors.product).removeClass('bracelet-complete').addClass('bracelet-incomplete');
            $(selectors.addToCartBtn).prop('disabled', true);
            customized = false;
              $(selectors.productStep).filter('.active').find('input').each(function(){
                if($(this).val() == '') {
                  $(this).addClass('required');
                } else {
                  $(this).removeClass('required');
                } 
              })

              $('.bracelet-incomplete input.required').eq(0).focus();
              $('.purchase-details').hide();
              $('.next_step_button').show();
              
          } else {
            $('.bracelet-incomplete input.required').removeClass('required');
            $(selectors.product).removeClass('bracelet-incomplete').addClass('bracelet-complete');
            $('.purchase-details').show();
            $('.next_step_button').hide();
          }
        });

        if(customized) {
          $('.purchase-details').show();
          $('.next_step_button').hide();
          currentStep += 1;
          $('body').trigger('stepchange', [currentStep]);  
        }
         
    });

    $('.product-custom-gift-set').on('click', '.next_step_button', function(event){
      $('.gift-set__step-next').click();
    })

    $(selectors.product).on('click', selectors.stepBackBtn, function(event){
        event.preventDefault();
        $(selectors.stepActionBtn).show();
        if(currentStep < 0) {
            return false;
        }

        currentStep -= 1;
        $('body').trigger('stepchange', [currentStep]);       
    });

    $('body').on('braceletcomplete', function(event){        
        activeStep = $(selectors.productStep).filter('.active');
        isLastStep = activeStep.is(':last-child');

        if(isLastStep) {
            $(selectors.addToCartBtn).prop('disabled', false);
        } else {
            $(selectors.stepActionBtn).trigger('click');
        }   
    });

    $(selectors.productWrap).on('click', selectors.addToCartBtn, function(event){
        event.preventDefault();

        let engravedText = $(selectors.textarea).val();

        if($(selectors.product).hasClass('bracelet-incomplete')) {
          $('body').trigger('stepchange', 0);
          $(selectors.product).removeClass('bracelet-incomplete');
          return;
        }

        if(engravedText.length == 0) {
          $(selectors.product).addClass('bracelet-complete');
          $('body').trigger('stepchange', 1);
          return;
        }
        
        // Submit only if textarea is not empty & bracelet is customized
        if(engravedText.length > 0 && $(selectors.product).hasClass('bracelet-complete')) {
          $(selectors.product).closest('form').submit();
        }
    });

    $('body').on( 'selectCallback', function( event, variant ) {

      if( !variant || !$(selectors.product).length || typeof $(selectors.product).attr('data-product-types') == undefined ) {
        return;
      }

      // Mirror keepsake type selection
      $(selectors.keepsakeType).val(variant.option3);
      $(selectors.type).val(variant.option3.toLowerCase()).trigger('change');

      // Applying steps validation
      let productTypes = $(selectors.product).attr('data-product-types').split('|'),
          validationRules = personalizationProducts.filter(x => productTypes.includes(x.type)),
          filledCount = 0;

      $.each(validationRules, function(i, validationRule) {
        let mandatoryFields = $(selectors.product).find(selectors.requiredFields);
        
        $.each(mandatoryFields, function(i, field) {
          if (field.value != '')
            filledCount += 1;
        });

        if(filledCount < validationRule.requiredfields) {
          $(selectors.addToCartBtn).prop('disabled', true);
          $('.purchase-details').hide();
        } else {
          $('.purchase-details').show();
        }
      });
    });
  },
  initCustomCoords: function() {

    var selectors = {
      productCustomCoords: '.product__custom-coords',
      container: '.custom-coords',
      inputGroup: '.custom-coords__input-group',
      input: '.custom-coords__input',
      inputLocation: '[name="location"]',
      inputLocationLookup: '.custom-coords__location-lookup',
      inputLat: '[name="properties[Latitude]"]',
      inputLng: '[name="properties[Longitude]"]',
      map: '.custom-coords__map',
      mapLockCheckbox: '.custom-coords__map-lock__checkbox',
      btnGetCurrentPosition: '.custom-coords__get-current-position',
      stepContinue: '.custom-coords__step__continue',
      stepBack: '.custom-coords__step__back',
      customBundleStepForward: '.product__custom__next',
      mobileMapContainer: '.mobile-configurator .custom-coords__input-row--map',
      mobileConfirmCoordinates: '.mobile-configurator__nav__link--confirm.custom-coords__confirm',
      navLinkConfirm: '.mobile-configurator__nav__link--confirm',
      addToCartBtn: '.add_to_cart'
    };

    if( !$( selectors.container ).length || $('.set-custom-coords').length ) {
      return;
    }

    // variables
    var geocoder,
        maps = [],
        markers = [],
        mapUnlocked = false,
        geocoder;

    // functions
    var initialize, getCurrentPosition, showPosition, placeMarkerAndGeoCode, codeAddress, codeLatLng, placeMarker, sanitizeInput;

    var initialized = false;
    var delayMap = (window.location.search.indexOf('delaymap') !== -1);

    initialize = function() {
      geocoder = new google.maps.Geocoder();

      var latLng = new google.maps.LatLng(-8.4095, 115.1889),
      mapOptions = {
        zoom: 8,
        center: latLng
      };

      $( selectors.map ).each(function(){

        var mapId = $(this).attr('id');

        if( mapId == undefined ) {
          return;
        }

        var map = new google.maps.Map(document.getElementById(mapId), mapOptions),
            marker = new google.maps.Marker({
              map: map,
              position: latLng
            });

        google.maps.event.addListener(map, 'click', function(event) {
          if( $(window).width() >= 768 && mapIsUnlocked() ) {
            placeMarker(event.latLng);
          }
        });

        google.maps.event.addListener(map,'center_changed', function() {
          if ( $(window).width() < 768 && (mapIsUnlocked() || delayMap) ) {
            var latLng = new google.maps.LatLng( map.getCenter().lat(), map.getCenter().lng() );
            placeMarkerAndGeoCode(latLng);
          }
        });

        maps.push(map);
        markers.push(marker);

      });

      if (delayMap) {
        $(selectors.mobileMapContainer).hide();
      }
    };

    getCurrentPosition = function() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
      } else {
        alert("Geolocation is not supported by this browser.");
      }
    };

    showPosition = function(position) {
      var lat = position.coords.latitude,
          lng = position.coords.longitude,
          latLng = new google.maps.LatLng(lat, lng);

      for( var i=0 ; i<maps.length ; i++ ) {
        var map = maps[i];
        map.setCenter(latLng);
      }

      placeMarkerAndGeoCode(latLng);

      if (delayMap && !initialized) {
        $(selectors.mobileMapContainer).slideToggle();
        initialized = true;
      }
    };

    placeMarker = function( latLng ) {
      // Update the map and coordinates when the map is clicked

      for( var i=0 ; i<markers.length ; i++ ) {
        var marker = markers[i];
        marker.setPosition( latLng );
      }

      var latLngArray = latLngToArray(latLng);
      setLatLngFields( latLngArray[0], latLngArray[1] );
    };

    placeMarkerAndGeoCode = function(latLng){
      placeMarker(latLng);

      geocoder.geocode({
        'latLng': latLng
      }, function(results, status) {
        if( status == google.maps.GeocoderStatus.OK && results[1] ) {
          setLocationField(results[0].formatted_address);
        } else {
          setLocationField('');
        }
      });
    };

    codeAddress = function( address ) {
      // Update the coordinates when an address is looked up
      geocoder.geocode( { 'address': address}, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          var location = results[0].geometry.location;

          for( var i=0 ; i<maps.length ; i++ ) {
            var map = maps[i];
            map.setCenter(location);
          }

          var latLngArray = latLngToArray( location );
          setLatLngFields(latLngArray[0], latLngArray[1]);

          markersSetPosition( location );

        } else {
          console.log("Sorry, we can't find that address");
        }
      });
    };

    codeLatLng = function($this) {
      // Update the map and coordinates if coordinates are entered
      var $container = $this.closest('.custom-coords');
      var $inputLat = $container.find('[name="properties[Latitude]"]');
      var $inputLng = $container.find('[name="properties[Longitude]"]');

      var sanitizedLatlng = sanitizeInput( $inputLat.val(), $inputLng.val() ),
          lat = sanitizedLatlng[0],
          lng = sanitizedLatlng[1],
          latLng = new google.maps.LatLng(lat, lng);

      for( var i=0 ; i<maps.length ; i++ ) {
        var map = maps[i];
        map.setCenter(latLng)
        map.setZoom(11);
      }

      markersSetPosition( latLng );
      setLocationField( '' );
      setLatLngFields( lat, lng );
    };

    sanitizeInput = function(latString, lngString) {
      // Sanitize user input in the coordinates boxes

      // Check for empty strings
      if(latString == NaN || latString == "NaN" || latString == 0 || latString == "0.0000" || latString.replace(/ /g,'') == "") {
        var lat = '0';
      } else {
        var lat = latString.replace(/[^0-9.-]/g, "");
      }
      if(lngString == NaN || lngString == "NaN" || lngString == 0 || lngString == "0.0000" || lngString.replace(/ /g,'') == "") {
        var lng = '0';
      } else {
        var lng = lngString.replace(/[^0-9.-]/g, "");
      }

      // Remove degree symbol
      lat = lat.replace(/[°]/g, "");
      lng = lng.replace(/[°]/g, "");

      lat = parseFloat(lat)
      lng = parseFloat(lng)

      // if we didn't get any number, reset to 0
      lat = isNaN(lat) ? 0 : lat;
      lng = isNaN(lng) ? 0 : lng;

      // Check for edge values
      if (lat > 90.0) {
        lat = 90;
      }
      if (lng > 180.0 ) {
        lng = 180;
      }
      if (lat < -90.0) {
        lat = -90;
      }
      if (lng < -180.0 ) {
        lng = -180;
      }

      // Check for N/S/E/W
      if (latString.toUpperCase().indexOf('N') > -1) {
        lat = Math.abs(lat);
      } else if (latString.toUpperCase().indexOf('S') > -1) {
        lat = -Math.abs(lat);
      }
      if (lngString.toUpperCase().indexOf('E') > -1) {
        lng = Math.abs(lng);
      } else if (lngString.toUpperCase().indexOf('W') > -1) {
        lng = -Math.abs(lng);
      }
      return [lat, lng];
    };

    var latLngToArray = function(latlng) {
      var latlngString = String( latlng ),
          latlongArray = latlngString.substring(1, latlngString.length - 1).split(',');
      latlongArray[0] =  parseFloat( latlongArray[0] ).toFixed(4);
      latlongArray[1] =  parseFloat( latlongArray[1] ).toFixed(4);
      return latlongArray;
    };

    var setLocationField = function( address ) {
      $( selectors.inputLocation ).val( address ).trigger('updateMirrorInput');
    };

    var currentColor = '';
    var lastColor = '';
    var lastCoordinates = []; // lat, long

    $('body').on( 'selectCallback', function( event, variant ) {
      if( !variant ) {
        return;
      }

      if (!lastColor){
        lastColor = variant.option2;
      }
      currentColor = variant.option2;

      if( lastCoordinates.length ){
        lastColor = currentColor;
        createBraceletPreview(
          lastCoordinates[0],
          lastCoordinates[1],
          currentColor
        );
      } else {
        $('.swatch_options').removeClass('is-loading');
      }
    });

    //
    var customBundleStepForward = function() {
      var $customFormContainer = $('.product__custom');
      var $customCoordinates = $('.product__custom-coords');
      var $customCrossedPaths = $('.product__crossed-paths');
      var currentStep = parseInt($customFormContainer.attr('data-current-step'));

      // Lock form container height
      $customFormContainer.css('height', $customCoordinates.outerHeight());
      // Update current step for form container to hide submit button
      $customFormContainer.attr('data-current-step', currentStep + 1);
      // Fade second step out and animate container height to height of first step
      $customCoordinates.fadeOut(400, function() {
        $customFormContainer.animate({
          'height': $customCrossedPaths.outerHeight()
        }, 400, function() {
          // Unlock second step
          $customCoordinates.removeClass('is-locked');
          // Fade in first step, lock it in place and reset container height
          $customCrossedPaths.fadeIn(400, function() {
            $customCrossedPaths.addClass('is-locked');
            $customFormContainer.css('height', '');
          });
        });
      });
    };

    var updatePreviewUrl = function (path) {
      let $slidesToUpdate = $('.flexslider .slides > li');
      let navThumb = $('.flex-control-nav > li');
      let itLoaded = false;
      let firstSlide;
      let secondSlide;
      let index;

      let $target = $slidesToUpdate.filter('[data-alt="Dynamic Custom Coordinates"]');

      if ($target.length) {
        firstSlide = $target.not('.clone')[0];
        secondSlide = $target.filter('.clone')[0];
        index = $slidesToUpdate.not('.clone').index(firstSlide);
      } else {
        firstSlide = $slidesToUpdate[1];
        secondSlide = $slidesToUpdate[$slidesToUpdate.length - 1];
        index = 0;
      }

      if (firstSlide){
        let $firstImage = $(firstSlide).find('img');
        $(firstSlide).data('thumb', path);
        $firstImage.attr('src', path);
        $firstImage.attr('data-src', path);
        $firstImage.attr('srcset', '');
        $firstImage.attr('data-srcset', '');
        var imageLoading = $(firstSlide).find('img');
        imageLoading.off('load').on('load', function(){
          itLoaded = true;
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        });
      }
      if (secondSlide){
        let $secondImage = $(secondSlide).find('img');
        $(secondSlide).data('thumb', path);
        $secondImage.attr('src', path);
        $secondImage.attr('data-src', path);
        $secondImage.attr('srcset', '');
        $secondImage.attr('data-srcset', '');
      }
      if (navThumb && navThumb.length > index)
        $(navThumb[index]).find('img').attr('src', path);
      var slider = $('.flexslider');
      if (slider) {
        slider.flexslider(index);
      }

      setTimeout(function() {
        // fallback in case it's taking too slow to load the first image
        if (!itLoaded){
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        }
      }, 3000);
    };

    // Keys will be concatenated values of lat, lng, color
    var cache = {};

    var createBraceletPreview = function (lat, lng, color) {
      if (!color || color.indexOf('Gift Pack') > -1 || color.indexOf('Button') > -1 || color.indexOf('Tassel') > -1){
        color = 'Black';
      }
      lat = lat.replace(/[°]/g, "");
      lng = lng.replace(/[°]/g, "");

      var path = encodeURI('https://w.sellry.com/bracelet-preview/?'+
        'lat='+lat+'&'+
        'lng='+lng+'&'+
        'color='+color+'&'+
        'action=preview');
        cache[lat+lng+color] = path;
      $('.bracelet-preview-url').attr('value', path);

      $('.product_gallery').addClass('is-loading');
      if ( cache[lat+lng+color] ) {
        setTimeout(function(){
          updatePreviewUrl(cache[lat+lng+color]);
        }, 500);
      } else {
        $.ajax({
          url: 'https://w.sellry.com/bracelet-preview/',
          dataType: 'json',
          cache: false,
          type: 'get',
          data: {lat: lat, lng: lng, color: color, action: 'preview'},
          error: function(xhr) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if(contentType !== 'image/jpeg') {
              $('.product_gallery').removeClass('is-loading');
              $('.swatch_options').removeClass('is-loading');
            }
          },
          complete: function(xhr) {
            var contentType = xhr.getResponseHeader("Content-Type");
            if(contentType === 'image/jpeg') {
              cache[left+right+up+down+color] = path;
              setTimeout(function(){
                updatePreviewUrl(path);
              }, 500);
            } else {
              $('.product_gallery').removeClass('is-loading');
              $('.swatch_options').removeClass('is-loading');
            }
          }
        });
      }

      return {
        valid : true,
        message : 'Preview image has been generated'
      };
    }

    var setLatLngFields = function( lat, lng ) {
      // Ensure values are positive
      var lngInitial = lng;
      var latInitial = lat;
      if ( lat[0] == '-' ) lat = lat.substring(1);
      if ( lng[0] == '-' ) lng = lng.substring(1);

      var latString = String(Math.abs(lat).toFixed(4) + '\xB0'),
          lngString = String(Math.abs(lng).toFixed(4) + '\xB0');

      if ( latInitial >= 0 ) {
        latString += ' N';
      } else if ( latInitial < 0 ) {
        latString += ' S';
      }

      if ( lngInitial >= 0 ) {
        lngString += ' E';
      } else if ( lngInitial < 0 ) {
        lngString += ' W';
      }

      $( selectors.inputLat ).val( latString ).trigger('updateMirrorInput');
      $( selectors.inputLng ).val( lngString ).trigger('updateMirrorInput');

      lastCoordinates = [latString, lngString];

      previewImage = createBraceletPreview(latString, lngString, currentColor);

      if( previewImage.valid === true) {
        $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', false);
        $(selectors.productCustomCoords).removeClass('bracelet-incomplete').addClass('bracelet-complete');
      } else {
        if(previewImage.code == 'badformat'){
          $(selectors.errorContainer).html(previewImage.message).addClass('visible');
        }
        $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', true);
        $(selectors.container).find(selectors.addToCartBtn).prop('disabled', true);
      }
    };

    var markersSetPosition = function(latlng) {
      for( var i=0 ; i < markers.length ; i++ ) {
        var marker = markers[i];
        marker.setPosition(latlng);
      }
    };

    var mapIsUnlocked = function() {
      return $( selectors.mapLockCheckbox ).first().is(':checked');
    }

    // Initialize map and corresponding events
    google.maps.event.addDomListener(window, 'load', initialize);

    // Event handlers
    $( selectors.inputLocationLookup ).click(function(e){
      if (delayMap && !initialized) {
        $(selectors.mobileMapContainer).slideDown();
        initialized = true;
      }

      e.preventDefault();
      var address = $(this).closest('.custom-coords__input-row').find( '[data-mirror-name="location"]' ).val();
      codeAddress( address );
    });

    $( selectors.inputLat ).change(function(e){
      if (delayMap && !initialized) {
        $(selectors.mobileMapContainer).slideDown();
        initialized = true;
      }

      codeLatLng($(this));
    });

    $( selectors.inputLng ).change(function(e){
      if (delayMap && !initialized) {
        $(selectors.mobileMapContainer).slideDown();
        initialized = true;
      }

      codeLatLng($(this));
    });

    $( selectors.mobileConfirmCoordinates ).click(function(e){      
          var $container = $(this).closest('.custom-coords');
          var $inputLat = $container.find('[data-mirror-name="properties[Latitude]"]');
          var $inputLng = $container.find('[data-mirror-name="properties[Longitude]"]');

          var sanitizedLatlng = sanitizeInput( $inputLat.val(), $inputLng.val() ),
          lat = sanitizedLatlng[0],
          lng = sanitizedLatlng[1],
          latLng = new google.maps.LatLng(lat, lng);

          for( var i=0 ; i < maps.length ; i++ ) {
            var map = maps[i];
            map.setCenter(latLng)
            map.setZoom(11);
          }

          markersSetPosition( latLng );
          setLatLngFields( lat, lng );
    });

    window.addEventListener('load', function(){
      if( $(selectors.inputLocation).val() !== 'Bali, Indonesia' && $( selectors.inputLat ).val() !== '0.0000° N'){
        $( selectors.inputLat ).trigger('change');
        $( selectors.inputLng ).trigger('change');
      }
    });

    /*
    $( selectors.inputLat, selectors.inputLng ).blur(function(e){
      var isValid = /[0-9]{1,3}.[0-9]{4}[\°\º] [NSWE]/g.test($(this).val());
    })
    */

    $( selectors.btnGetCurrentPosition ).click(function(e){
      e.preventDefault();
      getCurrentPosition();
    });

    $( selectors.inputLocation ).keydown(function(e){
      if( e.keyCode == 13 ) {
        e.preventDefault()
        $( selectors.inputLocationLookup ).first().click();
      }
    });

    $( '#CustomCoordsInputLocation--mobile-configurator' ).keydown(function(e){
      if( e.keyCode == 13 ) {
        e.preventDefault()
        $( selectors.inputLocationLookup ).last().click();
        $('#CustomCoordsInputLocation--mobile-configurator').blur();
      }
    });

    $( selectors.mapLockCheckbox ).change(function(){
      var val = $(this).is(':checked');
      $( selectors.mapLockCheckbox ).prop('checked', val);
    });

    $( selectors.stepContinue ).click(function(e){
      e.preventDefault();
      var currentStep = parseInt( $( selectors.productCustomCoords ).attr('data-current-step') );
      if( $( selectors.container ).filter('[data-step="' + (currentStep+1) + '"]').length ) {
        $( selectors.productCustomCoords ).attr('data-current-step', currentStep+1);
      }
    });

    $( selectors.stepBack ).click(function(e){
      e.preventDefault();
      var currentStep = parseInt( $( selectors.productCustomCoords ).attr('data-current-step') );
      $( selectors.productCustomCoords ).attr('data-current-step', currentStep-1);
    });

    $(selectors.customBundleStepForward).click(function(e) {
      e.preventDefault();
      var $latitudeInput = $('.custom-coords__input--latitude');
      var $longitudeInput = $('.custom-coords__input--longitude');

      if (!$latitudeInput.val() || !$longitudeInput.val()) {
        document.querySelector('.shopify-product-form').reportValidity();
      } else {
        customBundleStepForward();
      }
    });

    var $mobileConfigurator = $('.mobile-configurator');
    if( $mobileConfigurator.length ) {
      $mobileConfigurator.on('focusin', '[data-mirror-name="location"], [data-mirror-name="properties[Latitude]"], [data-mirror-name="properties[Longitude]"]', function(){
        $mobileConfigurator.find( '.custom-coords__input-row--map' ).stop().slideUp('slow');
        $(this).val('').trigger('updateMirrorInput');
      });

      $mobileConfigurator.on('focusout', '[data-mirror-name="location"], [data-mirror-name="properties[Latitude]"], [data-mirror-name="properties[Longitude]"]' , function(){
        $mobileConfigurator.find( '.custom-coords__input-row--map' ).stop().slideDown('slow');
      });
    }
  },
  initMobileConfigurator: function() {

    var selectors = {
      container: '.mobile-configurator',
      overlay: '.mobile-configurator__overlay',
      panelList: '.mobile-configurator__panel_list',
      panelItem: '.mobile-configurator__panel__item',
      panel: '.mobile-configurator__panel',
      panelClose: '.mobile-configurator__panel__close',
      nav: '.mobile-configurator__nav',
      navTitle: '.mobile-configurator__nav__title',
      navList: '.mobile-configurator__nav__list',
      navItem: '.mobile-configurator__nav__item',
      navLink: '.mobile-configurator__nav__link',
      navCart: '.mobile-configurator__add-to-cart',
      navOption: '.mobile-configurator__nav__option',
      navItemStep: '.mobile-configurator__nav__step',
      navExcluded: '.counter-excluded',
      navLinkAddToCart: '.mobile-configurator__nav__link--add-to-cart',
      navLinkNotify: '.mobile-configurator__nav__link--notify',
      navLinkConfirm: '.mobile-configurator__nav__link--confirm',
      navLabelText: '.mobile-configurator__nav__label__text',
      navLabelThumbnail: '.mobile-configurator__nav__label__thumbnail',
      navComplete: '.mobile-configurator__nav__complete',
      swatch: '.swatch',
      swatchElement: '.swatch__element',
      swatchListItem: '.swatch__list__item',
      mirrorInput: '.mirror-input'
    };

    var personalizationProducts = [
        'custom-gift-set',
        'custom-date',
        'custom-initials',
        'custom-coordinates',
        'custom-word',
        'custom-winged-heart'
    ];

    if( !$( selectors.container ).length ) {
      return;
    }

    var closePanels = function() {
      $( selectors.container ).removeClass('in');
      $( selectors.panelItem ).removeClass('active');
      $( selectors.navItem ).removeClass('active');
      $('#gorgias-web-messenger-container').show();
    };

    var openPanel = function(navItemName) {
      closePanels();

      if(navItemName == 'add-to-cart'){
        return;
      }

      var $addToCart = $( selectors.navLinkAddToCart ),
          $mobileConfigurator = $( selectors.container ),
          $navList = $(selectors.navList),
          $panelItem = $( selectors.panelItem ).filter('[data-name="' + navItemName + '"]'),
          $navItem = $( selectors.navItem ).filter('[data-name="' + navItemName + '"]');

      if(!$navItem.hasClass('counter-excluded')) {
        $mobileConfigurator.addClass('in');
        $panelItem.addClass('active');
        $navItem.addClass('active');      

        if($navList.hasClass('slick-initialized')) {
          $addToCart.prop('disabled', true);
          $navList.slick('slickGoTo', $navItem.attr('data-slick-index'));
        }
      }

      if($(window).width() < 768 ) {
        $('#gorgias-web-messenger-container').hide();
      }
    };

    $( selectors.overlay ).click(function() {
      closePanels();
    });

    $( selectors.container ).addClass('mobile-options-count-' + $(selectors.navItem).not(selectors.navExcluded).length);


    var stepcount = $(selectors.navItem).not(selectors.navExcluded).length;
    if( stepcount > 3) {
      $(selectors.navTitle).find('.mobile-configurator__step-count').html(stepcount);
      $(selectors.navList).slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: false,
        dots: false
      });
    }

    $(selectors.navItem).not(selectors.navExcluded).each(function(index, step){
      $(this).find(selectors.navItemStep).html(++index);
    });

    $(document).on('click', selectors.navItem, function(e) {
      e.preventDefault();

      var target = $(this).attr('data-name');

      if( target == undefined ) {
        target = $(this).closest( selectors.navItem ).attr('data-name');
      }

      var $navItem = $(this).closest(selectors.navItem);
      var $navAddToCart = $(selectors.navLinkAddToCart);
      if ($navItem.hasClass('is-complete')) {
        $navItem.removeClass('is-complete');
      }

      // Keepsake box can be added without any customization
      if( target != 'keepsake-box' && !$navItem.hasClass('keep-atc-active')) {
        $navAddToCart.prop('disabled', true);
      }

      openPanel( target );
    });

    $(document).on('click', '.product__custom__next--mobile', function(e) {
      e.preventDefault();

      var $navItem = $(this).closest(selectors.navItem);
      var isValid = true;

      if ($navItem.data('name') == 'custom-coords') {
        var $customCoordsEl = $($navItem).find('.custom-coords__input.mirror-input');
        $.each($customCoordsEl, function(i, element){
          var currentCoords = $(element).val();
          if (!currentCoords) {
            isValid = false;
          };
        });

        if (!isValid) {
          closePanels();
          $navItem.children(selectors.navLink).click();
          return false;
        }
      }

      if ($( selectors.navComplete ).length) {
        $navItem.addClass('is-complete');
      }

      openPanel('crossed-paths');
    });

    $(document).on('click', selectors.navLinkConfirm, function(e) {
        e.stopPropagation();
        e.preventDefault();
        
        window.scrollTo(0,0);

        // Trigger input change to regenerate preview on confirm action
        $(selectors.mirrorInput).trigger('keyup');

        var $currentPanel = $(this).closest(selectors.panelItem),
            $navItem = $(selectors.navItem).filter('[data-name="' + $currentPanel.attr('data-name') + '"]'),
            $navItemAddToCart = $( selectors.navLinkAddToCart ),
            $panelBody = $(this).closest( selectors.panelItem ).find('.mobile-configurator__panel__body'),
            bundleValidation = '',
            isValid = true;

        if ($navItem.data('name') == 'keepsake-giftset-message') {
            var $keepsakeBoxParentEl = $(this).parents(selectors.panelList).find('[data-name=keepsake-giftset-message]');
            if ($keepsakeBoxParentEl){
                var $keepsakeBoxEl = $($keepsakeBoxParentEl).find('.keepsake-box__input');
                $.each($keepsakeBoxEl, function(i, element) {
                    var keepsakeBoxInput = $(element).val().trim();
                    if (!keepsakeBoxInput || keepsakeBoxInput.length == 0) {
                        isValid = false;
                    }
                });
            }

            if (!isValid) {
                openPanel('keepsake-giftset-message');
                return false;
            }

            var $mobileConfigurator = $(selectors.container);
            if( $mobileConfigurator.attr('data-product-types') !== typeof undefined && $mobileConfigurator.attr('data-product-types') != '') {
                bundleValidation = $mobileConfigurator.attr('data-product-types').split('|');
                console.log('This product is bundled with: ' + bundleValidation);
            }
        }

        if ($navItem.data('name') == 'crossed-paths' || bundleValidation.includes('crossed-paths') === true ) {
          var $crossedPathsEl = $panelBody.find('.crossed-paths__input.mirror-input');
          $.each($crossedPathsEl, function(i, element){
            var currentInitial = $(element).val().trim();
            if (!currentInitial) {
              isValid = false;
            };
          });

          if (!isValid) {
            openPanel('crossed-paths');
            return false;
          }
        }

        if ($navItem.data('name') == 'custom-coords' || bundleValidation.includes('custom-coords') === true) {
          var $customCoordsEl = $($navItem).find('.custom-coords__input.mirror-input');
          $.each($customCoordsEl, function(i, element){
            var currentCoords = $(element).val().trim();
            if (!currentCoords || currentCoords.length == 0 ) {
              isValid = false;
            };
          });

          if (!isValid) {
            openPanel('custom-coords');
            return false;
          }
        }

        if ($navItem.data('name') == 'custom-date' || bundleValidation.includes('custom-date') === true) {

            isValid = false;
            var $customDateParentEl = $(this).parents('.mobile-configurator__nav').find('[data-name=custom-date]');
            if ($customDateParentEl.length > 0){
              var customDateElements = $($customDateParentEl).find('.custom-date__input.mirror-input'),
                  left = $(customDateElements[0]).val().trim() || '',
                  right = $(customDateElements[1]).val().trim() || '',
                  bottom = $(customDateElements[2]).val().trim() || '';

              if (left.length > 0 && right.length > 0 && bottom.length > 0){
                isValid = true;
              }
            }

            if (!isValid) {
                openPanel('custom-date');
                return false;
            }
        }

        if ($navItem.data('name') == 'custom-word' || bundleValidation.includes('custom-word') == true) {
            var $customWordParentEl = $(this).parents('.mobile-configurator__nav').find('[data-name=custom-word]');
            if ($customWordParentEl) {
              var $customWordEl = $($customWordParentEl).find('.custom-word__input.mirror-input');
              $.each($customWordEl, function(i, element) {
                var customWordInput = $(element).val().trim();
                if (!customWordInput || customWordInput.length == 0) {
                  isValid = false;
                };
              });

              if (!isValid) {
                openPanel('custom-word');
                return false;
              }
            }
        }

        if ($navItem.data('name') == 'winged-heart' || bundleValidation.includes('winged-heart') == true) {
            var $wingedHeartParentEl = $(this).parents('.mobile-configurator__nav').find('[data-name=winged-heart]');
            if ($wingedHeartParentEl){
              var $winhedHeartEl = $($wingedHeartParentEl).find('.winged-heart__input.mirror-input');

              var up = $winhedHeartEl[0].value;
              var middle = $winhedHeartEl[1].value;
              var down = $winhedHeartEl[2].value;

              if( (up && !middle && !down) || (!up && !middle && down) ) {
                middle = up ? up : down;
                up = down = '';
              } else if( (up && middle && !down) || (!up && middle && down) || (up && !middle && down) ) {
                up = up ? up : middle;
                middle = down ? down : middle;
                down = ''; 
              }

              $winhedHeartEl[0].value = up;
              $winhedHeartEl[1].value = middle;
              $winhedHeartEl[2].value = down;

              var filledOptions = 0;
              $.each($winhedHeartEl, function(i, element){
                var wingedHeartInitials = $(element).val();          
                if (wingedHeartInitials) {
                  filledOptions += 1;
                };
              });
      
              isValid = filledOptions > 0 ? true : false;

              if (!isValid) {
                openPanel('winged-heart');
                return false;
              }
            }
        }

        if ($navItem.data('name') == 'keepsake-box') {
            var $keepsakeBoxParentEl = $(this).parents('.mobile-configurator__nav').find('[data-name=keepsake-box]');
            if ($keepsakeBoxParentEl){
                var $keepsakeBoxEl = $($keepsakeBoxParentEl).find('.keepsake-box__input');
                $.each($keepsakeBoxEl, function(i, element) {
                    var keepsakeBoxInput = $(element).val().trim();
                    if (!keepsakeBoxInput || keepsakeBoxInput.length == 0) {
                        isValid = false;
                    }
                });
            }

            if (!isValid) {
                closePanels();
                $keepsakeBoxParentEl.children(selectors.navLink).click();
                return false;
            }
        }

        if (isValid) {
            /**
             * If we are on last step we add the complete class, otherways we trigger customization complete
             * in order to jump into next step
             *
             */
            if($($navItem).find(selectors.navComplete).length) {
                $navItem.addClass('is-complete');
                $navItemAddToCart.prop('disabled', false);
                closePanels();
            } else {
                $('body').trigger('braceletcomplete');
            }            
        }
    });

    $(document).on('click', selectors.navLinkAddToCart, function(e) {
      e.preventDefault();
      var $navItem = $(this).closest( selectors.navItem );
      var $panelBody = $(this).closest( selectors.navItem ).find('.mobile-configurator__panel__body');
      var isValid = true;

      var $crossedPathsParentEl = $(this).parents('.mobile-configurator__nav').find('[data-name=crossed-paths]');
      if ($crossedPathsParentEl.length > 0){
            var $crossedPathsEl = $($crossedPathsParentEl).find('.crossed-paths__input.mirror-input');
            $.each($crossedPathsEl, function(i, element){
              var currentInitial = $(element).val();
              if (!currentInitial || currentInitial.length == 0) {
                isValid = false;
              };
            });

            if (!isValid) {
              closePanels();
              $crossedPathsParentEl.children(selectors.navLink).click();
              return false;
            }
      }
      
      var $customCoordsParentEl = $(this).parents('.mobile-configurator__nav').find('[data-name=custom-coords]');
      if ($customCoordsParentEl.length > 0){
        var $customCoordsEl = $($customCoordsParentEl).find('.custom-coords__input.mirror-input');
        $.each($customCoordsEl, function(i, element){
          var currentCoords = $(element).val();
          if (!currentCoords) {
            isValid = false;
          };
        });

        if (!isValid) {
          closePanels();
          $customCoordsParentEl.children(selectors.navLink).click();
          return false;
        }
      }

      var $wingedHeartParentEl = $(this).parents('.mobile-configurator__nav').find('[data-name=winged-heart]');
      if ($wingedHeartParentEl.length > 0){
        var $winhedHeartEl = $($wingedHeartParentEl).find('.winged-heart__input.mirror-input');
        var filledOptions = 0;
        $.each($winhedHeartEl, function(i, element){
          var wingedHeartInitials = $(element).val();          
          if (wingedHeartInitials) {
            filledOptions += 1;
          };
        });

        isValid = filledOptions > 0 ? true : false;

        if (!isValid) {
          closePanels();
          $wingedHeartParentEl.children(selectors.navLink).click();
          return false;
        }
      }

      var $customDateParentEl = $(this).parents('.mobile-configurator__nav').find('[data-name=custom-date]');
      if ($customDateParentEl.length > 0){
        var $customDateEl = $($customDateParentEl).find('.custom-date__input.mirror-input');
        $.each($customDateEl, function(i, element){
          var customDateInput = $(element).val();
          if (!customDateInput) {
            isValid = false;
          };
        });

        if (!isValid) {
          closePanels();
          $customDateParentEl.children(selectors.navLink).click();
          return false;
        }
      }

      var $customWordParentEl = $(this).parents('.mobile-configurator__nav').find('[data-name=custom-word]');
      if ($customWordParentEl.length > 0){
        var $customWordEl = $($customWordParentEl).find('.custom-word__input.mirror-input');
        $.each($customWordEl, function(i, element){
          var customWordInitials = $(element).val();
          if (!customWordInitials) {
            isValid = false;
          };
        });

        if (!isValid) {
          closePanels();
          $customWordParentEl.children(selectors.navLink).click();
          return false;
        }
      }

      jQuery.post('/cart/add.js', $('form[action="/cart/add"]').serialize())
        .always(function(){
          $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            success: function(cart) {
              if($('.shopify-product-form').hasClass('to-checkout')) {
                window.location.href = '/checkout';
              } else {
                refreshCart(cart,false);
                window.setTimeout(function(){ $('.cart-button').click(); }, 1000);
              }

            }
          });
        });
    });

    $(document).on('click', selectors.navLinkNotify, function(e){
        BIS.popup.show();
    });

    $(document).on('click', selectors.panelClose, function(e) {
      e.preventDefault();
      e.stopPropagation();
      closePanels();
    });

    $(document).on('click', selectors.swatchElement, function(e) {
      e.stopPropagation();

      var $currentPanel = $(this).closest(selectors.panelItem),
          $currentNavItem = $(selectors.navItem).filter('[data-name="' + $currentPanel.attr('data-name') + '"]'),
          $nextNavItem = $currentNavItem.next(),
          $nextPanel = $(selectors.panelItem).filter('[data-name="' + $nextNavItem.attr('data-name') + '"]');


      if( $nextNavItem.attr('data-name') == 'add-to-cart'  ) {
        closePanels();
        return;
      }

      if( $nextPanel.length ) {
        openPanel($nextPanel.attr('data-name'));
      }
    });

    $( selectors.mirrorInput ).change(function(e){
      $(this).trigger('updateMirrorInput');
    });

    $( selectors.mirrorInput ).on('updateMirrorInput', function(){
        var val = $(this).val(),
        mirrorName = $(this).data('mirror-name');

        $('[data-mirror-name="' + mirrorName + '"]').val( val );
    });

    $('body').on( 'selectCallback', function( event, variant ) {
      if( !variant ) {
        return;
      }

      // If no inventory is available trigger out of stock notify
      
      if(variant.inventory_quantity <= 0 && variant.inventory_policy == 'deny') {
        $(selectors.navLinkAddToCart).prop('disabled', true).hide();
        $(selectors.navLinkNotify).show();
      } else {
        // If item is giftset or personalization step is not complete
        $mobileConfigurator = $(selectors.container);
        $finalStep = $(selectors.navItem + ':last-child');
        if ($finalStep.find('.mobile-configurator__nav__complete').length > 0 || personalizationProducts.includes($mobileConfigurator.data('product-type')) ) {
          if($finalStep.hasClass('is-complete')) {
            $(selectors.navLinkAddToCart).prop('disabled', false).show();
          } else {
            $(selectors.navLinkAddToCart).prop('disabled', true).show();
          }
        } else {
            $(selectors.navLinkAddToCart).prop('disabled', false).show();
        }
        $(selectors.navLinkNotify).hide();
      }
      


      // Update mobile configurator swatch state
      $( selectors.container ).find( selectors.swatchListItem ).removeClass('active');
      $( selectors.container ).find( selectors.navLabelThumbnail ).hide();

      // Enable add to cart button on variant selection for non-customizable items only
      if($( selectors.navComplete ).length == 0) {
        $( selectors.navLinkAddToCart ).prop('disabled', false);
      }

      for( var i=0 ; i<variant.options.length ; i++ ) {
        var variantOption = variant.options[i],
            $swatch = $( selectors.container ).find( selectors.swatch ).filter('[data-option-index="' + i + '"]'),
            $navItem = $( selectors.navItem ).filter('[data-option-index="' + i + '"]');

        $swatch.find( selectors.swatchElement ).filter('[data-value="' + variantOption + '"]').closest( selectors.swatchListItem ).addClass('active');

        $navItem.find( selectors.navLabelText ).html( variantOption );
        $navItem.find( selectors.navLabelThumbnail ).filter('[data-value="' + variantOption + '"]').show();
      }
    });

    $('body').on('braceletcomplete', function(event){
        var $currentNavItem = $(selectors.navItem).filter('.active'),
        $nextNavItem = $currentNavItem.next(),
        $navList = $(selectors.navList),
        target = $nextNavItem.attr('data-name');

        // blur active element to hide mobile keyboard and scroll to top in order to show preview
        document.activeElement.blur();
        window.scrollTo(0,0);

        if($navList.hasClass('slick-initialized')) {
          // If current nav has .complete child, there is no next step
          if ($currentNavItem.find( selectors.navComplete ).length != 0)
            return;

          $navList.slick('slickGoTo', $nextNavItem.attr('data-slick-index'));
        } else {
          if ($currentNavItem.find( selectors.navComplete ).length) {
            $currentNavItem.addClass('is-complete');
          }
          $( selectors.navLinkAddToCart ).prop('disabled', false);
        }

        openPanel(target);
    });
  },
  initCoordsSet: function() {

    var selectors = {
      productCustomCoords: '.product__custom-coords',
      container: '.custom-coords',
      inputGroup: '.custom-coords__input-group',
      input: '.custom-coords__input',
      inputLocation: '[name="location"]',
      inputLocationLookup: '.custom-coords__location-lookup',
      inputLat: '[name="properties[Latitude]"]',
      inputLng: '[name="properties[Longitude]"]',
      map: '.custom-coords__map',
      mapLockCheckbox: '.custom-coords__map-lock__checkbox',
      btnGetCurrentPosition: '.custom-coords__get-current-position',
      stepContinue: '.custom-coords__step__continue',
      stepBack: '.custom-coords__step__back',
      customBundleStepForward: '.product__custom__next',
      mobileMapContainer: '.mobile-configurator .custom-coords__input-row--map',
      mobileConfirmCoordinates: '.mobile-configurator__nav__link--confirm.custom-coords__confirm',
      navLinkConfirm: '.mobile-configurator__nav__link--confirm',
      addToCartBtn: '.add_to_cart'
    };

    if( !$( '.set-custom-coords' ).length ) {
      return;
    }

    // variables
    var geocoder,
        maps = [],
        markers = [],
        mapUnlocked = false,
        geocoder;

    // functions
    var initialize, getCurrentPosition, showPosition, placeMarkerAndGeoCode, codeAddress, codeLatLng, placeMarker, sanitizeInput;

    var initialized = false;
    var delayMap = (window.location.search.indexOf('delaymap') !== -1);

    initialize = function() {

      geocoder = new google.maps.Geocoder();

      var latLng = new google.maps.LatLng(-8.4095, 115.1889),
      mapOptions = {
        zoom: 8,
        center: latLng
      };

      $( selectors.map ).each(function(){

        var mapId = $(this).attr('id');
        if( mapId == undefined ) {
          return;
        }

        var map = new google.maps.Map(document.getElementById(mapId), mapOptions),
            marker = new google.maps.Marker({
              map: map,
              position: latLng
            });  

        google.maps.event.addListener(map, 'click', function(event) {
          if( $(window).width() >= 768 && mapIsUnlocked() ) {
            placeMarker(event.latLng);
          }
        });

        google.maps.event.addListener(map,'center_changed', function() {
          if ( $(window).width() < 768 && (mapIsUnlocked() || delayMap) ) {
            var latLng = new google.maps.LatLng( map.getCenter().lat(), map.getCenter().lng() );
            placeMarkerAndGeoCode(latLng);
          }
        });

        maps.push(map);
        markers.push(marker);

      });

      if (delayMap) {
        $(selectors.mobileMapContainer).hide();
      }
    };

    getCurrentPosition = function() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showPosition);
      } else {
        alert("Geolocation is not supported by this browser.");
      }
    };

    showPosition = function(position) {
      var lat = position.coords.latitude,
          lng = position.coords.longitude,
          latLng = new google.maps.LatLng(lat, lng);

      for( var i=0 ; i<maps.length ; i++ ) {
        var map = maps[i];
        map.setCenter(latLng);
      }

      placeMarkerAndGeoCode(latLng);

      if (delayMap && !initialized) {
        $(selectors.mobileMapContainer).slideToggle();
        initialized = true;
      }
    };

    placeMarker = function( latLng ) {
      // Update the map and coordinates when the map is clicked

      for( var i=0 ; i<markers.length ; i++ ) {
        var marker = markers[i];
        marker.setPosition( latLng );
      }

      var latLngArray = latLngToArray(latLng);
      setLatLngFields( latLngArray[0], latLngArray[1] );
    };

    placeMarkerAndGeoCode = function(latLng){
      placeMarker(latLng);

      geocoder.geocode({
        'latLng': latLng
      }, function(results, status) {
        if( status == google.maps.GeocoderStatus.OK && results[1] ) {
          setLocationField(results[0].formatted_address);
        } else {
          setLocationField('');
        }
      });
    };

    codeAddress = function( address ) {
      // Update the coordinates when an address is looked up
      geocoder.geocode( { 'address': address}, function(results, status) {
        if (status == google.maps.GeocoderStatus.OK) {
          var location = results[0].geometry.location;

          for( var i=0 ; i<maps.length ; i++ ) {
            var map = maps[i];
            map.setCenter(location);
          }

          var latLngArray = latLngToArray( location );
          setLatLngFields(latLngArray[0], latLngArray[1]);

          markersSetPosition( location );

        } else {
          console.log("Sorry, we can't find that address");
        }
      });
    };

    codeLatLng = function($this) {
      // Update the map and coordinates if coordinates are entered
      var $container = $this.closest('.custom-coords');
      var $inputLat = $container.find('[name="properties[Latitude]"]');
      var $inputLng = $container.find('[name="properties[Longitude]"]');

      var sanitizedLatlng = sanitizeInput( $inputLat.val(), $inputLng.val() ),
          lat = sanitizedLatlng[0],
          lng = sanitizedLatlng[1],
          latLng = new google.maps.LatLng(lat, lng);

      for( var i=0 ; i<maps.length ; i++ ) {
        var map = maps[i];
        map.setCenter(latLng)
        map.setZoom(11);
      }

      markersSetPosition( latLng );
      setLocationField( '' );
      setLatLngFields( lat, lng );
    };

    sanitizeInput = function(latString, lngString) {
      // Sanitize user input in the coordinates boxes

      // Check for empty strings
      if(latString == NaN || latString == "NaN" || latString == 0 || latString == "0.0000" || latString.replace(/ /g,'') == "") {
        var lat = '0';
      } else {
        var lat = latString.replace(/[^0-9.-]/g, "");
      }
      if(lngString == NaN || lngString == "NaN" || lngString == 0 || lngString == "0.0000" || lngString.replace(/ /g,'') == "") {
        var lng = '0';
      } else {
        var lng = lngString.replace(/[^0-9.-]/g, "");
      }

      // Remove degree symbol
      lat = lat.replace(/[°]/g, "");
      lng = lng.replace(/[°]/g, "");

      lat = parseFloat(lat)
      lng = parseFloat(lng)

      // if we didn't get any number, reset to 0
      lat = isNaN(lat) ? 0 : lat;
      lng = isNaN(lng) ? 0 : lng;

      // Check for edge values
      if (lat > 90.0) {
        lat = 90;
      }
      if (lng > 180.0 ) {
        lng = 180;
      }
      if (lat < -90.0) {
        lat = -90;
      }
      if (lng < -180.0 ) {
        lng = -180;
      }

      // Check for N/S/E/W
      if (latString.toUpperCase().indexOf('N') > -1) {
        lat = Math.abs(lat);
      } else if (latString.toUpperCase().indexOf('S') > -1) {
        lat = -Math.abs(lat);
      }
      if (lngString.toUpperCase().indexOf('E') > -1) {
        lng = Math.abs(lng);
      } else if (lngString.toUpperCase().indexOf('W') > -1) {
        lng = -Math.abs(lng);
      }
      return [lat, lng];
    };

    var latLngToArray = function(latlng) {
      var latlngString = String( latlng ),
          latlongArray = latlngString.substring(1, latlngString.length - 1).split(',');
      latlongArray[0] =  parseFloat( latlongArray[0] ).toFixed(4);
      latlongArray[1] =  parseFloat( latlongArray[1] ).toFixed(4);
      return latlongArray;
    };

    var setLocationField = function( address ) {
      $( selectors.inputLocation ).val( address ).trigger('updateMirrorInput');
    };

    var currentColor = $('.fancybox-is-open .product__custom-coords').attr('current-color');

    //
    var customBundleStepForward = function() {
      var $customFormContainer = $('.product__custom');
      var $customCoordinates = $('.product__custom-coords');
      var $customCrossedPaths = $('.product__crossed-paths');
      var currentStep = parseInt($customFormContainer.attr('data-current-step'));

      // Lock form container height
      $customFormContainer.css('height', $customCoordinates.outerHeight());
      // Update current step for form container to hide submit button
      $customFormContainer.attr('data-current-step', currentStep + 1);
      // Fade second step out and animate container height to height of first step
      $customCoordinates.fadeOut(400, function() {
        $customFormContainer.animate({
          'height': $customCrossedPaths.outerHeight()
        }, 400, function() {
          // Unlock second step
          $customCoordinates.removeClass('is-locked');
          // Fade in first step, lock it in place and reset container height
          $customCrossedPaths.fadeIn(400, function() {
            $customCrossedPaths.addClass('is-locked');
            $customFormContainer.css('height', '');
          });
        });
      });
    };

    var updatePreviewUrl = function (path) {

    };

    // Keys will be concatenated values of lat, lng, color
    var cache = {};

    var createBraceletPreview = function (lat, lng, color) {

      color =  $('.fancybox-is-open .product__custom-coords').attr('current-color');

      if (!color){
        color = 'Black';
      }
      lat = lat.replace(/[°]/g, "");
      lng = lng.replace(/[°]/g, "");

      var path = encodeURI('https://w.sellry.com/beaded-coordinates-preview/?'+
        'lat='+lat+'&'+
        'lng='+lng+'&'+
        'color='+color+'&'+
        'action=preview');
        cache[lat+lng+color] = path;
      $('.bracelet-preview-url').attr('value', path);


      $.ajax({
        url: 'https://w.sellry.com/beaded-coordinates-preview/',
        dataType: 'json',
        cache: false,
        type: 'get',
        data: {lat: lat, lng: lng, color: color, action: 'preview'},
        error: function(xhr) {
          var contentType = xhr.getResponseHeader("Content-Type");
          if(contentType !== 'image/jpeg') {
            $('.product_gallery').removeClass('is-loading');
            $('.swatch_options').removeClass('is-loading');
          }
        },
        complete: function(xhr) {
          var contentType = xhr.getResponseHeader("Content-Type");
          if(contentType === 'image/jpeg') {
            $('.fancybox-is-open .product__custom-coords').attr('preview-img', path);
            $('.currentCoordImg').attr('src',path);
          } else {
            $('.product_gallery').removeClass('is-loading');
            $('.swatch_options').removeClass('is-loading');
          }
        }
      });
      

      return {
        valid : true,
        message : 'Preview image has been generated'
      };
    }

    var setLatLngFields = function( lat, lng ) {
      // Ensure values are positive
      var lngInitial = lng;
      var latInitial = lat;
      if ( lat[0] == '-' ) lat = lat.substring(1);
      if ( lng[0] == '-' ) lng = lng.substring(1);

      var latString = String(Math.abs(lat).toFixed(4) + '\xB0'),
          lngString = String(Math.abs(lng).toFixed(4) + '\xB0');

      if ( latInitial >= 0 ) {
        latString += ' N';
      } else if ( latInitial < 0 ) {
        latString += ' S';
      }

      if ( lngInitial >= 0 ) {
        lngString += ' E';
      } else if ( lngInitial < 0 ) {
        lngString += ' W';
      }

      $( selectors.inputLat ).val( latString ).trigger('updateMirrorInput');
      $( selectors.inputLng ).val( lngString ).trigger('updateMirrorInput');

      lastCoordinates = [latString, lngString];

      previewImage = createBraceletPreview(latString, lngString, currentColor);

      if( previewImage.valid === true) {
        $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', false);
        $(selectors.productCustomCoords).removeClass('bracelet-incomplete').addClass('bracelet-complete');
      } else {
        if(previewImage.code == 'badformat'){
          $(selectors.errorContainer).html(previewImage.message).addClass('visible');
        }
        $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', true);
        $(selectors.container).find(selectors.addToCartBtn).prop('disabled', true);
      }
    };

    var markersSetPosition = function(latlng) {
      for( var i=0 ; i < markers.length ; i++ ) {
        var marker = markers[i];
        marker.setPosition(latlng);
      }
    };

    var mapIsUnlocked = function() {
      return $( selectors.mapLockCheckbox ).first().is(':checked');
    }

    // Initialize map and corresponding events
    google.maps.event.addDomListener(window, 'load', initialize);

    // Event handlers
    $( selectors.inputLocationLookup ).click(function(e){
      if (delayMap && !initialized) {
        $(selectors.mobileMapContainer).slideDown();
        initialized = true;
      }

      e.preventDefault();
      var address = $(this).closest('.custom-coords__input-row').find( '[data-mirror-name="location"]' ).val();
      codeAddress( address );
    });

    /* added for sets */

    $('.unlockCurrentMap').click(function(){
      if($('#map-lock--product-template-set').is(":checked")) {
        $( "#map-lock--product-template-set" ).prop( "checked", false ).attr('checked', false);
        $(this).text('unlock map');
      } else {
        $( "#map-lock--product-template-set" ).prop( "checked", true ).attr('checked', true);
        $(this).text('Lock map');
      }
    })

    $('body').on('change,','.custom-coords__input--latitude, .custom-coords__input--longitude', function(){
      var inputs = $(this).parent().find('.custom-coords__step .inputCoordsBlock');
      var latitude = inputs.find('.custom-coords__input--latitude').val();
      var longitude = inputs.find('.custom-coords__input--longitude').val();  
      if(latitude.length != 0 && longitude.length != 0) {
        createBraceletPreview(latitude, longitude);
      }     
    })
    
    $('body').on('focus','#CustomCoordsInputLocation--product-template-set',function(){
      if($(this).val() == 'Bali, Indonesia') {
        $(this).val('');
      }
    })

    $('.saveCoordinates').click(function(e){
      e.preventDefault();
      var inputs = $('.fancybox-is-open .custom-coords__step .inputCoordsBlock');
      var latitude = inputs.find('.custom-coords__input--latitude').val();
      var longitude = inputs.find('.custom-coords__input--longitude').val();

      if(latitude.length == 0 || longitude.length == 0 ) {

        if(latitude.length == 0) {
          inputs.find('.custom-coords__input--latitude').addClass('red-border');
        } 

        if(longitude.length == 0) {
          inputs.find('.custom-coords__input--longitude').addClass('red-border');
        }

        $('.fancybox-is-open').scrollTop($('#CustomCoordsInputlatitude--product-template-set').offset().top);

      } else {
          var currentBracelet = $('.fancybox-is-open .product__custom-coords').attr('data-layout-nubmer');
          var currentBraceletLayout = $('.coordinatesCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
          var previewImage = $(this).parent().parent().attr('preview-img');
          currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
          currentBraceletLayout.attr('data-preview-src', previewImage);
          currentBraceletLayout.find('.coordsLeft').val(latitude);
          currentBraceletLayout.find('.coordsRight').val(longitude);
          currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
          currentBraceletLayout.find('.getCoordinates').hide();
          currentBraceletLayout.addClass('coordsEntered');
         
          setTimeout(function() { 
            
          $('.coordinatesCustomizer:not(.emptyContainer)').each(function(){
            if($(this).find('.enteredCoordinates .coordsLeft').val().length === 0) {
 
                $(this).find('.customizerImg').attr('src', currentBraceletLayout.attr('data-preview-src'));
                $(this).attr('data-preview-src', currentBraceletLayout.attr('data-preview-src'));
                $(this).find('.coordsLeft').val(latitude);
                $(this).find('.coordsRight').val(longitude);
                $(this).find('.enteredCoordinates').addClass('showFlexdiv');
                $(this).find('.getCoordinates').hide();
                $(this).addClass('coordsEntered'); 

                var currentColor = currentBraceletLayout.find('.colorContainer img.selected').attr('data-color');
                var currentSize = currentBraceletLayout.find('.sizeContainers .customizerContainer.selected').attr('data-size');
                var material =  currentBraceletLayout.find('.materialContainers .customizerContainer.selected').attr('data-material');
  
                $(this).find('.customizerImgContainer img').removeClass('selected');
                $(this).find('.materialContainers .customizerContainer').removeClass('selected');
                $(this).find('.sizeContainers .customizerContainer').removeClass('selected');
                $(this).find('.customizerImgContainer img[data-color="' + currentColor + '"]').addClass('selected');
                $(this).find('.sizeContainers .customizerContainer[data-size="' + currentSize + '"]').addClass('selected');
                $(this).find('.materialContainers .customizerContainer[data-material="' + material + '"]').addClass('selected'); 
                getAvailableColors();
              
            }

          })
          checkFilledData();
         }, 700);


          $('.fancybox-is-open .fancybox-close-small').click();
      }

    })

    $('body').on('click','.getCoordinates',function(e){
      e.preventDefault();
      $('.product__custom-coords').fancybox( {
        
        touch: false,
        autoFocus: false,

        afterClose: function() {
          
          var inputs = $('.custom-coords__step .inputCoordsBlock');
          var latitude = inputs.find('.custom-coords__input--latitude').val();
          var longitude = inputs.find('.custom-coords__input--longitude').val();
    
          if(latitude.length > 0 || longitude.length > 0 ) {
            var currentBracelet = $('.product__custom-coords').attr('data-layout-nubmer');;
            var currentBraceletLayout = $('.coordinatesCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
            var previewImage = $('.product__custom-coords').attr('preview-img');
            currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
            currentBraceletLayout.attr('data-preview-src', previewImage);
            currentBraceletLayout.find('.coordsLeft').val(latitude);
            currentBraceletLayout.find('.coordsRight').val(longitude);
            currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
            currentBraceletLayout.find('.getCoordinates').hide();
            currentBraceletLayout.addClass('coordsEntered');
    
            checkFilledData();
          }       
        }

      }).trigger('click'); 

      if($(window).width() > 767) {
        $('.fancybox-is-open .set-custom-coords').prepend($('.fancybox-is-open .coordsSubtitle'))
        $('.fancybox-is-open .set-custom-coords').prepend($('.fancybox-is-open .currentlauerTitle'))
      }


      $('.currentCoordImg').attr('src', $(this).parent().parent().find('.customizerImg').attr('src'));
      $('.fancybox-is-open #CustomCoordsInputlatitude--product-template-set').val('');
      $('.fancybox-is-open #CustomCoordsInputlongitude--product-template-set').val('');
      var braceletNumber = $(this).parent().parent().attr('data-layout-nubmer');
      $('.product__custom-coords .currentlauerTitle').text('Bracelet '+ braceletNumber);
      $('.product__custom-coords').attr('data-layout-nubmer', braceletNumber);
      $(this).parent().parent().attr('current-color',$(this).parent().parent().find('.chosenColor').text());
      $('.product__custom-coords').attr('current-color', $(this).parent().parent().find('.chosenColor').text());
      //createBraceletPreview('','',$(this).parent().parent().find('.chosenColor').text());
    });

    $('body').on('click','.editCoordinates',function(e) {

      e.preventDefault();

      var lat = $(this).parent().find('.coordsLeft').val();
      var long = $(this).parent().find('.coordsRight').val();
      $('.currentCoordImg').attr('src', $(this).parent().parent().find('.customizerImg').attr('src'))
      $('.product__custom-coords').fancybox({
        
        touch: false,
        autoFocus: false,

        afterClose: function() {
          
          var inputs = $('.custom-coords__step .inputCoordsBlock');
          var latitude = inputs.find('.custom-coords__input--latitude').val();
          var longitude = inputs.find('.custom-coords__input--longitude').val();
    
          if(latitude.length > 0 || longitude.length > 0 ) {
            var currentBracelet = $('.product__custom-coords').attr('data-layout-nubmer');;
            var currentBraceletLayout = $('.coordinatesCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
            var previewImage = $('.product__custom-coords').attr('preview-img');
            currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
            currentBraceletLayout.attr('data-preview-src', previewImage);
            currentBraceletLayout.find('.coordsLeft').val(latitude);
            currentBraceletLayout.find('.coordsRight').val(longitude);
            currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
            currentBraceletLayout.find('.getCoordinates').hide();
            currentBraceletLayout.addClass('coordsEntered');
    
            checkFilledData();
          }       
        }

      }).trigger('click'); 
      var braceletNumber = $(this).parent().parent().attr('data-layout-nubmer');
      $('.product__custom-coords').attr('data-layout-nubmer', braceletNumber);
      $('.fancybox-is-open #CustomCoordsInputlatitude--product-template-set').val(lat);
      $('.fancybox-is-open #CustomCoordsInputlongitude--product-template-set').val(long);
    });
    
    $( selectors.inputLat ).change(function(e){
      if (delayMap && !initialized) {
        $(selectors.mobileMapContainer).slideDown();
        initialized = true;
      }

      codeLatLng($(this));
    });

    $( selectors.inputLng ).change(function(e){
      if (delayMap && !initialized) {
        $(selectors.mobileMapContainer).slideDown();
        initialized = true;
      }

      codeLatLng($(this));
    });

    $( selectors.mobileConfirmCoordinates ).click(function(e){      
          var $container = $(this).closest('.custom-coords');
          var $inputLat = $container.find('[data-mirror-name="properties[Latitude]"]');
          var $inputLng = $container.find('[data-mirror-name="properties[Longitude]"]');

          var sanitizedLatlng = sanitizeInput( $inputLat.val(), $inputLng.val() ),
          lat = sanitizedLatlng[0],
          lng = sanitizedLatlng[1],
          latLng = new google.maps.LatLng(lat, lng);

          for( var i=0 ; i < maps.length ; i++ ) {
            var map = maps[i];
            map.setCenter(latLng)
            map.setZoom(11);
          }

          markersSetPosition( latLng );
          setLatLngFields( lat, lng );
    });

    window.addEventListener('load', function(){
      if( $(selectors.inputLocation).val() !== 'Bali, Indonesia' && $( selectors.inputLat ).val() !== '0.0000° N'){
        $( selectors.inputLat ).trigger('change');
        $( selectors.inputLng ).trigger('change');
      }
    });

    /*
    $( selectors.inputLat, selectors.inputLng ).blur(function(e){
      var isValid = /[0-9]{1,3}.[0-9]{4}[\°\º] [NSWE]/g.test($(this).val());
    })
    */

    $( selectors.btnGetCurrentPosition ).click(function(e){
      e.preventDefault();
      getCurrentPosition();
    });

    $( selectors.inputLocation ).keydown(function(e){
      if( e.keyCode == 13 ) {
        e.preventDefault()
        $( selectors.inputLocationLookup ).first().click();
      }
    });

    $( '#CustomCoordsInputLocation--mobile-configurator' ).keydown(function(e){
      if( e.keyCode == 13 ) {
        e.preventDefault()
        $( selectors.inputLocationLookup ).last().click();
        $('#CustomCoordsInputLocation--mobile-configurator').blur();
      }
    });



    $( selectors.mapLockCheckbox ).change(function(){
      var val = $(this).is(':checked');
      $( selectors.mapLockCheckbox ).prop('checked', val);
    });

    $( selectors.stepContinue ).click(function(e){
      e.preventDefault();
      var currentStep = parseInt( $( selectors.productCustomCoords ).attr('data-current-step') );
      if( $( selectors.container ).filter('[data-step="' + (currentStep+1) + '"]').length ) {
        $( selectors.productCustomCoords ).attr('data-current-step', currentStep+1);
      }
    });

    $( selectors.stepBack ).click(function(e){
      e.preventDefault();
      var currentStep = parseInt( $( selectors.productCustomCoords ).attr('data-current-step') );
      $( selectors.productCustomCoords ).attr('data-current-step', currentStep-1);
    });

    $(selectors.customBundleStepForward).click(function(e) {
      e.preventDefault();
      var $latitudeInput = $('.custom-coords__input--latitude');
      var $longitudeInput = $('.custom-coords__input--longitude');

      if (!$latitudeInput.val() || !$longitudeInput.val()) {
        document.querySelector('.shopify-product-form').reportValidity();
      } else {
        customBundleStepForward();
      }
    });

    var $mobileConfigurator = $('.mobile-configurator');
    if( $mobileConfigurator.length ) {
      $mobileConfigurator.on('focusin', '[data-mirror-name="location"], [data-mirror-name="properties[Latitude]"], [data-mirror-name="properties[Longitude]"]', function(){
        $mobileConfigurator.find( '.custom-coords__input-row--map' ).stop().slideUp('slow');
        $(this).val('').trigger('updateMirrorInput');
      });

      $mobileConfigurator.on('focusout', '[data-mirror-name="location"], [data-mirror-name="properties[Latitude]"], [data-mirror-name="properties[Longitude]"]' , function(){
        $mobileConfigurator.find( '.custom-coords__input-row--map' ).stop().slideDown('slow');
      });
    }
  },
  initDateSet: function() {
    var selectors = {
      container: '.custom-date-set',
      errorContainer: '.custom-date__input-error',
      inputGroup: '.custom-date__input-group',
      input: '.custom-date__input',
      navLinkConfirm: '.mobile-configurator__nav__link--confirm',
      addToCartBtn: '.add_to_cart'
    };

    if( !$( selectors.container ).length ) {
      return;
    }

    var currentColor = '';
    var lastColor = '';
    var lastCustomDate = [];

    var refreshDatePreview = function() {
      if (lastCustomDate.length) {
        lastColor = currentColor;
        createCustomDatePreview(
          lastCustomDate[0],
          lastCustomDate[1],
          lastCustomDate[2],
          currentColor
        );
      }
    };

    var updatePreviewUrl = function (path) {
      /*
      let $slidesToUpdate = $('.flexslider .slides > li');
      let navThumb = $('.flex-control-nav > li');
      let itLoaded = false;
      let firstSlide;
      let secondSlide;
      let index;

      firstSlide = $slidesToUpdate[1];
      secondSlide = $slidesToUpdate[$slidesToUpdate.length - 1];
      index = 0;

      if (firstSlide){
        let $firstImage = $(firstSlide).find('img');
        $(firstSlide).data('thumb', path);
        $firstImage.attr('src', path);
        $firstImage.attr('data-src', path);
        $firstImage.attr('srcset', '');
        $firstImage.attr('data-srcset', '');
        var imageLoading = $firstImage;
        imageLoading.off('load').on('load', function(){
          itLoaded = true;
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        });
      }
      if (secondSlide){
        let $secondImage = $(secondSlide).find('img');
        $(secondSlide).data('thumb', path);
        $secondImage.attr('src', path);
        $secondImage.attr('data-src', path);
        $secondImage.attr('srcset', '');
        $secondImage.attr('data-srcset', '');
      }
      if (navThumb && navThumb.length > index)
        $(navThumb[index]).find('img').attr('src', path);
      var slider = $('.flexslider');
      if (slider) {
        slider.flexslider(index);
      }

      $('.mobile-configurator__panel__body .custom-date__input-bg').css('background-image', 'url(' + path + ')');

      setTimeout(function() {
        // fallback in case it's taking too slow to load the first image
        if (!itLoaded){
          $('.product_gallery').removeClass('is-loading');
          $('.swatch_options').removeClass('is-loading');
        }
      }, 3000);
      */
    };

    var cache = {};

    var braceletBaseUrl = 'https://w.sellry.com/beaded-date-preview';

    var createCustomDatePreview = function (left, right, bottom, color) {

      if (!color) {
        var color =  $('.fancybox-is-open .product__custom-date').attr('current-color');
      }

      //$('.product_gallery').addClass('is-loading');
      //$('.swatch_options').addClass('is-loading');

      var cacheKey = left + right + bottom + color;

      // Don't wait for response to assign the preview url
      var path = encodeURI(braceletBaseUrl + '/?' +
                'left='+left+'&'+
                'right='+right+'&'+
                'bottom='+bottom+'&'+
                'color='+color+'&'+
                'action=preview');

      $('.bracelet-preview-url').attr('value', path);


      if(left.length >= 1 && right.length >= 1 && bottom.length >= 1 ) {
      $.ajax({
        url: braceletBaseUrl + '/',
        dataType: 'json',
        cache: false,
        type: 'get',
        data: {left: left, right: right, bottom: bottom, color: color, action: 'preview'},
        error: function(xhr) {
          var contentType = xhr.getResponseHeader("Content-Type");
          if(contentType !== 'image/jpeg') {
            $('.product_gallery').removeClass('is-loading');
            $('.swatch_options').removeClass('is-loading');
          }
        },
        complete: function(xhr) {
          var contentType = xhr.getResponseHeader("Content-Type");
          if(contentType === 'image/jpeg') {

            $('.fancybox-is-open .product__custom-date').attr('preview-img', path);
            if($('.fancybox-is-open .currentCoordImg').attr('src') == null) {
              $('.fancybox-is-open .currentCoordImg').attr('src', path);
            }
            if(left != null && right != null && bottom != null) {
              $('.currentCoordImg').attr('src',path);
            }

            /*setTimeout(function(){
              updatePreviewUrl(path);
            }, 500);*/
          } else {
            $('.product_gallery').removeClass('is-loading');
            $('.swatch_options').removeClass('is-loading');
          }
        }
      });

      }

      
    };

    /* added for set */

    $('.saveDate').click(function(e){
      e.preventDefault();
      var inputs = $(this).parent().find('.inputDateBlock');
      var firstDate = inputs.find('.custom-date__input1').val();
      var secondDate = inputs.find('.custom-date__input2').val();
      var thirdDate = inputs.find('.custom-date__input3').val();

      if(firstDate.length == 0 || secondDate.length == 0 || thirdDate.length == 0 ) {

        if(firstDate.length == 0) {
          inputs.find('.custom-date__input1').addClass('red-border');
        } 

        if(secondDate.length == 0) {
          inputs.find('.custom-date__input2').addClass('red-border');
        }

        if(thirdDate.length == 0) {
          inputs.find('.custom-date__input2').addClass('red-border');
        }

        $('.fancybox-is-open').scrollTop($('#CustomDateInput1--product-template-set').offset().top);

      } else {
          var currentBracelet = $(this).parent().parent().attr('data-layout-nubmer');
          var currentBraceletLayout = $('.dateCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
          var previewImage = $(this).parent().parent().attr('preview-img');
          currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
          currentBraceletLayout.attr('data-preview-src', previewImage);
          currentBraceletLayout.find('.dateLeft').val(firstDate);
          currentBraceletLayout.find('.dateRight').val(secondDate);
          currentBraceletLayout.find('.dateBottom').val(thirdDate);
          currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
          currentBraceletLayout.find('.getDate').hide();
          currentBraceletLayout.addClass('dateEntered');

          setTimeout(function() { 
            $('.dateCustomizer:not(.emptyContainer)').each(function(){

              if($(this).find('.enteredCoordinates .dateLeft').val().length === 0) {
                $(this).find('.customizerImg').attr('src', currentBraceletLayout.attr('data-preview-src'));
                $(this).attr('data-preview-src', currentBraceletLayout.attr('data-preview-src'));
                $(this).find('.dateLeft').val(firstDate);
                $(this).find('.dateRight').val(secondDate);
                $(this).find('.dateBottom').val(thirdDate);
                $(this).find('.enteredCoordinates').addClass('showFlexdiv');
                $(this).find('.getDate').hide();
                $(this).addClass('dateEntered'); 
                
                var currentColor = currentBraceletLayout.find('.colorContainer img.selected').attr('data-color');
                var currentSize = currentBraceletLayout.find('.sizeContainers .customizerContainer.selected').attr('data-size');
                var material =  currentBraceletLayout.find('.materialContainers .customizerContainer.selected').attr('data-material');
  
                $(this).find('.customizerImgContainer img').removeClass('selected');
                $(this).find('.materialContainers .customizerContainer').removeClass('selected');
                $(this).find('.sizeContainers .customizerContainer').removeClass('selected');
                $(this).find('.customizerImgContainer img[data-color="' + currentColor + '"]').addClass('selected');
                $(this).find('.sizeContainers .customizerContainer[data-size="' + currentSize + '"]').addClass('selected');
                $(this).find('.materialContainers .customizerContainer[data-material="' + material + '"]').addClass('selected'); 
                getAvailableColors();
              }

            })
            checkFilledData();
          }, 700);


          $('.fancybox-is-open .fancybox-close-small').click();
      }

    })

    $('body').on('focus','.custom-date__input1',function() {
      $('.topLeftTip').show();
      $('.topRightTip, .bottomTip').hide();
      $('.underscores').removeClass('focused');
      $(this).parent().addClass('focused');
    })

    $('body').on('focus','.custom-date__input2',function() {
      $('.topRightTip').show();
      $('.topLeftTip, .bottomTip').hide();
      $('.underscores').removeClass('focused');
      $(this).parent().addClass('focused');
    })

    $('body').on('focus','.custom-date__input3',function() {
      $('.bottomTip').show();
      $('.topLeftTip, .topRightTip').hide();
      $('.underscores').removeClass('focused');
      $(this).parent().addClass('focused');
    })

    $('body').on('click','.getDate',function(e){
      e.preventDefault();
      $('.product__custom-date').fancybox( 
        { 
          touch: {
            vertical: false, // Allow to drag content vertically
            momentum: false // Continue movement after releasing mouse/touch when panning
          },
          afterClose: function() {
          
            var inputs = $('.custom-date__step');
            var firstDate = inputs.find('.custom-date__input1').val();
            var secondDate = inputs.find('.custom-date__input2').val();
            var thirdDate = inputs.find('.custom-date__input3').val();
      
            if(firstDate.length != 0 && secondDate.length != 0 && thirdDate.length != 0 ) {
              var currentBracelet = $('.product__custom-date').attr('data-layout-nubmer');
              var currentBraceletLayout = $('.dateCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
              var previewImage =  $('.product__custom-date').attr('preview-img');
              currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
              currentBraceletLayout.attr('data-preview-src', previewImage);
              currentBraceletLayout.find('.dateLeft').val(firstDate);
              currentBraceletLayout.find('.dateRight').val(secondDate);
              currentBraceletLayout.find('.dateBottom').val(thirdDate);
              currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
              currentBraceletLayout.find('.getDate').hide();
              currentBraceletLayout.addClass('dateEntered');
      
              checkFilledData();
            }       
          } 
        } 
      ).trigger('click');

      if($(window).width() > 767) {
        $('.fancybox-is-open .custom-date-set').prepend($('.fancybox-is-open .coordsSubtitle'))
        $('.fancybox-is-open .custom-date-set').prepend($('.fancybox-is-open .currentlauerTitle'))
      }

      $('.product__custom-date .currentCoordImg').attr('src', null);
      //$('.currentCoordImg').attr('src', $(this).parent().parent().find('.customizerImg').attr('src'))  
      var braceletNumber = $(this).parent().parent().attr('data-layout-nubmer');
      $(this).parent().parent().attr('current-color',$(this).parent().parent().find('.chosenColor').text());
      $('.product__custom-date').attr('current-color', $(this).parent().parent().find('.chosenColor').text());
      createCustomDatePreview('12','10','2015',$(this).parent().parent().find('.chosenColor').text());
      $('.currentCoordImg').attr('src', $('.product__custom-date').attr('preview-img'));
      $('.product__custom-date').attr('data-layout-nubmer', braceletNumber);
      $('.product__custom-date .currentlauerTitle').text('Bracelet '+ braceletNumber);
      $('.fancybox-is-open .custom-date__input1').val('');
      $('.fancybox-is-open .custom-date__input2').val('');
      $('.fancybox-is-open .custom-date__input3').val('');

    });

    $('body').on('click','.editDate',function(e) {

      e.preventDefault();

      var d1 = $(this).parent().find('.dateLeft').val();
      var d2 = $(this).parent().find('.dateRight').val(); 
      var d3 = $(this).parent().find('.dateBottom').val();
      $('.product__custom-date .currentCoordImg').attr('src', null);
      createCustomDatePreview(d1,d2,d3,$(this).parent().parent().find('.chosenColor').text());
      $('.product__custom-date').fancybox({ 
        touch: {
          vertical: false, // Allow to drag content vertically
          momentum: false // Continue movement after releasing mouse/touch when panning
        },
        afterClose: function() {
        
          var inputs = $('.custom-date__step');
          var firstDate = inputs.find('.custom-date__input1').val();
          var secondDate = inputs.find('.custom-date__input2').val();
          var thirdDate = inputs.find('.custom-date__input3').val();
    
          if(firstDate.length != 0 && secondDate.length != 0 && thirdDate.length != 0 ) {
            var currentBracelet = $('.product__custom-date').attr('data-layout-nubmer');
            var currentBraceletLayout = $('.dateCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
            var previewImage =  $('.product__custom-date').attr('preview-img');
            currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
            currentBraceletLayout.attr('data-preview-src', previewImage);
            currentBraceletLayout.find('.dateLeft').val(firstDate);
            currentBraceletLayout.find('.dateRight').val(secondDate);
            currentBraceletLayout.find('.dateBottom').val(thirdDate);
            currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
            currentBraceletLayout.find('.getDate').hide();
            currentBraceletLayout.addClass('dateEntered');
    
            checkFilledData();
          }       
        } 
      }).trigger('click'); 
      var braceletNumber = $(this).parent().parent().attr('data-layout-nubmer');
      $('.product__custom-date').attr('data-layout-nubmer', braceletNumber);
      $('.fancybox-is-open .custom-date__input1').val(d1);
      $('.fancybox-is-open .custom-date__input2').val(d2);
      $('.fancybox-is-open .custom-date__input3').val(d3);

    });

    var $customDateInput = $( selectors.input );

    var handleReloadImage = function(input) {
      var customDateElements = input.closest('.custom-date__input-groups').find(selectors.input);
      if (customDateElements && customDateElements.length >= 1) {
        var left = $(customDateElements[0]).val() || '',
            right = $(customDateElements[1]).val() || '',
            bottom = $(customDateElements[2]).val() || '';

        if(left.length >= 1 && right.length >= 1 && bottom.length >= 1) {
          lastCustomDate = [left, right, bottom];
          createCustomDatePreview(left, right, bottom, currentColor);
          return {
              valid : true,
              message : 'Preview image has been generated'
          };
        } else {
          lastCustomDate = [left, right, bottom];
          createCustomDatePreview(left, right, bottom, currentColor);
          return {
              valid : false,
              code : 'incomplete',
              message : 'Looks like you are entering less characters'
          };
        }
      }

      return {
        valid : false,
        code : 'general',
        message : 'Something went wrong while generating the preview image'
      };
    };

    $customDateInput.on('keydown', function(event) {
      // Prevent shift key since its not needed
      if (event.shiftKey == true) {
        event.preventDefault();
      }
      // Allow Only: keyboard 0-9, numpad 0-9, backspace, tab, left arrow, right arrow, delete
      if ((event.keyCode >= 48 && event.keyCode <= 57) || (event.keyCode >= 96 && event.keyCode <= 105) || event.keyCode == 8 || event.keyCode == 9 || event.keyCode == 37 || event.keyCode == 39 || event.keyCode == 46) {
      // Allow normal operation

      var $nextInput = $(this).closest( '.underscores' ).next().find( selectors.input );
      var $prevInput = $(this).closest( '.underscores' ).prev().find( selectors.input );

      switch(event.which) {
        case 37: // left
        $prevInput.focus();
        break;

        case 38: // up
        $nextInput.focus();
        break;

        case 39: // right
        $nextInput.focus();
        break;

        case 40: // down
        $prevInput.focus();
        break;

      }

      } else {
        // Prevent the rest
        event.preventDefault();
      }
    });

    $customDateInput.on('keyup', function(){
      lastCustomDate = [];

      var val = $(this).val();
      var name = $(this).attr('name');

      var parsedNum = parseInt(val, 10);

      if (isNaN(parseInt(val, 10)) === true || parsedNum < 0) {
        val = '';
      }

      $customDateInput.filter('[name="' + name + '"]').val( val ).trigger('updateMirrorInput');

      if (val == '' || /^\d+$/.test(val) === false) {
        $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', true);
        return;
      }

      $(selectors.errorContainer).html('').removeClass('visible');

      var $nextInput = $(this).closest( '.underscores' ).next().find( selectors.input );

      var maxLength = parseInt($(this).attr('maxLength'), 10);

      if( maxLength === val.length && $nextInput.length ) {
        $nextInput.focus();
      }

      if(val.length > maxLength) {
        $(this).val( $(this).val().substr(0, maxLength) );
        return;
      }

      previewImage = handleReloadImage($(this));

      if(!previewImage.valid) {
        if(previewImage.code == 'incomplete'){
            $(selectors.addToCartBtn).prop('disabled', false);
            $(selectors.navLinkConfirm).prop('disabled', false);
        }
        return;
      }

      $('body').trigger('braceletcomplete');
    }).trigger('keyup');
  },
  initCrossedSet: function() {

    var selectors = {
      container: '.crossed-paths-set',
      inputGroup: '.crossed-paths__input-group',
      input: '.crossed-paths__input',
      customBundleStepBack: '.product__custom__prev',
      navLinkConfirm: '.mobile-configurator__nav__link--confirm'
    };

    if( !$( selectors.container ).length  ) {
      return;
    }

    var currentColor = '';
    var lastInitials = []; // left, right, up, down

 
    $('body').on( 'selectCallback', function( event, variant ) {
      if( !variant ) {
        return;
      }

      currentColor = variant.option2;

      if( lastInitials.length ){
        createCrossedPathPreview(
          lastInitials[0],
          lastInitials[1],
          lastInitials[2],
          lastInitials[3],
          currentColor
        );
      }
    });

    var customBundleStepBack = function() {
      var $customFormContainer = $('.product__custom');
      var $customCoordinates = $('.product__custom-coords');
      var $customCrossedPaths = $('.product__crossed-paths');
      var currentStep = parseInt($customFormContainer.attr('data-current-step'));

      // Lock form container height
      $customFormContainer.css('height', $customCrossedPaths.outerHeight());
      // Fade first step out and animate container height to height of second step
      $customCrossedPaths.fadeOut(400, function() {
        $customFormContainer.animate({
          'height': $customCoordinates.outerHeight()
        }, 400, function() {
          // Update current step
          $customFormContainer.attr('data-current-step', currentStep - 1);
          // Unlock first step
          $customCrossedPaths.removeClass('is-locked');
          // Fade in second step, lock it in place and reset container height
          $customCoordinates.fadeIn(400, function() {
            $customCoordinates.addClass('is-locked');
            $customFormContainer.css('height', '');
          });
        });
      });
    };

    var updatePreviewUrl = function (path) {

    };

    // Keys will be concatenated values of left, right, up, down, color
    var cache = {};

    var createCrossedPathPreview = function (left, right, up, down, color) {

      if (!color) {
        var color =  $('.fancybox-is-open .product__custom-initials').attr('current-color');
      }
      

      // Don't wait for response to assign the preview url
      var path = encodeURI('https://w.sellry.com/beaded-crossed-preview/?'+
                'left='+left+'&'+
                'right='+right+'&'+
                'up='+up+'&'+
                'down='+down+'&'+
                'color='+color+'&'+
                'action=preview');
      $('.bracelet-preview-url').attr('value', path);


      $.ajax({
        url: 'https://w.sellry.com/beaded-crossed-preview/',
        dataType: 'json',
        cache: false,
        type: 'get',
        data: {left: left, right: right, up: up, down: down, color: color, action: 'preview'},
        error: function(xhr) {
          var contentType = xhr.getResponseHeader("Content-Type");
          if(contentType !== 'image/jpeg') {
            $('.product_gallery').removeClass('is-loading');
            $('.swatch_options').removeClass('is-loading');
          }
        },
        complete: function(xhr) {
          var contentType = xhr.getResponseHeader("Content-Type");
          if(contentType === 'image/jpeg') {
            $('.fancybox-is-open .product__custom-initials').attr('preview-img', path);
            if($('.fancybox-is-open .currentCoordImg').attr('src') == null) {
              $('.fancybox-is-open .currentCoordImg').attr('src', path);
            }
            if(left != null && right != null && up != null & down != null) {
              $('.fancybox-is-open .currentCoordImg').attr('src',path);
            }
          } else {
            $('.product_gallery').removeClass('is-loading');
            $('.swatch_options').removeClass('is-loading');
          }
        }
      });
      
      
      return {
        valid : true,
        message : 'Preview image has been generated'
      };
    }

    /* added for set */

    $('.saveInitials').click(function(e){
    e.preventDefault();
    var inputs = $(this).parent().find('.inputInitialsBlock');
    var firstInitial = inputs.find('.custom_initial_input1').val();
    var secondInitial = inputs.find('.custom_initial_input2').val();
    var thirdInitial = inputs.find('.custom_initial_input3').val();
    var forthInitial = inputs.find('.custom_initial_input4').val();

    if(firstInitial.length == 0 || secondInitial.length == 0 || thirdInitial.length == 0 || forthInitial.length == 0) {

      if(firstDate.length == 0) {
        inputs.find('.custom-date__input1').addClass('red-border');
      } 

      if(secondDate.length == 0) {
        inputs.find('.custom-date__input2').addClass('red-border');
      }

      if(thirdDate.length == 0) {
        inputs.find('.custom-date__input3').addClass('red-border');
      }

      if(forthInitial.length == 0) {
        inputs.find('.custom-date__input4').addClass('red-border');
      }

      $('.fancybox-is-open').scrollTop($('#CrossedPathsInput1--product-template-set').offset().top);

    } else {
        var currentBracelet = $(this).parent().attr('data-layout-nubmer');
        var currentBraceletLayout = $('.initialsCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
        var previewImage = $(this).parent().attr('preview-img');
        currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
        currentBraceletLayout.attr('data-preview-src', previewImage);
        currentBraceletLayout.find('.initial1').val(firstInitial);
        currentBraceletLayout.find('.initial2').val(secondInitial);
        currentBraceletLayout.find('.initial3').val(thirdInitial);
        currentBraceletLayout.find('.initial4').val(forthInitial);
        currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
        currentBraceletLayout.find('.getInitials').hide();
        currentBraceletLayout.addClass('initialsEntered');

        $('.initialsCustomizer:not(.emptyContainer)').each(function(){

          if($(this).find('.enteredCoordinates .initial1').val().length === 0) {
            $(this).find('.customizerImg').attr('src',previewImage);
            $(this).attr('data-preview-src', previewImage);
            $(this).find('.initial1').val(firstInitial);
            $(this).find('.initial2').val(secondInitial);
            $(this).find('.initial3').val(thirdInitial);
            $(this).find('.initial4').val(forthInitial);
            $(this).find('.enteredCoordinates').addClass('showFlexdiv');
            $(this).find('.getInitials').hide();
            $(this).addClass('initialsEntered'); 
            
            var currentColor = currentBraceletLayout.find('.colorContainer img.selected').attr('data-color');
            var currentSize = currentBraceletLayout.find('.sizeContainers .customizerContainer.selected').attr('data-size');
            var material =  currentBraceletLayout.find('.materialContainers .customizerContainer.selected').attr('data-material');

            $(this).find('.customizerImgContainer img').removeClass('selected');
            $(this).find('.materialContainers .customizerContainer').removeClass('selected');
            $(this).find('.sizeContainers .customizerContainer').removeClass('selected');
            $(this).find('.customizerImgContainer img[data-color="' + currentColor + '"]').addClass('selected');
            $(this).find('.sizeContainers .customizerContainer[data-size="' + currentSize + '"]').addClass('selected');
            $(this).find('.materialContainers .customizerContainer[data-material="' + material + '"]').addClass('selected'); 
            getAvailableColors();
          }

        })

        checkFilledData();
        $('.fancybox-is-open .fancybox-close-small').click();
    }

  })

  $('body').on('focus','.custom_initial_input1, .custom_initial_input2',function() {
    $('.LeftTip, .RightTip').show();
    $('.topTip, .bottomTip').hide();
    $('.crossed-paths__input-group').removeClass('focusedDiv');
    $(this).parent().addClass('focusedDiv');

  })

  $('body').on('focus','.custom_initial_input3, .custom_initial_input4',function() {
    $('.LeftTip, .RightTip').hide();
    $('.topTip, .bottomTip').show();
    $('.crossed-paths__input-group').removeClass('focusedDiv');
    $(this).parent().addClass('focusedDiv');
  })

  $('body').on('click','.getInitials',function(e){
    e.preventDefault();
    //$('.currentCoordImg').attr('src', $(this).parent().parent().find('.customizerImg').attr('src'))

    $('.product__custom-initials').fancybox({
      afterClose: function() {
          
        var inputs = $('.crossed-paths__step');
        var firstInitial = inputs.find('.custom_initial_input1').val();
        var secondInitial = inputs.find('.custom_initial_input2').val();
        var thirdInitial = inputs.find('.custom_initial_input3').val();
        var forthInitial = inputs.find('.custom_initial_input4').val();


  
        if(firstInitial.length != 0 && secondInitial.length != 0 && thirdInitial.length != 0 && forthInitial.length != 0 ) {

          var currentBracelet = $('.product__custom-initials').attr('data-layout-nubmer');
          var currentBraceletLayout = $('.initialsCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
          var previewImage =  $('.product__custom-initials').attr('preview-img');
          currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
          currentBraceletLayout.attr('data-preview-src', previewImage);
          currentBraceletLayout.find('.initial1').val(firstInitial);
          currentBraceletLayout.find('.initial2').val(secondInitial);
          currentBraceletLayout.find('.initial3').val(thirdInitial);
          currentBraceletLayout.find('.initial4').val(forthInitial);
          currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
          currentBraceletLayout.find('.getInitials').hide();
          currentBraceletLayout.addClass('initialsEntered');
  
          checkFilledData();
        }       
      }
    }).trigger('click');

    if($(window).width() > 767) {
      $('.fancybox-is-open .crossed-paths-set').prepend($('.fancybox-is-open .coordsSubtitle'))
      $('.fancybox-is-open .crossed-paths-set').prepend($('.fancybox-is-open .currentlauerTitle'))
    }

    $('.product__custom-initials .currentCoordImg').attr('src', null);

    $(this).parent().parent().attr('current-color',$(this).parent().parent().find('.chosenColor').text());
    $('.product__custom-initials').attr('current-color', $(this).parent().parent().find('.chosenColor').text());

    //$('.currentCoordImg').attr('src', $('.product__custom-initials').attr('preview-img'));
    $('.custom_initial_input1').val('');
    $('.custom_initial_input2').val('');
    $('.custom_initial_input3').val('');
    $('.custom_initial_input4').val('');
    createCrossedPathPreview('B','K','C','R',$(this).parent().parent().find('.chosenColor').text());
    var braceletNumber = $(this).parent().parent().attr('data-layout-nubmer');
    $('.product__custom-initials .currentlauerTitle').text('Bracelet '+ braceletNumber);
    $('.product__custom-initials').attr('data-layout-nubmer', braceletNumber);
  

  });

  $('body').on('click','.editInitials',function(e) {

    e.preventDefault();

    var i1 = $(this).parent().find('.initial1').val();
    var i2 = $(this).parent().find('.initial2').val(); 
    var i3 = $(this).parent().find('.initial3').val();
    var i4 = $(this).parent().find('.initial4').val();

    //$('.product__custom-initials .currentCoordImg').attr('src', null);
    $('.product__custom-initials').fancybox({
      afterClose: function() {
          
        var inputs = $('.crossed-paths__step');
        var firstInitial = inputs.find('.custom_initial_input1').val();
        var secondInitial = inputs.find('.custom_initial_input2').val();
        var thirdInitial = inputs.find('.custom_initial_input3').val();
        var forthInitial = inputs.find('.custom_initial_input4').val();


  
        if(firstInitial.length != 0 && secondInitial.length != 0 && thirdInitial.length != 0 && forthInitial.length != 0 ) {

          var currentBracelet = $('.product__custom-initials').attr('data-layout-nubmer');
          var currentBraceletLayout = $('.initialsCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
          var previewImage =  $('.product__custom-initials').attr('preview-img');
          currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
          currentBraceletLayout.attr('data-preview-src', previewImage);
          currentBraceletLayout.find('.initial1').val(firstInitial);
          currentBraceletLayout.find('.initial2').val(secondInitial);
          currentBraceletLayout.find('.initial3').val(thirdInitial);
          currentBraceletLayout.find('.initial4').val(forthInitial);
          currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
          currentBraceletLayout.find('.getInitials').hide();
          currentBraceletLayout.addClass('initialsEntered');
  
          checkFilledData();
        }       
      }
    }).trigger('click');
    $(this).parent().parent().attr('current-color',$(this).parent().parent().find('.chosenColor').text());
    $('.product__custom-initials').attr('current-color', $(this).parent().parent().find('.chosenColor').text());
    createCrossedPathPreview(i1,i2, i3,i4,$(this).parent().parent().find('.chosenColor').text());

 
    var braceletNumber = $(this).parent().parent().attr('data-layout-nubmer');
    $('.product__custom-initials').attr('data-layout-nubmer', braceletNumber);
    $('.fancybox-is-open .custom_initial_input1').val(i1);
    $('.fancybox-is-open .custom_initial_input2').val(i2);
    $('.fancybox-is-open .custom_initial_input3').val(i3);
    $('.fancybox-is-open .custom_initial_input4').val(i4);

  });
  

    var $crossedPathsInput = $( selectors.input );
    $crossedPathsInput.on('keyup', function(event){
      lastInitials = [];


      if ($(this).val().length >= 1) {
        $(this).val($(this).val().substr(0, 1));
      }

      var val = String.fromCharCode(event.which).replace(/[^a-zA-Z]/g, '').toUpperCase();
      
      if(val == '') {
        val = $(this).val();
      }
      
      // Disallow any emoji input, arrow keys & blank space
      
      if ([37, 38, 39, 40, 32].indexOf(event.keyCode) > -1 || event.keyCode == 32) {

        if(event.keyCode == 37 || event.keyCode == 38) {
          
          var currentIndex = parseInt($('.fancybox-is-open .crossed-paths__input ').index(this));
          var $nextInput = $('.fancybox-is-open .custom_initial_input'+currentIndex);
    
          if( $nextInput.length ) {
            $nextInput.focus();
          }         
        }

        else {
          var currentIndex = parseInt($('.fancybox-is-open .crossed-paths__input ').index(this));
          currentIndex = currentIndex + 2;
          var $nextInput = $('.fancybox-is-open .custom_initial_input'+currentIndex);
    
          if( $nextInput.length ) {
            $nextInput.focus();
          }
        }

        return;
      }

      if( val == '' ) {
        return;
      }

      $(this).val(val.clearEmojis());

      var currentIndex = parseInt($('.fancybox-is-open .crossed-paths__input ').index(this));
      currentIndex = currentIndex + 2;
      var $nextInput = $('.fancybox-is-open .custom_initial_input'+currentIndex);

      if( $nextInput.length ) {
        $nextInput.focus();
      }
      var crossedElements = $(this).closest('.crossed-paths__input-groups').find(selectors.input);
      if (crossedElements && crossedElements.length === 4) {
        var left = $(crossedElements[0]).val() || '',
            right = $(crossedElements[1]).val() || '',
            up = $(crossedElements[2]).val() || '',
            down = $(crossedElements[3]).val() || '';
        if (left && right && up && down){
          lastInitials = [left, right, up, down];
          previewImage = createCrossedPathPreview(left, right, up, down, currentColor);

          if( previewImage.valid === true) {
            $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', false);
            $('body').trigger('braceletcomplete');
          } else {
            if(previewImage.code == 'badformat'){
                $(selectors.errorContainer).html(previewImage.message).addClass('visible');
            }
            $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', true);
            $(selectors.container).find(selectors.addToCartBtn).prop('disabled', true);
          }
        } else {
          $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', true);
        }
      }

    }).trigger('keyup');

    $(selectors.customBundleStepBack).click(function(e) {
      e.preventDefault();
      customBundleStepBack();
    });
  },
  initHeartSet: function() {

    var selectors = {
      container: '.heart-set',
      inputGroup: '.crossed-paths__input-group',
      input: '.beaded_heart_input',
      customBundleStepBack: '.product__custom__prev',
      navLinkConfirm: '.mobile-configurator__nav__link--confirm'
    };

    if( !$( selectors.container ).length  ) {
      return;
    }

    var currentColor = '';
    var lastInitials = []; // left, right, up, down

 
    $('body').on( 'selectCallback', function( event, variant ) {
      if( !variant ) {
        return;
      }

      currentColor = $('.fancybox-is-open .product__custom-heart').attr('current-color');

      if( lastInitials.length ){
        createCrossedPathPreview(
          lastInitials[0],
          lastInitials[1],
          lastInitials[2],
          lastInitials[3],
          currentColor
        );
      }
    });

    var customBundleStepBack = function() {
      var $customFormContainer = $('.product__custom');
      var $customCoordinates = $('.product__custom-coords');
      var $customCrossedPaths = $('.product__crossed-paths');
      var currentStep = parseInt($customFormContainer.attr('data-current-step'));

      // Lock form container height
      $customFormContainer.css('height', $customCrossedPaths.outerHeight());
      // Fade first step out and animate container height to height of second step
      $customCrossedPaths.fadeOut(400, function() {
        $customFormContainer.animate({
          'height': $customCoordinates.outerHeight()
        }, 400, function() {
          // Update current step
          $customFormContainer.attr('data-current-step', currentStep - 1);
          // Unlock first step
          $customCrossedPaths.removeClass('is-locked');
          // Fade in second step, lock it in place and reset container height
          $customCoordinates.fadeIn(400, function() {
            $customCoordinates.addClass('is-locked');
            $customFormContainer.css('height', '');
          });
        });
      });
    };

    var updatePreviewUrl = function (path) {

    };

    // Keys will be concatenated values of left, right, up, down, color
    var cache = {};

    var createHeartPreview = function (up, middle, down, color) {

      if (!color || color.length < 2) {
        var color =  $('.fancybox-is-open .product__custom-heart').attr('current-color');
      }

      middle = encodeURIComponent(middle);
      up = encodeURIComponent(up);
      down = encodeURIComponent(down);

     

      // Don't wait for response to assign the preview url
      var path = encodeURI('https://w.sellry.com/beaded-winged-heart-preview/?'+
                'middle='+middle+'&'+
                'up='+up+'&'+
                'down='+down+'&'+
                'color='+color+'&'+
                'action=preview');
                
      $('.bracelet-preview-url').attr('value', path);


      $.ajax({
        url: 'https://w.sellry.com/beaded-winged-heart-preview/',
        dataType: 'json',
        cache: false,
        type: 'get',
        data: { up: up, middle: middle, down: down, color: color, action: 'preview'},
        error: function(xhr) {
          var contentType = xhr.getResponseHeader("Content-Type");
          if(contentType !== 'image/jpeg') {
            $('.product_gallery').removeClass('is-loading');
            $('.swatch_options').removeClass('is-loading');
          }
        },
        complete: function(xhr) {
          var contentType = xhr.getResponseHeader("Content-Type");
          if(contentType === 'image/jpeg') {
            $('.fancybox-is-open .product__custom-heart').attr('preview-img', path);
            if($('.fancybox-is-open .currentCoordImg').attr('src') == null) {
              $('.fancybox-is-open .currentCoordImg').attr('src', path);
            }
            if(middle != null && up != null & down != null) {
              $('.fancybox-is-open .currentCoordImg').attr('src',path);
            }
          } else {
            $('.product_gallery').removeClass('is-loading');
            $('.swatch_options').removeClass('is-loading');
          }
        }
      });
      
      
      return {
        valid : true,
        message : 'Preview image has been generated'
      };
    }

    /* added for set */

    $('.saveHeart').click(function(e){
    e.preventDefault();
    var inputs = $(this).parent().find('.inputInitialsBlock');
    var firstInitial = inputs.find('.custom_initial_input1').val();
    var secondInitial = inputs.find('.custom_initial_input2').val();
    var thirdInitial = inputs.find('.custom_initial_input3').val();

    if(firstInitial.length == 0 || secondInitial.length == 0 || thirdInitial.length == 0 ) {

      if(firstDate.length == 0) {
        inputs.find('.custom_initial_input1').addClass('red-border');
      } 

      if(secondInitial.length == 0) {
        inputs.find('.custom_initial_input2').addClass('red-border');
      }

      if(thirdInitial.length == 0) {
        inputs.find('.custom_initial_input3').addClass('red-border');
      }


      $('.fancybox-is-open').scrollTop($('#CrossedPathsInput1--product-template-set').offset().top);

    } else {
        var currentBracelet = $(this).parent().attr('data-layout-nubmer');
        var currentBraceletLayout = $('.heartCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
        var previewImage = $(this).parent().attr('preview-img');
        currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
        currentBraceletLayout.attr('data-preview-src', previewImage);
        currentBraceletLayout.find('.up').val(firstInitial);
        currentBraceletLayout.find('.middle').val(secondInitial);
        currentBraceletLayout.find('.down').val(thirdInitial);
        currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
        currentBraceletLayout.find('.getHeart').hide();
        currentBraceletLayout.addClass('initialsEntered');

        setTimeout(function() { 

        $('.heartCustomizer:not(.emptyContainer)').each(function(){

          if($(this).find('.enteredCoordinates .up').val().length === 0) {
            $(this).find('.customizerImg').attr('src',previewImage);
            $(this).attr('data-preview-src', previewImage);
            $(this).find('.up').val(firstInitial);
            $(this).find('.middle').val(secondInitial);
            $(this).find('.down').val(thirdInitial);
            $(this).find('.enteredCoordinates').addClass('showFlexdiv');
            $(this).find('.getHeart').hide();
            $(this).addClass('initialsEntered'); 
            
            var currentColor = currentBraceletLayout.find('.colorContainer img.selected').attr('data-color');
            var currentSize = currentBraceletLayout.find('.sizeContainers .customizerContainer.selected').attr('data-size');
            var material =  currentBraceletLayout.find('.materialContainers .customizerContainer.selected').attr('data-material');

            $(this).find('.customizerImgContainer img').removeClass('selected');
            $(this).find('.materialContainers .customizerContainer').removeClass('selected');
            $(this).find('.sizeContainers .customizerContainer').removeClass('selected');
            $(this).find('.customizerImgContainer img[data-color="' + currentColor + '"]').addClass('selected');
            $(this).find('.sizeContainers .customizerContainer[data-size="' + currentSize + '"]').addClass('selected');
            $(this).find('.materialContainers .customizerContainer[data-material="' + material + '"]').addClass('selected'); 
            getAvailableColors();
          }

        })

        checkFilledData();
        }, 700);
        $('.fancybox-is-open .fancybox-close-small').click();
    }

  })

  $('body').on('click','.getHeart',function(e){
    e.preventDefault();
    //$('.currentCoordImg').attr('src', $(this).parent().parent().find('.customizerImg').attr('src'))

    $('.product__custom-heart').fancybox(
      { 
        touch: false, 
        beforeShow: function(){
          $("body").css({'overflow-y':'hidden'});
        },
        afterClose: function(){
            $("body").css({'overflow-y':'visible'});

            var inputs = $('.heart-set');
            var firstInitial = inputs.find('.custom_initial_input1').val();
            var secondInitial = inputs.find('.custom_initial_input2').val();
            var thirdInitial = inputs.find('.custom_initial_input3').val();
      
            if(firstInitial.length != 0 && secondInitial.length != 0 && thirdInitial.length != 0 ) {
    
              var currentBracelet = $('.product__custom-heart').attr('data-layout-nubmer');
              var currentBraceletLayout = $('.heartCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
              var previewImage =  $('.product__custom-heart').attr('preview-img');
              currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
              currentBraceletLayout.attr('data-preview-src', previewImage);
              currentBraceletLayout.find('.up').val(firstInitial);
              currentBraceletLayout.find('.middle').val(secondInitial);
              currentBraceletLayout.find('.down').val(thirdInitial);
              currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
              currentBraceletLayout.find('.getHeart').hide();
              currentBraceletLayout.addClass('initialsEntered');
      
              checkFilledData();
            }       
            
        }
      }).trigger('click');

    if($(window).width() > 767) {
      $('.fancybox-is-open .heart-set').prepend($('.fancybox-is-open .coordsSubtitle'))
      $('.fancybox-is-open .heart-set').prepend($('.fancybox-is-open .currentlauerTitle'))
    }

    $('.product__custom-heart .currentCoordImg').attr('src', null);

    $(this).parent().parent().attr('current-color',$(this).parent().parent().find('.chosenColor').text());
    $('.product__custom-heart').attr('current-color', $(this).parent().parent().find('.chosenColor').text());

    //$('.currentCoordImg').attr('src', $('.product__custom-initials').attr('preview-img'));
    $('.custom_initial_input1').val('');
    $('.custom_initial_input2').val('');
    $('.custom_initial_input3').val('');
    createHeartPreview('L','T','K',$(this).parent().parent().find('.chosenColor').text());
    var braceletNumber = $(this).parent().parent().attr('data-layout-nubmer');
    $('.product__custom-heart .currentlauerTitle').text('Bracelet '+ braceletNumber);
    $('.product__custom-heart').attr('data-layout-nubmer', braceletNumber);
  

  });

  $('body').on('click','.editHeart',function(e) {

    e.preventDefault();

    var i1 = $(this).parent().find('.up').val();
    var i2 = $(this).parent().find('.middle').val(); 
    var i3 = $(this).parent().find('.down').val();

    //$('.product__custom-initials .currentCoordImg').attr('src', null);
    $('.product__custom-heart').fancybox({ 
      touch: false, 
      beforeShow: function(){
        $("body").css({'overflow-y':'hidden'});
      },
      afterClose: function(){
          $("body").css({'overflow-y':'visible'});

          var inputs = $('.heart-set');
          var firstInitial = inputs.find('.custom_initial_input1').val();
          var secondInitial = inputs.find('.custom_initial_input2').val();
          var thirdInitial = inputs.find('.custom_initial_input3').val();
    
          if(firstInitial.length != 0 && secondInitial.length != 0 && thirdInitial.length != 0 ) {
  
            var currentBracelet = $('.product__custom-heart').attr('data-layout-nubmer');
            var currentBraceletLayout = $('.heartCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
            var previewImage =  $('.product__custom-heart').attr('preview-img');
            currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
            currentBraceletLayout.attr('data-preview-src', previewImage);
            currentBraceletLayout.find('.up').val(firstInitial);
            currentBraceletLayout.find('.middle').val(secondInitial);
            currentBraceletLayout.find('.down').val(thirdInitial);
            currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
            currentBraceletLayout.find('.getHeart').hide();
            currentBraceletLayout.addClass('initialsEntered');
    
            checkFilledData();
          }       
          
      }
    }).trigger('click');
    $(this).parent().parent().attr('current-color',$(this).parent().parent().find('.chosenColor').text());
    $('.product__custom-heart').attr('current-color', $(this).parent().parent().find('.chosenColor').text());
    createHeartPreview(i1,i2, i3, $(this).parent().parent().find('.chosenColor').text());

 
    var braceletNumber = $(this).parent().parent().attr('data-layout-nubmer');
    $('.product__custom-heart').attr('data-layout-nubmer', braceletNumber);
    $('.fancybox-is-open .custom_initial_input1').val(i1);
    $('.fancybox-is-open .custom_initial_input2').val(i2);
    $('.fancybox-is-open .custom_initial_input3').val(i3);

  });
  

    var $crossedPathsInput = $( selectors.input );

    $crossedPathsInput.on('keyup paste', function(event){
      lastInitials = [];


      if ($(this).val().length >= 1) {
        $(this).val($(this).val().substr(0, 1));
      }

      if(event.keyCode == 107) {
        var val = '+';
      } else {
        var val = String.fromCharCode(event.which).replace(/[^a-zA-Z]/g, '').toUpperCase();
      }

      if(val == '') {
        val = $(this).val();
      }
     
      // Disallow any emoji input, arrow keys & blank space
      
      if ([37, 38, 39, 40, 32].indexOf(event.keyCode) > -1 || event.keyCode == 32) {



        if(event.keyCode == 37 || event.keyCode == 38) {
          
          var currentIndex = parseInt($('.fancybox-is-open .crossed-paths__input ').index(this));
          var $nextInput = $('.fancybox-is-open .custom_initial_input'+currentIndex);
    
          if( $nextInput.length ) {
            $nextInput.focus();
          }         
        }

        else {
          var currentIndex = parseInt($('.fancybox-is-open .crossed-paths__input ').index(this));
          currentIndex = currentIndex + 2;
          var $nextInput = $('.fancybox-is-open .custom_initial_input'+currentIndex);
    
          if( $nextInput.length ) {
            $nextInput.focus();
          }
        }

        return;
      }

      if( val == '' ) {
        return;
      }

      var cleared = val.clearEmojis().replace(/[^a-zA-Z&+]/g, '').toUpperCase();

      $(this).val(cleared);



      if(cleared.length > 0) {

      var currentIndex = parseInt($('.fancybox-is-open .crossed-paths__input ').index(this));
      currentIndex = currentIndex + 2;
      var $nextInput = $('.fancybox-is-open .custom_initial_input'+currentIndex);

      if( $nextInput.length ) {
        $nextInput.focus();
      }
      var crossedElements = $(this).closest('.crossed-paths__input-groups').find(selectors.input);

      if (crossedElements && crossedElements.length === 3) {
        var up = $(crossedElements[0]).val() || '',
            middle = $(crossedElements[1]).val() || '',
            down = $(crossedElements[2]).val() || '';
        if (up && middle && down){
          lastInitials = [up, middle, down];
          previewImage = createHeartPreview(up, middle, down, $('.fancybox-is-open .product__custom-heart').attr('current-color'));

          if( previewImage.valid === true) {
            $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', false);
            $('body').trigger('braceletcomplete');
          } else {
            if(previewImage.code == 'badformat'){
                $(selectors.errorContainer).html(previewImage.message).addClass('visible');
            }
            $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', true);
            $(selectors.container).find(selectors.addToCartBtn).prop('disabled', true);
          }
        } else {
          $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', true);
        }
      }
      } else {
        $(this).focus();
      }

    }).trigger('keyup');

    $(selectors.customBundleStepBack).click(function(e) {
      e.preventDefault();
      customBundleStepBack();
    });
  },
  initInfinitySet: function() {

    var selectors = {
      container: '.infinity-set',
      inputGroup: '.crossed-paths__input-group',
      input: '.beaded_infinity_input',
      customBundleStepBack: '.product__custom__prev',
      navLinkConfirm: '.mobile-configurator__nav__link--confirm'
    };

    if( !$( selectors.container ).length  ) {
      return;
    }

    var currentColor = '';
    var lastInitials = []; // left, right, up, down

 
    $('body').on( 'selectCallback', function( event, variant ) {
      if( !variant ) {
        return;
      }

      currentColor = variant.option2;

      if( lastInitials.length ){
        createCrossedPathPreview(
          lastInitials[0],
          lastInitials[1],
          lastInitials[2],
          lastInitials[3],
          currentColor
        );
      }
    });

    var customBundleStepBack = function() {
      var $customFormContainer = $('.product__custom');
      var $customCoordinates = $('.product__custom-coords');
      var $customCrossedPaths = $('.product__crossed-paths');
      var currentStep = parseInt($customFormContainer.attr('data-current-step'));

      // Lock form container height
      $customFormContainer.css('height', $customCrossedPaths.outerHeight());
      // Fade first step out and animate container height to height of second step
      $customCrossedPaths.fadeOut(400, function() {
        $customFormContainer.animate({
          'height': $customCoordinates.outerHeight()
        }, 400, function() {
          // Update current step
          $customFormContainer.attr('data-current-step', currentStep - 1);
          // Unlock first step
          $customCrossedPaths.removeClass('is-locked');
          // Fade in second step, lock it in place and reset container height
          $customCoordinates.fadeIn(400, function() {
            $customCoordinates.addClass('is-locked');
            $customFormContainer.css('height', '');
          });
        });
      });
    };

    var updatePreviewUrl = function (path) {

    };

    // Keys will be concatenated values of left, right, up, down, color
    var cache = {};

    var createInfinityPreview = function (up, middle, down, color) {

      if (!color || color == undefined) {
        var color =  $('.fancybox-is-open .product__custom-infinity').attr('current-color');
      }

      middle = encodeURIComponent(middle);
      up = encodeURIComponent(up);
      down = encodeURIComponent(down);

     

      // Don't wait for response to assign the preview url
      var path = encodeURI('https://w.sellry.com/beaded-infinity-preview/?'+
                'middle='+middle+'&'+
                'up='+up+'&'+
                'down='+down+'&'+
                'color='+color+'&'+
                'action=preview');
                
      $('.bracelet-preview-url').attr('value', path);


      $.ajax({
        url: 'https://w.sellry.com/beaded-infinity-preview/',
        dataType: 'json',
        cache: false,
        type: 'get',
        data: { up: up, middle: middle, down: down, color: color, action: 'preview'},
        error: function(xhr) {
          var contentType = xhr.getResponseHeader("Content-Type");
          if(contentType !== 'image/jpeg') {
            $('.product_gallery').removeClass('is-loading');
            $('.swatch_options').removeClass('is-loading');
          }
        },
        complete: function(xhr) {
          var contentType = xhr.getResponseHeader("Content-Type");
          if(contentType === 'image/jpeg') {
            $('.fancybox-is-open .product__custom-infinity').attr('preview-img', path);
            if($('.fancybox-is-open .currentCoordImg').attr('src') == null) {
              $('.fancybox-is-open .currentCoordImg').attr('src', path);
            }
            if(middle != null && up != null & down != null) {
              $('.fancybox-is-open .currentCoordImg').attr('src',path);
            }
          } else {
            $('.product_gallery').removeClass('is-loading');
            $('.swatch_options').removeClass('is-loading');
          }
        }
      });
      
      
      return {
        valid : true,
        message : 'Preview image has been generated'
      };
    }

    /* added for set */

    $('.saveInfinity').click(function(e){
    e.preventDefault();
    var inputs = $(this).parent().find('.inputInitialsBlock');
    var firstInitial = inputs.find('.custom_initial_input1').val();
    var secondInitial = inputs.find('.custom_initial_input2').val();
    var thirdInitial = inputs.find('.custom_initial_input3').val();

    if(firstInitial.length == 0 || secondInitial.length == 0 || thirdInitial.length == 0 ) {

      if(firstDate.length == 0) {
        inputs.find('.beaded_infinity_input').addClass('red-border');
      } 

      if(secondInitial.length == 0) {
        inputs.find('.custom_initial_input2').addClass('red-border');
      }

      if(thirdInitial.length == 0) {
        inputs.find('.custom_initial_input3').addClass('red-border');
      }


      $('.fancybox-is-open').scrollTop($('#CrossedPathsInput1--product-template-set').offset().top);

    } else {
        var currentBracelet = $(this).parent().attr('data-layout-nubmer');
        var currentBraceletLayout = $('.infCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
        var previewImage = $(this).parent().attr('preview-img');

        currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
        currentBraceletLayout.attr('data-preview-src', previewImage);
        currentBraceletLayout.find('.up').val(firstInitial);
        currentBraceletLayout.find('.middle').val(secondInitial);
        currentBraceletLayout.find('.down').val(thirdInitial);
        currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
        currentBraceletLayout.find('.getInfinity').hide();
        currentBraceletLayout.addClass('initialsEntered');

        setTimeout(function() { 

        $('.infCustomizer:not(.emptyContainer)').each(function(){

          if($(this).find('.enteredCoordinates .up').val().length === 0) {
            $(this).find('.customizerImg').attr('src',previewImage);
            $(this).attr('data-preview-src', previewImage);
            $(this).find('.up').val(firstInitial);
            $(this).find('.middle').val(secondInitial);
            $(this).find('.down').val(thirdInitial);
            $(this).find('.enteredCoordinates').addClass('showFlexdiv');
            $(this).find('.getInfinity').hide();
            $(this).addClass('initialsEntered'); 
            
            var currentColor = currentBraceletLayout.find('.colorContainer img.selected').attr('data-color');
            var currentSize = currentBraceletLayout.find('.sizeContainers .customizerContainer.selected').attr('data-size');
            var material =  currentBraceletLayout.find('.materialContainers .customizerContainer.selected').attr('data-material');

            $(this).find('.customizerImgContainer img').removeClass('selected');
            $(this).find('.materialContainers .customizerContainer').removeClass('selected');
            $(this).find('.sizeContainers .customizerContainer').removeClass('selected');
            $(this).find('.customizerImgContainer img[data-color="' + currentColor + '"]').addClass('selected');
            $(this).find('.sizeContainers .customizerContainer[data-size="' + currentSize + '"]').addClass('selected');
            $(this).find('.materialContainers .customizerContainer[data-material="' + material + '"]').addClass('selected'); 
            getAvailableColors();
          }

        })

        checkFilledData();
        }, 700);
        $('.fancybox-is-open .fancybox-close-small').click();
    }

  })

  $('body').on('click','.getInfinity',function(e){
    e.preventDefault();
    //$('.currentCoordImg').attr('src', $(this).parent().parent().find('.customizerImg').attr('src'))

    $('.product__custom-infinity').fancybox(
      { 
        touch: false, 
        beforeShow: function(){
          $("body").css({'overflow-y':'hidden'});
        },
        afterClose: function(){
            $("body").css({'overflow-y':'visible'});

            var inputs = $('.infinity-set');
            var firstInitial = inputs.find('.custom_initial_input1').val();
            var secondInitial = inputs.find('.custom_initial_input2').val();
            var thirdInitial = inputs.find('.custom_initial_input3').val();
      
            if(firstInitial.length != 0 && secondInitial.length != 0 && thirdInitial.length != 0 ) {
    
              var currentBracelet = $('.product__custom-infinity').attr('data-layout-nubmer');
              var currentBraceletLayout = $('.infCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
              var previewImage =  $('.product__custom-infinity').attr('preview-img');
              currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
              currentBraceletLayout.attr('data-preview-src', previewImage);
              currentBraceletLayout.find('.up').val(firstInitial);
              currentBraceletLayout.find('.middle').val(secondInitial);
              currentBraceletLayout.find('.down').val(thirdInitial);
              currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
              currentBraceletLayout.find('.getInfinity').hide();
              currentBraceletLayout.addClass('initialsEntered');
      
              checkFilledData();
            }       
            
        }
      }).trigger('click');

    if($(window).width() > 767) {
      $('.fancybox-is-open .infinity-set').prepend($('.fancybox-is-open .coordsSubtitle'))
      $('.fancybox-is-open .infinity-set').prepend($('.fancybox-is-open .currentlauerTitle'))
    }

    $('.product__custom-infinity .currentCoordImg').attr('src', null);

    $(this).parent().parent().attr('current-color',$(this).parent().parent().find('.chosenColor').text());
    $('.product__custom-infinity').attr('current-color', $(this).parent().parent().find('.chosenColor').text());

    //$('.currentCoordImg').attr('src', $('.product__custom-initials').attr('preview-img'));
    $('.custom_initial_input1').val('');
    $('.custom_initial_input2').val('');
    $('.custom_initial_input3').val('');
    createInfinityPreview('L','T','K',$(this).parent().parent().find('.chosenColor').text());
    var braceletNumber = $(this).parent().parent().attr('data-layout-nubmer');
    $('.product__custom-infinity .currentlauerTitle').text('Bracelet '+ braceletNumber);
    $('.product__custom-infinity').attr('data-layout-nubmer', braceletNumber);
  

  });

  $('body').on('click','.editInfinity',function(e) {

    e.preventDefault();

    var i1 = $(this).parent().find('.up').val();
    var i2 = $(this).parent().find('.middle').val(); 
    var i3 = $(this).parent().find('.down').val();

    //$('.product__custom-initials .currentCoordImg').attr('src', null);
    $('.product__custom-infinity').fancybox({ 
      touch: false, 
      beforeShow: function(){
        $("body").css({'overflow-y':'hidden'});
      },
      afterClose: function(){
          $("body").css({'overflow-y':'visible'});

          var inputs = $('.infinity-set');
          var firstInitial = inputs.find('.custom_initial_input1').val();
          var secondInitial = inputs.find('.custom_initial_input2').val();
          var thirdInitial = inputs.find('.custom_initial_input3').val();
    
          if(firstInitial.length != 0 && secondInitial.length != 0 && thirdInitial.length != 0 ) {
  
            var currentBracelet = $('.product__custom-infinity').attr('data-layout-nubmer');
            var currentBraceletLayout = $('.infCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
            var previewImage =  $('.product__custom-infinity').attr('preview-img');
            currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
            currentBraceletLayout.attr('data-preview-src', previewImage);
            currentBraceletLayout.find('.up').val(firstInitial);
            currentBraceletLayout.find('.middle').val(secondInitial);
            currentBraceletLayout.find('.down').val(thirdInitial);
            currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
            currentBraceletLayout.find('.getInfinity').hide();
            currentBraceletLayout.addClass('initialsEntered');
    
            checkFilledData();
          }       
          
      }
    }).trigger('click');
    $(this).parent().parent().attr('current-color',$(this).parent().parent().find('.chosenColor').text());
    $('.product__custom-infinity').attr('current-color', $(this).parent().parent().find('.chosenColor').text());
    createInfinityPreview(i1,i2, i3, $(this).parent().parent().find('.chosenColor').text());

 
    var braceletNumber = $(this).parent().parent().attr('data-layout-nubmer');
    $('.product__custom-infinity').attr('data-layout-nubmer', braceletNumber);
    $('.fancybox-is-open .custom_initial_input1').val(i1);
    $('.fancybox-is-open .custom_initial_input2').val(i2);
    $('.fancybox-is-open .custom_initial_input3').val(i3);

  });
  

    var $crossedPathsInput = $( selectors.input );

    $crossedPathsInput.on('keyup paste', function(event){
      lastInitials = [];


      if ($(this).val().length >= 1) {
        $(this).val($(this).val().substr(0, 1));
      }

      if(event.keyCode == 107) {
        var val = '+';
      } else {
        var val = String.fromCharCode(event.which).replace(/[^a-zA-Z]/g, '').toUpperCase();
      }

      if(val == '') {
        val = $(this).val();
      }

      var rx = /[^A-Z0-9!@#%&*+()]+/gi;

      val = val.replace(rx, '');
     
      // Disallow any emoji input, arrow keys & blank space
      
      if ([37, 38, 39, 40, 32].indexOf(event.keyCode) > -1 || event.keyCode == 32) {



        if(event.keyCode == 37 || event.keyCode == 38) {
          
          var currentIndex = parseInt($('.fancybox-is-open .crossed-paths__input ').index(this));
          var $nextInput = $('.fancybox-is-open .custom_initial_input'+currentIndex);
    
          if( $nextInput.length ) {
            $nextInput.focus();
          }         
        }

        else {
          var currentIndex = parseInt($('.fancybox-is-open .crossed-paths__input ').index(this));
          currentIndex = currentIndex + 2;
          var $nextInput = $('.fancybox-is-open .custom_initial_input'+currentIndex);
    
          if( $nextInput.length ) {
            $nextInput.focus();
          }
        }

        return;
      }

      if( val == '' ) {
        return;
      }

      var cleared = val.clearEmojis().replace(/[^a-zA-Z&+]/g, '').toUpperCase();

      $(this).val(cleared);



      if(cleared.length > 0) {

      var currentIndex = parseInt($('.fancybox-is-open .crossed-paths__input ').index(this));
      currentIndex = currentIndex + 2;
      var $nextInput = $('.fancybox-is-open .custom_initial_input'+currentIndex);

      if( $nextInput.length ) {
        $nextInput.focus();
      }
      var crossedElements = $(this).closest('.crossed-paths__input-groups').find(selectors.input);

      if (crossedElements && crossedElements.length === 3) {
        var up = $(crossedElements[0]).val() || '',
            middle = $(crossedElements[1]).val() || '',
            down = $(crossedElements[2]).val() || '';
        if (up && middle && down){
          lastInitials = [up, middle, down];
          previewImage = createInfinityPreview(up, middle, down, currentColor);

          if( previewImage.valid === true) {
            $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', false);
            $('body').trigger('braceletcomplete');
          } else {
            if(previewImage.code == 'badformat'){
                $(selectors.errorContainer).html(previewImage.message).addClass('visible');
            }
            $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', true);
            $(selectors.container).find(selectors.addToCartBtn).prop('disabled', true);
          }
        } else {
          $(selectors.container).find(selectors.navLinkConfirm).prop('disabled', true);
        }
      }
      } else {
        $(this).focus();
      }

    }).trigger('keyup');

    $(selectors.customBundleStepBack).click(function(e) {
      e.preventDefault();
      customBundleStepBack();
    });
  },
  initNameSet: function() {

    var selectors = {
      container: '.name-set',
      inputGroup: '.custom-word__input-group',
      inputColor: '.custom-word__color',
      input: '.custom-word__input',
      navLinkConfirm: '.mobile-configurator__nav__link--confirm'
    };

    if( !$( selectors.container ).length  ) {
      return;
    }
 
    var updatePreviewUrl = function (path) {

    };

    // Keys will be concatenated values of left, right, up, down, color
    var cache = {};
    

    var createNamePreview = function (word, color) {

      if (!color) {
        var color =  $('.fancybox-is-open .product__custom-name').attr('current-color');
      }
      

      var braceletBaseUrl = 'https://w.sellry.com/beaded-word-preview';

      // Don't wait for response to assign the preview url
      var path = braceletBaseUrl + '/?' +
                'word='+ encodeURIComponent(word) +'&'+
                'color='+ encodeURIComponent(color) +'&'+
                'action=preview';

      $('.bracelet-preview-url').attr('value', path);


      $.ajax({
        url: 'https://w.sellry.com/beaded-word-preview/',
        dataType: 'json',
        cache: false,
        type: 'get',
        data: { word: word, color: color, action: 'preview'},
        error: function(xhr) {
          var contentType = xhr.getResponseHeader("Content-Type");
          if(contentType !== 'image/jpeg') {
            $('.product_gallery').removeClass('is-loading');
            $('.swatch_options').removeClass('is-loading');
          }
        },
        complete: function(xhr) {
          var contentType = xhr.getResponseHeader("Content-Type");
          if(contentType === 'image/jpeg') {
            $('.fancybox-is-open .product__custom-name').attr('preview-img', path);
            if($('.fancybox-is-open .currentCoordImg').attr('src') == null) {
              $('.fancybox-is-open .currentCoordImg').attr('src', path);
            }
            if(word != null) {
              $('.fancybox-is-open .currentCoordImg').attr('src',path);
            }
          } else {
            $('.product_gallery').removeClass('is-loading');
            $('.swatch_options').removeClass('is-loading');
          }
        }
      });
      
      
      return {
        valid : true,
        message : 'Preview image has been generated'
      };
    }

    /* added for set */

    $('.saveName').click(function(e){
    e.preventDefault();

    var word = $('.fancybox-is-open .name-set .word').val();


    if(word.length == 0 ) {

      $('.fancybox-is-open .name-set .word').addClass('red-border');

      $('.fancybox-is-open').scrollTop($('#word-input').offset().top);

    } else {
       
        var currentBracelet = $(this).parent().parent().attr('data-layout-nubmer');

        var currentBraceletLayout = $('.nameCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
        var previewImage = $(this).parent().parent().attr('preview-img');
        currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
        currentBraceletLayout.attr('data-preview-src', previewImage);
        currentBraceletLayout.find('.word').val(word);
        currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
        currentBraceletLayout.find('.getName').hide();
        currentBraceletLayout.addClass('nameEntered');

        setTimeout(function() { 

        $('.nameCustomizer:not(.emptyContainer)').each(function(){

          if($(this).find('.enteredCoordinates .word').val().length === 0) {
            $(this).find('.customizerImg').attr('src',previewImage);
            $(this).attr('data-preview-src', previewImage);
            $(this).find('.word').val(word);
            $(this).find('.enteredCoordinates').addClass('showFlexdiv');
            $(this).find('.getName').hide();
            $(this).addClass('nameEntered'); 
            
            var currentColor = currentBraceletLayout.find('.colorContainer img.selected').attr('data-color');
            var currentSize = currentBraceletLayout.find('.sizeContainers .customizerContainer.selected').attr('data-size');
            var material =  currentBraceletLayout.find('.materialContainers .customizerContainer.selected').attr('data-material');

            $(this).find('.customizerImgContainer img').removeClass('selected');
            $(this).find('.materialContainers .customizerContainer').removeClass('selected');
            $(this).find('.sizeContainers .customizerContainer').removeClass('selected');
            $(this).find('.customizerImgContainer img[data-color="' + currentColor + '"]').addClass('selected');
            $(this).find('.sizeContainers .customizerContainer[data-size="' + currentSize + '"]').addClass('selected');
            $(this).find('.materialContainers .customizerContainer[data-material="' + material + '"]').addClass('selected'); 
            getAvailableColors();
          }
          
        })

        checkFilledData();
        }, 700);
        $('.fancybox-is-open .fancybox-close-small').click();
    }

  })


  $('body').on('click','.getName',function(e){
    e.preventDefault();
    //$('.currentCoordImg').attr('src', $(this).parent().parent().find('.customizerImg').attr('src'))

    $('.product__custom-name').fancybox({         
        touch: false, 
        beforeShow: function(){
          $("body").css({'overflow-y':'hidden'});
        },
        afterClose: function(){
          $("body").css({'overflow-y':'visible'});

          var word = $('.product__custom-name .word').val();
    
          if(word.length != 0 ) {
  
            var currentBracelet = $('.product__custom-name').attr('data-layout-nubmer');
            var currentBraceletLayout = $('.nameCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
            var previewImage =  $('.product__custom-heart').attr('preview-img');
            currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
            currentBraceletLayout.attr('data-preview-src', previewImage);
            currentBraceletLayout.find('.word').val(word);
            currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
            currentBraceletLayout.find('.getName').hide();
            currentBraceletLayout.addClass('nameEntered');
    
            checkFilledData();
          }       
          
      }
    }).trigger('click');

    if($(window).width() > 767) {
      $('.fancybox-is-open .name-set').prepend($('.fancybox-is-open .coordsSubtitle'))
      $('.fancybox-is-open .name-set').prepend($('.fancybox-is-open .currentlauerTitle'))
    }

    $('.product__custom-name .currentCoordImg').attr('src', null);

    $(this).parent().parent().attr('current-color',$(this).parent().parent().find('.chosenColor').text());
    $('.product__custom-name').attr('current-color', $(this).parent().parent().find('.chosenColor').text());

    //$('.currentCoordImg').attr('src', $('.product__custom-initials').attr('preview-img'));
    $('.word').val('');
    createNamePreview('Emily',$(this).parent().parent().find('.chosenColor').text());
    var braceletNumber = $(this).parent().parent().attr('data-layout-nubmer');
    $('.product__custom-name .currentlauerTitle').text('Bracelet '+ braceletNumber);
    $('.product__custom-name').attr('data-layout-nubmer', braceletNumber);
  

  });

  $('body').on('click','.editName',function(e) {

    e.preventDefault();

    var word = $(this).parent().find('.word').val();


    //$('.product__custom-initials .currentCoordImg').attr('src', null);
    $('.product__custom-name').fancybox({         
      touch: false, 
      beforeShow: function(){
        $("body").css({'overflow-y':'hidden'});
      },
      afterClose: function(){
        $("body").css({'overflow-y':'visible'});

        var word = $('.product__custom-name .word').val();
  
        if(word.length != 0 ) {

          var currentBracelet = $('.product__custom-name').attr('data-layout-nubmer');
          var currentBraceletLayout = $('.nameCustomizer[data-layout-nubmer="'+ currentBracelet +'"] ');
          var previewImage =  $('.product__custom-heart').attr('preview-img');
          currentBraceletLayout.find('.customizerImg').attr('src',previewImage);
          currentBraceletLayout.attr('data-preview-src', previewImage);
          currentBraceletLayout.find('.word').val(word);
          currentBraceletLayout.find('.enteredCoordinates').addClass('showFlexdiv');
          currentBraceletLayout.find('.getName').hide();
          currentBraceletLayout.addClass('nameEntered');
  
          checkFilledData();
        }       
        
    }
  }).trigger('click');
    $(this).parent().parent().attr('current-color',$(this).parent().parent().find('.chosenColor').text());
    $('.product__custom-name').attr('current-color', $(this).parent().parent().find('.chosenColor').text());
    createNamePreview(word, $(this).parent().parent().find('.chosenColor').text());

 
    var braceletNumber = $(this).parent().parent().attr('data-layout-nubmer');
    $('.product__custom-heart').attr('data-layout-nubmer', braceletNumber);
    $('.fancybox-is-open .word').val(word);

  });
  

    $('.name-set .custom-word').on('keydown', function(event) {
        if (event.which === 32 && event.target.selectionStart === 0) {
            return false;
        }
    });

    $('.name-set .custom-word').on('keyup paste', function(event) {
      lastCustomWord = '';
      
      var val = $('.name-set .custom-word').val();

      // Disallow any emoji input & arrow keys
      var char = String.fromCharCode(event.which);
      if (char.match(/([\uE000-\uF8FF]|\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDDFF])|\s/) || [37, 38, 39, 40].indexOf(event.keyCode) > -1 || event.keyCode == 32) {
        $(this).val(val.length == 1 ? '' : val);
        event.preventDefault();
        return;
      }

      var rx = /[^a-zA-Z0-9!@#$%^&*\-_=+()[\]{}<>?"':;.,/~ ]+/gi;

      val = val.replace(rx, '');

      if(val.length > 8) {
        val = val.substring(0, 8);
      }

      var remainLength =  8 - val.length;

      $('.name-set .custom-word').val( val );

      setTimeout(function() { 
         createNamePreview($('.name-set .custom-word').val());
      }, 1000);

      $('.fancybox-is-open .name-set .remainCharactersTooltip').text(remainLength)

     // $('body').trigger('braceletcomplete');

    }).trigger('keyup');



  },
  destroySlider: function($target) {
    let slider = $target.find('.product_slider'),
        galleryWrapper = $('.product_gallery_wrapper'),
        wrapperHeight = galleryWrapper.height();

    galleryWrapper.css({'opacity':0, 'min-height': wrapperHeight});
    destroySlider(slider);
  },
  unload: function($target) {
    this.destroySlider($target);
  },
  initBuffaloBoneModal: function() {
    window.addEventListener('load', function(){
      $('.buffalo-modal-btn').attr('href', '#ModalBuffaloBone');
      $('.buffalo-modal-btn, .btn-buffalo-bone-modal-toggle').fancybox({
        hideOnContentClick: true,
        wrapCSS: 'buffalo_bone_popup',
        afterShow: function( instance, current ) {
            if((typeof YT !== "undefined") && YT && YT.Player){
                let playerFrame = $('.video-container-wrapper').find('iframe').get()[0];
                if(playerFrame !== "undefined") {
                let playerWrap = playerFrame.parentElement;

                if(navigator.platform.indexOf("iPhone") != -1 && playerFrame.hasAttribute('data-iphonesrc')) {
                    playerFrame.dataset.src = playerFrame.dataset.iphonesrc;
                }
                
                let onPlayerStateChange=function(event){
                    if (event.data==YT.PlayerState.ENDED){
                        playerWrap.classList.add("ended");
                    }else if (event.data==YT.PlayerState.PAUSED){
                    playerWrap.classList.add("paused");
                    }else if (event.data==YT.PlayerState.PLAYING){
                        playerWrap.classList.remove("ended");
                        playerWrap.classList.remove("paused");
                    }
                };

                let onPlayerReady=function(event){
                    let player = event.target;
                    
                    let clickOverlay = function(){
                        let playerState = player.getPlayerState();

                        if (playerState == YT.PlayerState.ENDED){
                            player.seekTo(0);
                        }else if (playerState == YT.PlayerState.PAUSED || playerState == YT.PlayerState.CUED){
                            player.playVideo();
                        }
                    }

                    playerWrap.addEventListener('click', clickOverlay);     
                }

                player = new YT.Player(playerFrame,{
                    events:{
                        'onStateChange': onPlayerStateChange,
                        'onReady': onPlayerReady
                    }
                });
              }                                           
            }
        },
        afterClose: function( instance, current ) {
            if((typeof YT !== "undefined") && YT && YT.Player){
                let playerFrame = $('.video-container-wrapper').find('iframe').get()[0];
                if(playerFrame !== "undefined") {
                  let playerWrap = playerFrame.parentElement;
                }
                //playerWrap.removeEventListener('click', clickOverlay);                
            }
            if ($('#ModalBuffaloBone iframe').length) {
              let playerFrame = $('#ModalBuffaloBone iframe')[0];
              playerFrame.classList.remove("lazyloaded");
              playerFrame.classList.add("lazyload");
            }
        }
      });
    });
  },
  initPrintCardModal: function() {
    if($(window).width() > 768 ) {
      if($('.print-at-home-card-link').length) {
        $('.print-at-home-card-link').fancybox({
          toolbar  : false,
          smallBtn : true,
          helpers: {
            title : {
              type : 'float'
            }
          },
          maxWidth: 800,
        });
      }
    } else {
      if($('.print-at-home-card-link-mobile').length) {
        $('.print-at-home-card-link-mobile').fancybox({
          toolbar  : false,
          smallBtn : true,
          helpers: {
            title : {
              type : 'float'
            }
          },
          maxWidth: 800,
        });
      }          
    }
  },
  initAnnouncementModal: function() {
    $('.promo_banner--fancybox').fancybox({
      toolbar  : false,
      smallBtn : true,
      onInit: function(instance) {
        let mql = window.matchMedia('(max-width: 768px)'),
            trigger = $('.promo_banner--fancybox').first();
        if(mql.matches) {
          instance.group[0].src = trigger.data('mobile-href');
        } else {
          instance.group[0].src = trigger.data('desktop-href');
        }
      },
      helpers: {
        title : {
          type : 'float'
        }
      },
      maxWidth: 610
    });
  },
  hijackQuestionButton: function() {
    var $questionButton = $('.stamped-summary-actions-newquestion');

    if ($questionButton.length) {
      $questionButton[0].onclick = null;
      $questionButton.click(function(e) {
        e.preventDefault();
        $zopim.livechat.window.show();
      });
    }
  }
}


/*============================================================================
  Collection
==============================================================================*/

var collection = {
  init: function(){

    

    if( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      $(".quick_shop").remove();
    } else {
      $('.thumbnail').hover(function(){
        $(this).find('.quick_shop').show();

        if ($(this).find('.secondary').length){
          var imgHeights = $(this).find('.product_image img').map(function() {
              return $(this).outerHeight(true);
          }).get();

          var maxHeight = Math.max.apply(null, imgHeights);

          $(this).addClass('swap');
          $(this).find('.product_image').css('height', maxHeight);
        }

      }, function(){
        $(this).find('.quick_shop').hide();

        if ($(this).find('.secondary').length){
          $(this).removeClass('swap');
          $(this).find('.product_image').css('height', 'auto');
        }
      })

      var modal_width = '860px';
      if($(window).width() >= 1200 || $('html').hasClass('ie')) {
        modal_width = '1080px'
      }
      $(".quick_shop").fancybox({
        width: modal_width,
        height: 'auto',
        autoSize: false,
        padding: [20, 20, 20, 20],
        afterShow: function(e) {
          var selector = $('.fancybox-opened').find('.selector-wrapper select');
          selector.trigger('change');
        },
        beforeShow: function(e) {
          var $gallery = $('.' + $(this.element).data('gallery'));
          var $product = $(this.element).data("fancybox-href");
          var thumbnailPosition = $gallery.parents('.product_section').data('thumbnail');
          var slideshowAnimation = $gallery.parents('.product_section').data('slideshow-animation');
          var slideshowSpeed = $gallery.parents('.product_section').data('slideshow-speed');

          $gallery.flexslider({
            startAt: parseInt($('.featured_image', $(this)).data('index'), 10),
            touch: true,
            pauseOnHover: true,
            controlNav: thumbnailPosition == "no-thumbnails" ? false : "thumbnails",
            directionNav: thumbnailPosition == "no-thumbnails" ? true : false,
            animation: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? 'fade' : slideshowAnimation,
            slideshow: slideshowAnimation == 'none' || slideshowAnimation == 'zoom' ? false : true,
            slideshowSpeed: slideshowSpeed ? slideshowSpeed*1000 : 10*1000,
            start: function(slider){
              slider.resize();
            }
          });

          if (slideshowAnimation == 'slide'){
            if($gallery.data("index") == 0) { $('.flex-direction-nav', $gallery).hide() }
          } else {
            if($gallery.length == 1) { $('.flex-direction-nav', $gallery).hide() }
          }
        }
      });
    }

    $('#sort-by').val($('#sort-by').data('default-sort'));

    $('body')
      .on('change', '#tag_filter, #sort-by', function() {
        var sortValue = $('#sort-by').val();
        var filterValue = $('#tag_filter').val();

        Shopify.queryParams.sort_by = sortValue;
        sortUrl = $.param(Shopify.queryParams);

        if (sortValue && filterValue){
          window.location = filterValue + '?sort_by=' + sortValue;
        } else if (sortValue && !filterValue) {
          window.location = '?' + sortUrl;
        } else if (!sortValue && filterValue){
          window.location = filterValue;
        }
    });
  },
  unload: function($target){
    $target.find('.thumbnail').off('mouseenter mouseleave');
    $('body').off('change', '#tag_filter, #sort-by');
    $target.find('.quick_shop').unbind('click.fb');
  }
}

/*============================================================================
  Page Banner Template
==============================================================================*/

var pageBanner = {
  init: function(){
    $('.banner-flexslider').flexslider({
      touch: false,
      controlNav: false,
      directionNav: false,
      animation: "fade"
    });
  },
  unload: function($target){
    var slider = $target.find('.banner-flexslider');
    destroySlider(slider);
  }
}

/*============================================================================
  Map
==============================================================================*/

var map = {
  init: function(){
    if ($(".map-section .map, .contact-template-section .map, .page-details-section .map, .product-details-section .map").hasClass('js-api-map')) {
      var mapsToLoad = [];

      //Create map settings array
      $('.map').each(function(i, obj) {
        mapsToLoad.push(this);
        mapsToLoad[i].sectionid = $(this).data('id');
        mapsToLoad[i].address = $(this).data('address');
        mapsToLoad[i].directions = $(this).data('directions-address');
        mapsToLoad[i].zoom = $(this).data('zoom');
        mapsToLoad[i].mapstyle = $(this).data('style');
        mapsToLoad[i].showpin = $(this).data('pin');
        mapsToLoad[i].apikey = $(this).data('api-key');
      });

      $.each(mapsToLoad, function(i, instance) {

        //Enable caching to avoid duplicate google maps files
        $.ajaxSetup({ cache: true });

        //Load maps script and find location coordinates
        $.getScript('https://maps.googleapis.com/maps/api/js?key=' + mapsToLoad[i].apikey).then(function() {
          map.findLocation(mapsToLoad[i]);
          $.ajaxSetup({ cache: false });
        });
      });
    }
  },

  findLocation:function(mapArray) {
    var geoLat;
    var geoLng;
    var geocoder = new google.maps.Geocoder();

    //Find and set coordinates
    geocoder.geocode( { 'address': mapArray.address }, function(results, status) {
      if (status == google.maps.GeocoderStatus.OK) {

        geoLat = results[0].geometry.location.lat();
        geoLng = results[0].geometry.location.lng();

        //Create map
        map.initMap(geoLat, geoLng, mapArray);

      }
    });
  },

  initMap:function(lat,lng, mapArray) {

    var location = {lat: lat, lng: lng};
    var styleJson = [];

    //Set style JSON
    if( mapArray.mapstyle == 'aubergine') {
      styleJson = [{"elementType":"geometry","stylers":[{"color":"#1d2c4d"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#8ec3b9"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#1a3646"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#4b6878"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#64779e"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"color":"#4b6878"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"color":"#334e87"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#023e58"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#283d6a"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#6f9ba5"}]},{"featureType":"poi","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#023e58"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#3C7680"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#304a7d"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#98a5be"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#2c6675"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#255763"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#b0d5ce"}]},{"featureType":"road.highway","elementType":"labels.text.stroke","stylers":[{"color":"#023e58"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#98a5be"}]},{"featureType":"transit","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"transit.line","elementType":"geometry.fill","stylers":[{"color":"#283d6a"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#3a4762"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#0e1626"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#4e6d70"}]}];
    } else if(mapArray.mapstyle == 'retro') {
      styleJson = [{"elementType":"geometry","stylers":[{"color":"#ebe3cd"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#523735"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f1e6"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#c9b2a6"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.stroke","stylers":[{"color":"#dcd2be"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#ae9e90"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#93817c"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#a5b076"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#447530"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#f5f1e6"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#fdfcf8"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#f8c967"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#e9bc62"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#e98d58"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"color":"#db8555"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#806b63"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"transit.line","elementType":"labels.text.fill","stylers":[{"color":"#8f7d77"}]},{"featureType":"transit.line","elementType":"labels.text.stroke","stylers":[{"color":"#ebe3cd"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#b9d3c2"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#92998d"}]}];
    } else if(mapArray.mapstyle == 'silver') {
      styleJson = [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}];
    } else if(mapArray.mapstyle == 'night') {
      styleJson =  [{"elementType":"geometry","stylers":[{"color":"#242f3e"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#746855"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#242f3e"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#263c3f"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#6b9a76"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#38414e"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#212a37"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#9ca5b3"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#746855"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#1f2835"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#f3d19c"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#2f3948"}]},{"featureType":"transit.station","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#17263c"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#515c6d"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#17263c"}]}];
    } else {
      styleJson = [];
    }

    //Create google maps link
    $('.js-map-link').attr('href', 'https://www.google.com/maps/place/' + mapArray.directions + '/@' + lat + ',' + lng );

    //Set map options
    var mapOptions = {
      zoom: mapArray.zoom,
      center: location,
      styles: styleJson,
      disableDefaultUI: false
    };

    //Create map
    var map = new google.maps.Map(document.getElementById(mapArray.sectionid), mapOptions);

    //Show pin
    if(mapArray.showpin == true) {
      var marker = new google.maps.Marker({
        position: location,
        map: map
      });
    }
  }
}

/*============================================================================
  Cart
==============================================================================*/
var cart = {
  init: function(){
    // Remove emoji characters
    $('form[action="/checkout"],form[action="/cart"]').find('[name="note"]').on('keyup', function(){
      var val = $(this).val();
      // https://stackoverflow.com/questions/10992921/how-to-remove-emoji-code-using-javascript
      // val = val.replace(/([\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2694-\u2697]|\uD83E[\uDD10-\uDD5D])/g, '');
      $(this).val(val);
    });
  },
  initSidebar: function(){
    $cart = $("#cart-wrapper");
    $cart.on("click", ".minus", function(e){
        var quantity = parseInt( $($(this).data('id')).val() );
        quantity -= 1;
        $($(this).data('id')).val(quantity);
        if (quantity == 0) {
            $(this).closest('.cart_item').slideUp(400, function(){
                var itemToRemove = $($(this).data('id')).data('id');
                $('.item--' + itemToRemove).remove();
                setTimeout(ajaxSubmitCart, 500);
            });
        } else {
            ajaxSubmitCart();
        }

        e.stopPropagation();
        e.preventDefault();
        return false;
    });

    $cart.on("click", ".plus", function(e){
        var quantity = parseInt( $($(this).data('id')).val() );
        quantity += 1;
        $($(this).data('id')).val(quantity).trigger('change');
        ajaxSubmitCart();
        e.stopPropagation();
        e.preventDefault();
        return false;
    });

    $cart.on("click", ".remove", function(e){
        $cartItem = $(this).closest('.cart_item');
        $cartItem.slideUp(400, function(){
            $cartItem.find('input.quantity').val(0).trigger('change');
            setTimeout(ajaxSubmitCart, 500);
        });

        e.stopPropagation();
        e.preventDefault();
        return false;
    });

    $cart.on("change", "#cart-note", function() {
        ajaxSubmitCart();
    });
  }
}

/*============================================================================
  Product form
==============================================================================*/

var productFormListeners = {
  init: function(){
    $(document).on("click", "#cart_form .minus", function(e) {
      var quantity = parseInt( $($(this).data('id')).val() );
      quantity -= 1;
      $($(this).data('id')).val(quantity);
      if (quantity == 0) {
        $(this).closest('.cart_item').slideUp(400, function(){              
            var itemToRemove = $($(this).data('id')).data('id');
            $('.item--' + itemToRemove).remove();
            setTimeout(ajaxSubmitCart, 500);
        });            
        
      } else {
        $($(this).data('id')).trigger('change');
      }

      e.stopPropagation();
      e.preventDefault();
      return false;
    });

    $(document).on("click", "#cart_form .plus", function(e) {
      var quantity = parseInt( $($(this).data('id')).val() );
      quantity += 1;
      $($(this).data('id')).val(quantity).trigger('change');

      e.stopPropagation();
      e.preventDefault();
      return false;
    });

    $(document).on("click", "#cart_form .remove", function(e) { 

        $($(this).data('id')).val(0).trigger('change');

        e.stopPropagation();
        e.preventDefault();
        return false;
    });

    $(document).on("change", "#cart_form input[type='number']", function() {
      $("#cart_form").trigger('submit', [ { 'updateAction': true } ]);
    });

    $('body').on('submit', '#cart_form', function(e, updateAction) {
      
      if(!updateAction) {
        return true;
      }

      e.preventDefault();
      var $addToCartForm = $(this);
      var $addToCartInfo = $(this).parent('.product_form');
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');

      $.ajax({
        url: '/cart/update.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass("zoomIn").addClass('animated zoomOut');
        },
        success: function(itemData) {
          window.location = $addToCartForm.attr('action');
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();

          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
        }
      });

      return false;
    });

    if ($('.tos_agree').length) {
      $('body').on('click', 'input[type="submit"]', function() {
        if($(this).parents('form').find('.tos_agree').length) {
          if ($(this).parents('form').find('.tos_agree').is(':checked')) {
            $(this).submit();
          } else {
            alert("You must agree with the terms and conditions to checkout.");
            return false;
          }
        } else {
          $(this).submit();
        }
      });
    }
  },
  unload: function(){

  }
}

/*============================================================================
  Cart
==============================================================================*/

var ajaxCart = {
  init: function(){
    $('body').on('submit', '.product_form form', function(e) {
      e.preventDefault();
      var $addToCartForm = $(this);
      var $addToCartInfo = $(this).parent('.product_form');
      var $addToCartBtn = $addToCartForm.find('.add_to_cart');

      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass("zoomIn").addClass('animated zoomOut');
        },
        success: function(itemData) {
          $addToCartBtn.find('span').text("Added").removeClass('zoomOut').addClass('fadeIn');

          window.setTimeout(function(){
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('span').addClass("fadeOut").text($addToCartBtn.data('label')).removeClass('fadeIn').removeClass("fadeOut").addClass('zoomIn');
          }, 1000);

          $.ajax({
            url: '/cart.js',
            dataType: "json",
            cache: false,
            success: function(cart) {
              refreshCart(cart,false);
              window.setTimeout(function(){ $.fancybox.close(); $('.cart-button').click(); }, 500);
            }
          });
        },
        error: function(XMLHttpRequest) {
          var response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;
          $('.warning').remove();

          var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
          $addToCartForm.after(warning);
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text("Add to Cart").removeClass('zoomOut').addClass('zoomIn');
        }
      });

      return false;
    });
  },
  unload: function(){

  }
}

/*============================================================================
  Utils
==============================================================================*/

var toggleSidebarBlocks = function($toggle){
  if($toggle.next('ul').is(':visible')) {
    $toggle.next('ul').hide();
    $toggle.children('span').html('+');
    $toggle.attr('aria-expanded', false);
  } else {
    $toggle.next('ul').show();
    $toggle.children('span').html('-');
    $toggle.attr('aria-expanded', true);
  }
}

var toggleSidebarMenus = function($toggle){
  var $content = $toggle.next('ul');
  $content.slideToggle();
  $toggle.toggleClass('active');
  $toggle.attr('aria-expanded', $toggle.attr('aria-expanded') == 'true' ? 'false' : 'true');
}

var sliderBlock = {
  select: function(blockId, $parentSection){
    var $blocks = $parentSection.find('li[data-block-id]:not(".clone")');
    var blockIdsArray = $blocks.map(function() {
      return String($(this).data('block-id'));
    });
    var slider = $parentSection.find('.flexslider').data('flexslider');

    slider.pause();

    for(var i = 0; i < blockIdsArray.length; i++){
      if(blockIdsArray[i] === blockId){
        var currentSlide = i;
        if (currentSlide !== slider.currentSlide){
          slider.flexAnimate(parseInt(currentSlide));
        }
      }
    }
  },
  deselect: function($parentSection){
    var slider = $parentSection.find('.flexslider').data('flexslider');
    if(slider) {
      slider.play();
    }
  }
}

// hashCode method implementation
String.prototype.hashCode = function() {
  var hash = 0, i, chr;
  if (this.length === 0) return hash;
  for (i = 0; i < this.length; i++) {
    chr   = this.charCodeAt(i);
    hash  = ((hash << 5) - hash) + chr;
    hash |= 0; // Convert to 32bit integer
  }
  return hash;
};

/*============================================================================
  Start of cart-related functionality
==============================================================================*/
function ajaxSubmitCart() {
  $cart = $("#cart-sidebar").addClass('loading');
  $.ajax({
    url: '/cart/update.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: $cart.serialize(),
    success: function (data) {
      refreshCart(data,false);
    }
  });
}

function ajaxUpdateCart(lineID, quantity, parent) {
  $.ajax({
    url: '/cart/change.js',
    dataType: 'json',
    cache: false,
    type: 'post',
    data: { quantity: quantity, line: lineID },
    success: function (data) {
      refreshCart(data,false);

      var lineIDIndex = lineID - 1;
      var $input = parent.find("input[data-line-id='" + lineID + "']");

      //check to see if there are correct amount of products in array
      if (typeof data.items[lineIDIndex] === "undefined"){
        var updated_quantity = 0;
      } else {
        var updated_quantity = data.items[lineIDIndex].quantity;
      }

      if(quantity > 0 && quantity != updated_quantity) {
        if (updated_quantity == 1) {
          items_left_text = "item left";
        } else {
          items_left_text = "items left";
        }

        $('.warning--quantity').remove();

        var warning = '<div class="warning warning--quantity animated bounceIn">' + updated_quantity + ' ' + items_left_text + '</div>';

        $input.parent().next().find(".item_info").append(warning);
        $input.val(updated_quantity);
      }
    }
  });
}

function reviewPromoHolidayPromotion4(cart){
  if (window.promo4 && window.promo4.threshold){
    var threshold = window.promo4.threshold / 100;
    var unlocked = window.promo4.unlocked === '4' ? true : false;
    var new_price = cart.total_price / 100;
    if (new_price >= threshold && !unlocked){
      window.location.reload(true);
    }
    else if (new_price < threshold && unlocked){
      window.location.reload(true);
    }
  }
}
function processPromoHolidayCartPromotion4() {
  var cartItems = $('.mm-panels .discount--item');
  var foundGift = false;
  var promoObject = window.promo4;
  var promoCode = '4';
  if (!promoObject || !promoObject.variants || promoObject.variants.length == 0)
    return false;
  if (!promoObject || promoObject.unlocked !== promoCode)
    return false;

  $.each(cartItems, function(i, item) {

    var variantIdElement = $(item).find('span.discount--item-variant');
    var variantId = $(variantIdElement).text();
    for (var i=0; i<window.promo4.variants.length; i++){
      var thisVariant = window.promo4.variants[i];
      if (variantId == thisVariant.variantId){

        // this is the discounted item
        var thisLineItem = $(item);
        thisLineItem.css('pointer-events', 'none');
        thisLineItem.find('p.remove_item').css('pointer-events', 'auto');
        var removeEl = thisLineItem.find('p.remove_item').find('a');
        var cartForms = $('form#cart_form, form#cart');
        if (removeEl) {
          removeEl.on('click', function () {
            localStorage.setItem('wanderer_4_remove_clicked', true);
          })
        }
        if (cartForms) {
          cartForms.on('submit', function () {
            localStorage.setItem('wanderer_4_checkout_clicked', true);
          })
        }

        var priceElement = $(thisLineItem).find('.discount--item-price');
        var subtotalElement = $(thisLineItem).parents('form').find('.discount--subtotal');

        var oldItemPrice = priceElement.find('.money').text();
        oldItemPrice = oldItemPrice.replace('$', '');
        var oldItemPrice = parseFloat(oldItemPrice) * 100;
        priceElement.html('<span class="money">' + Shopify.formatMoney(0, $('body').data('money-format')) + ' - FREE!' + '</span>');

        var oldSubtotal = subtotalElement.find('.money').text();
        oldSubtotal = oldSubtotal.replace('$', '').replace(',','');
        var oldSubtotal = parseFloat(oldSubtotal) * 100;

        var newSubtotal = oldSubtotal - oldItemPrice;
        subtotalElement.html('<span class="money">' + Shopify.formatMoney(newSubtotal, $('body').data('money-format')) + '</span>');

      }
    }
  })
}
function reviewPromoHolidayPromotion3(cart){
  if (window.promo3 && window.promo3.threshold){
    var threshold = window.promo3.threshold;
    var unlocked = window.promo3.unlocked === '3' ? true : false;
    var item_count = cart.item_count;
    if (item_count >= threshold && !unlocked){
      window.location.reload(true);
    }
    else if (item_count <= threshold && unlocked){
      window.location.reload(true);
    }
  }
}
function processPromoHolidayCartPromotion3() {
  var ajaxCartForm = $('form#cart');
  var promoObject = window.promo3;
  var promoCode = '3';
  if (!promoObject || promoObject.unlocked !== promoCode)
    return false;

  var subtotalElement = $(ajaxCartForm).find('.discount--subtotal');

  var oldSubtotal = subtotalElement.find('.money').text();
  oldSubtotal = oldSubtotal.replace('$', '').replace(',','');
  var oldSubtotal = parseFloat(oldSubtotal) * 100;

  var amountOff = window.promo3.amountOff || 0;
  amountOff = amountOff * 100;

  var newSubtotal = oldSubtotal - amountOff;
  subtotalElement.html('<span class="money">' + Shopify.formatMoney(newSubtotal, $('body').data('money-format')) + '</span>');

}

function reviewPromoHolidayPromotion1(cart){

  var promoToken = "FREEMYSTERYBRACELET";
  var hasToken = false;
  var tokenFromLocalStorage = localStorage.getItem('wanderer_token');
  if (tokenFromLocalStorage === promoToken)
    hasToken = true;

  if (window.promo1A && window.promo1A.threshold && !hasToken){
    var threshold = window.promo1A.threshold / 100;
    var unlocked = window.promo1A.unlocked === '1A' ? true : false;
    var new_price = cart.total_price / 100;
    var free_product_price = 24;
    if (new_price >= threshold && !unlocked){
      window.location.reload(true);
    }
    else if ((new_price - free_product_price) < threshold && unlocked){
      window.location.reload(true);
    }
  }
  if (window.promo1B && window.promo1B.threshold && hasToken){
    var threshold = window.promo1B.threshold;
    var unlocked = window.promo1B.unlocked === '1B' ? true : false;
    var item_count = cart.item_count;
    if (item_count >= threshold && !unlocked){
      window.location.reload(true);
    }
    else if (item_count <= threshold && unlocked){
      window.location.reload(true);
    }
  }
}
function processPromoHolidayCartPromotion1() {
  var promoToken = "FREEMYSTERYBRACELET";
  var hasToken = false;
  var tokenFromLocalStorage = localStorage.getItem('wanderer_token');
  if (tokenFromLocalStorage === promoToken)
    hasToken = true;

  var cartItems = $('.mm-panels .discount--item');
  var foundGift = false;
  var promoObject = hasToken ? window.promo1B : window.promo1A;
  var promoCode = hasToken ? '1B' : '1A';
  if (!promoObject || !promoObject.variantId)
    return false;
  if (!promoObject || promoObject.unlocked !== promoCode)
    return false;

  $.each(cartItems, function(i, item) {

    var variantIdElement = $(item).find('span.discount--item-variant');
    var variantId = $(variantIdElement).text();
    if (variantId == promoObject.variantId){
      // this is the discounted item
      var thisLineItem = $(item);
      thisLineItem.css('pointer-events', 'none');
      thisLineItem.find('p.remove_item').css('pointer-events', 'auto');
      var removeEl = thisLineItem.find('p.remove_item').find('a');
      var cartForms = $('form#cart_form, form#cart');
      if (removeEl) {
        removeEl.on('click', function () {
          localStorage.setItem('wanderer_remove_clicked', true);
        })
      }
      if (cartForms) {
        cartForms.on('submit', function () {
          localStorage.setItem('wanderer_checkout_clicked', true);
        })
      }

      var priceElement = $(thisLineItem).find('.discount--item-price');
      var subtotalElement = $(thisLineItem).parents('form').find('.discount--subtotal');

      var oldItemPrice = priceElement.find('.money').text();
      oldItemPrice = oldItemPrice.replace('$', '');
      var oldItemPrice = parseFloat(oldItemPrice) * 100;
      priceElement.html('<span class="money">' + Shopify.formatMoney(0, $('body').data('money-format')) + ' - FREE!' + '</span>');

      var oldSubtotal = subtotalElement.find('.money').text();
      oldSubtotal = oldSubtotal.replace('$', '').replace(',','');
      var oldSubtotal = parseFloat(oldSubtotal) * 100;

      var newSubtotal = oldSubtotal - oldItemPrice;
      subtotalElement.html('<span class="money">' + Shopify.formatMoney(newSubtotal, $('body').data('money-format')) + '</span>');

    }
  })
}

function buildPreviewUrlFromLineItem(item) {
  var props = item.properties;
  var url = null;

  if(!props) {
    return null;
  }

  if(props.initial1 && props.initial2 && props.initial3 && props.initial4) {
    if(item.title.includes('Beaded') || item.title.includes('Wood') || item.title.includes('Woven')) {
      var color = item.variant_options[0];
    } else {
      var color = item.variant_options[1];    
    }
    var params = [];
    params.push('left=' + encodeURIComponent(props.initial1));
    params.push('right=' + encodeURIComponent(props.initial2));
    params.push('up=' + encodeURIComponent(props.initial3));
    params.push('down=' + encodeURIComponent(props.initial4));
    params.push('color=' + encodeURIComponent(color));
    params.push('action=preview');
    if(item.title.includes('Beaded') || item.title.includes('Wood')) {
      url = 'https://w.sellry.com/beaded-crossed-preview/?' + params.join('&');
    } else if(item.title.includes('Woven')) {
      url = 'https://w.sellry.com/woven-crossed-preview/?' + params.join('&');
    } else {
      url = 'https://w.sellry.com/crossed-path-preview/?' + params.join('&');
    }

  } else if(typeof props.initial1 !== 'undefined' && typeof props.initial2 !== 'undefined' && typeof props.initial3 !== 'undefined') {
    var color = item.variant_options[0];
    var params = [];
    params.push('up=' + encodeURIComponent(props.initial1));
    params.push('middle=' + encodeURIComponent(props.initial2));
    params.push('down=' + encodeURIComponent(props.initial3));
    params.push('color=' + encodeURIComponent(color));
    params.push('action=preview');
    if(item.title.includes('Beaded') || item.title.includes('Wood')) {
      url = 'https://w.sellry.com/beaded-winged-heart-preview/?' + params.join('&');
    } else {
      url = 'https://w.sellry.com/winged-heart-preview/?' + params.join('&');
    }
  } else if(props.Latitude && props.Longitude) {
    if(item.title.includes('Beaded') || item.title.includes('Wood') || item.title.includes('Woven')) {
      var color = item.variant_options[0];
    } else {
      var color = item.variant_options[1];    
    }

    if(color == 'Default Title') {
      color = 'Black';
    }

    var params = [];
    params.push('lat=' + encodeURIComponent(props.Latitude));
    params.push('lng=' + encodeURIComponent(props.Longitude));
    params.push('color=' + encodeURIComponent(color));
    params.push('action=preview');
    if(item.title.includes('Beaded') || item.title.includes('Wood')) {
      url = 'https://w.sellry.com/beaded-coordinates-preview/?' + params.join('&');
    } else if(item.title.includes('Woven')) {
      url = 'https://w.sellry.com/woven-coordinates-preview/?' + params.join('&');
    } else {
      url = 'https://w.sellry.com/bracelet-preview/?' + params.join('&');
    }

  } else if (props.date1 && props.date2 && props.date3) {
    if(item.title.includes('Beaded') || item.title.includes('Wood') || item.title.includes('Woven')) {
      var color = item.variant_options[0];
    } else {
      var color = item.variant_options[1];    
    }

    var params = [];
    params.push('left=' + props.date1);
    params.push('right=' + props.date2);
    params.push('bottom=' + props.date3);
    params.push('color=' + encodeURIComponent(color));
    params.push('action=preview');
    if(item.title.includes('Beaded') || item.title.includes('Wood')) {
      url = 'https://w.sellry.com/beaded-date-preview/?' + params.join('&');
    } else if(item.title.includes('Woven')) {
      url = 'https://w.sellry.com/woven-date-preview/?' + params.join('&');
    } else {
      url = 'https://w.sellry.com/date-bracelet-preview/?' + params.join('&');
    }

  } else if (props.words) {
    var color = item.variant_options[0];
    var params = [];
    params.push('word=' + encodeURIComponent(props.words));
    params.push('color=' + encodeURIComponent(color));
    params.push('action=preview');
    if(item.title.includes('Beaded') || item.title.includes('Wood')) {
      url = 'https://w.sellry.com/beaded-word-preview/?' + params.join('&');
    } else {
      url = 'https://w.sellry.com/word-bracelet-preview/?' + params.join('&');
    }  

  }

  return url;
};

function refreshCart(cart, reload) {
  reload = typeof reload !== 'undefined' ? reload : true;

  if (reload) {
    
    
    
  }

  var cart_update = new CustomEvent('cart_updated',{
    detail: {
      cart: cart
    }
  });
  
  window.dispatchEvent(cart_update);

  $cartBtn = $(".icon-cart");
    $.ajax({
        url: window.location.href, 
        cache: false,
        success: function(response) {
            $('#cart-sidebar').html($(response).find("#cart-sidebar").html());
            // $('.icon-cart.cart-button').html($(response).find(".icon-cart.cart-button").html());
            $(response).find('.icon-cart.cart-button').each(function (i) {
              const html = $(this).html();
              $('.icon-cart.cart-button').eq(i).html(html);
            });

            $("#cart-sidebar").removeClass('loading');
        }
    });
}

function addUpsellToCart(item) {
  let variantId = variantSku = variantPrice = boxType = timeStamp = engravableMessage = false,
      pageRefresh = true,
      variantName = $(item).data('name');

  if($(item)[0].hasAttribute('data-message')){
    engravableMessage = $(item).data('message').trim();
    boxType = $(item).data('box-type');
    timeStamp = $(item).data('timestamp');

    if(engravableMessage.length > 0){
      variantId = $(item).data('engraved-variant-id') || false,
      variantSku = $(item).data('engraved-sku'),
      variantPrice = $(item).data('engraved-price');
    } else {
      variantId = $(item).data('variant-id') || false,
      variantSku = $(item).data('variant-sku'),
      variantPrice = $(item).data('variant-price');
    }
  } else {
    variantId = $(item).data('variant-id') || false,
    variantSku = $(item).data('variant-sku') || false,
    variantPrice = $(item).data('variant-price') || false;
  }

  if( !variantId ) {
    return;
  }

  let options = {
    quantity: 1,
    id: variantId
  }

  if($(item)[0].hasAttribute('data-message')){
    options.properties = { "Box": boxType };
    options.properties.timestamp = timeStamp;
  }

  let actionList = "Cart View";
  if(window.location.hash == '#cartopen') {
    actionList = "Drawer Cart";
  }

  jQuery.post('/cart/add.js', options).always(function(){
    dataLayer.push({
      "event": "productAddToCart",
      "ecommerce": {
        "currencyCode": "USD",
        "add": {
          "actionField": {"list": actionList},
          "products": [
            {
              "id": variantSku,
              "name": variantName,
              "price": variantPrice,
              "variant": variantId,
              "quantity": 1,
              "list": actionList
            }
          ]
        }
      }
    });
  }).done(function() { 
    if(engravableMessage.length > 0) {
      let variantIdentifier = variantSku + '_' + timeStamp + '_Text',
          attributeMessage = {},
          cartPayload = {};

      attributeMessage[variantIdentifier] = engravableMessage;
      cartPayload.attributes = attributeMessage;

      // Cart update to include keepsake box message
      jQuery.post('/cart/update.js', cartPayload).always(function(){}).done(function() { 
        if(pageRefresh) {
          if(document.URL.indexOf('cartopen') !== -1) {
            window.location.hash = 'cartopen';
          }
          window.location.reload(true);
        }       
      });  
    } else {
      if(pageRefresh) {
        if(document.URL.indexOf('cartopen') !== -1) {
          window.location.hash = 'cartopen';
        }
        window.location.reload(true);
      }
    }
  }).fail(function() {  
    let messagesContainer = $('.cart-upsell__messages');
    messagesContainer.html('<span>It was not possible to add the product to your cart</span>');
    setTimeout(function() {
      messagesContainer.empty();
    }, 4000);
  });
}

function setMobileHeaderHeight() {
  if ($('.promo_sticky_banner_mobile--true:visible').length) {
    var promoOuterHeight = $('.promo_sticky_banner_mobile--true').outerHeight();
    $('.mobile-header-wrapper--true').height(40 + promoOuterHeight);
    $('.main_content_area').css('padding-top', 0);
  } else {
    var headerHeight = $('.header').height();
    $('.product .main_content_area').css('padding-top', headerHeight);
    $('.mobile-header-wrapper--true').height(0);
  }
}

window.addEventListener('DOMContentLoaded', function() {
  if($('textarea.engravable_message_upsell').length > 0) {
    $('.cart-upsell__content').on('keyup','textarea.engravable_message_upsell', function(event){

      let wrapper = $(event.delegateTarget),
          textarea_val = $(this).val().replace(/[^a-zA-Z [\!@#\$%\^&\*\(\)_\-\+=\{\}\[\]\|;:,\.\?\\\]\d\r\n\\?\!\.\-]/g, ''),
          char_limit = parseInt($(wrapper).find('.char-limit span').text()),
          input_length = char_limit - textarea_val.length;

          $(wrapper).find('.char-limit em').text(input_length > 0 ? input_length : 0);

          // Update textarea and data attribute
          let updatedMessage = textarea_val.slice(0, char_limit);
          $(this).val(updatedMessage);
          $(wrapper).find('.cart-upsell-button').attr('data-message', updatedMessage);
    }).trigger('keyup');
  }

  if($('#cart_form').length > 0 && $('#cart_form').find('.cart-upsell') ) {
    let $cartUpsell = $('#cart-sidebar').find('.cart-upsell');
    dataLayer.push({
      "event": "productImpressions",
      "ecommerce": {
        "currencyCode": "USD",
        "impressions": [
          {
            "id": $cartUpsell.find('.cart-upsell-button').data('variant-sku'),
            "name": $cartUpsell.find('.cart-upsell__content-name').text(),
            "price": $cartUpsell.find('.cart-upsell-button').data('variant-price'),
            "position": 0,
            "variant": $cartUpsell.find('.cart-upsell-button').data('variant-id'),
            "list": "Cart View"
          }
        ]
      }
    });
  }
});

window.addEventListener('DOMContentLoaded', function() {
  /*window.lazySizesConfig = window.lazySizesConfig || {};
  window.lazySizesConfig.expand = 1500;
  window.lazySizesConfig.loadMode = 1;*/

  //Load sections
  slideshow.init();
  header.init();
  map.init();
  testimonials.init();
  featuredProducts.init();
  product.init();
  collection.init();
  productFormListeners.init();
  video.init();
  pageBanner.init();
  cart.init();
  cart.initSidebar();

  //Sidebar toggle
  $(document).on('click', '.menu-toggle', function(e) {
    toggleSidebarMenus($(this));
  });
  var sidebarTouched = false;
  $(document).on('touchstart', '.toggle', function(e) {
    if ($(window).width() <= 767 || $(this).parents('.sidebar').hasClass('toggle-all--true')) {
      var $toggle = $(this);
      toggleSidebarBlocks($toggle);
      sidebarTouched = true;
      e.preventDefault();
      return false;
    }
  });
  $(document).on('click', '.toggle', function(e) {
    if ($(window).width() <= 767 || $(this).parents('.sidebar').hasClass('toggle-all--true')) {
      var $toggle = $(this);
      if (!sidebarTouched) {
        toggleSidebarBlocks($toggle);
        e.preventDefault();
        return false;
      }
    }
  });

  if($('.header-section .logo-below').length > 0) {
    $('#content .index-sections').removeClass('adjust-header');
  } else {
    $('#content .index-sections').addClass('adjust-header');
  }

  // Load Accordions
  var allPanels = $('.accordion > dd').hide();
  var allActions = $('.accordion > dt > a');
  $('.accordion > dt > a').click(function() {
    allActions.removeClass('open');

    if(!$(this).parent().next().is(":visible")) {
      allPanels.slideUp();
      $('.accordion small.right').html('&#9668;');
      $(this).find('small.right').html('&#9660;');
      $(this).parent().next().slideDown();
      $(this).addClass('open');
    } else {      
      allPanels.slideUp();
      $(this).removeClass('open');
    }
    return false;
  });

  $($('.accordion:not(.product__accordion-faq) > dt > a')[0]).trigger('click');

  $('.slider').flexslider({
    touch: false,
    directionNav: false,
    controlNav: false,
    animation: "fade",
    fadeFirstSlide: false
  });

  $('.slider-no-nav').flexslider({
    touch: false,
    controlNav: false,
    directionNav: false,
    animation: "fade",
    fadeFirstSlide: false
  });

  $('.slider-no-nav-quick').flexslider({
    touch: false,
    controlNav: false,
    directionNav: false,
    animation: "fade",
    slideshowSpeed: 4000,
    fadeFirstSlide: false
  });

  $("body").on("click", '.continue', function() {

    var cart = $("#cart").data( "mmenu" );
    cart.close();

    var nav = $("#nav").data( "mmenu" );
    nav.close();

  });

  $("body").on("click", '#search-toggle, .search-close', function(e) {
    
    if($('#search').is(":visible") && $(window).scrollTop() == 0) {
      $(".index .header").removeClass('header_bar');
      $('.index .header .logo img').attr('src', $('.logo img').data('src-home'));
    } else {
      $(".index .header").addClass('header_bar');
      $('.index .header .logo img').attr('src', $('.logo img').data('src'));
    }

    $('#search').fadeToggle('fast').find('input').focus();
    e.stopPropagation();
    e.preventDefault();
    $('.search-close').css('top', $('#search form').offset().top + 'px');
    $('#search input[name="q"]').val('');
  });

  if($('.flexslider img').length == 1) { $('.flexslider .flex-direction-nav').hide() }
  $(".search-submit").on('click', function(e) { $(this).parent('form').submit(); });
  $('.lightbox').fancybox();

  if ($(window).width() >= 959) {

    var modal_width = '860px';

    $('.thumbnail').hover(function(){
      $('.quick_shop', this).show();
    }, function(){
      $('.quick_shop', this).hide();
    })

    if($(window).width() >= 1200 || $('html').hasClass('ie')) {
      modal_width = '1100px'
    }
  }

  $(".fancybox").fancybox({
    padding: 0,
    wrapCSS: 'gallery'
  });

  

  

  $('#tag_filter').change(function() { window.location = $('#tag_filter option:selected').val(); });

  Shopify.queryParams = {};
  if (location.search.length) {
    for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
      aKeyValue = aCouples[i].split('=');
      if (aKeyValue.length > 1) {
        Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
      }
    }
  }

  var tabs = $('ul.tabs');
  tabs.each(function(i) {
    var tab = $(this).find('> li > a');
    tab.click(function(e) {
      var contentLocation = $(this).attr('href');
      if(contentLocation.charAt(0)=="#") {
        e.preventDefault();
        tab.removeClass('active');
        $(this).addClass('active');
        $(this).parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
      }
    });
  });

  if ($('.shopify-section.page-details-section, .product_gallery').length){
    // Don't apply mediaWrapper
  } else if ($('body').hasClass('index')) {
    $('.featured-products-section iframe[src*=youtube], .featured-products-section iframe[src*=vimeo]').mediaWrapper({
      intrinsic: true
    });
  } else {
    $('iframe[src*=youtube]:not(.shogun-video-embed), iframe[src*=vimeo]:not(.shogun-video-embed)').mediaWrapper({
      intrinsic: true
    });
  }

  var $contact_form = $('.newsletter .contact-form');
  $contact_form.each(function() {
    var $cf = $(this);
    $cf.on('submit', function (e) {
      if($('input[name="challenge"]', $cf).val() !== "true") {
        $.ajax({
          type: $cf.attr('method'),
          url: $cf.attr('action'),
          data: $cf.serialize(),
          success: function (data) {
            $cf.fadeOut("slow", function(){
              $cf.prev('.message').html("Thank you for joining our mailing list!");
            });
          },
          error: function(data) {
            $('input[name="challenge"]', $cf).val('true');
            $cf.submit();
          }
        });
        e.preventDefault();
      }
    });
  });

  
    $('.swatch :radio').change(function() {
      var optionIndex = $(this).closest('.swatch').attr('data-option-index');
      var optionValue = $(this).val();
      $(this)
        .closest('form')
        .find('.single-option-selector')
        .eq(optionIndex)
        .val(optionValue)
        .trigger('change');
    });
  

  $('.maps').on('click', function () {
    $('.maps iframe').css("pointer-events", "auto");
  });

  /*============================================================================
    Home page - social media
  ==============================================================================*/

  

  if (document.URL.indexOf('cartopen') != -1) {
    $('.cart-button').click();
  } 

  $('.cart-item-see-customization').on('click', function(e) {
    e.preventDefault();

    $(this).next('.cart-item-customization').toggle();
    if($(this).find('span').text() == "See") $(this).find('span').text("Hide");
    else $(this).find('span').text("See");
  });

  setMobileHeaderHeight();
  let windowWidth = $(window).width();
  $(window).resize(function () {
    if ($(this).width() != windowWidth) {
      setMobileHeaderHeight();
    }
  });
});

var singleTime = true;
var firstTime = true;
selectCallback = function(variant, selector) {
  if (!singleTime) return;

  singleTime = false;
  setTimeout(function(){
    singleTime = true;
  }, 150);

  var $product = $('.product-' + selector.product.id);
  var $notify_form = $('.notify-form-' + selector.product.id);
  var $productForm = $('.product_form', $product);
  var variantInventory = $productForm.data('variant-inventory');

  product.destroySlider($product);
  product.initSlider($product, variant);

  if (variant) {
    if (variantInventory) {
      variantInventory.forEach(function(v){
        if (v.id === variant.id) {
          variant.inventory_quantity = v.inventory_quantity;
          variant.inventory_management = v.inventory_management;
          variant.inventory_policy = v.inventory_policy;
        }
      });
    }

    $('.sku span', $product).text(variant.sku);
    $(".notify_form_message", $product).attr("value", $(".notify_form_message", $product).data('body') + " - " + variant.title);

    
      $productForm.find('.swatch__list__item').removeClass('active');
      for (var i=0,length=variant.options.length; i<length; i++) {
        var radioButton = $productForm.find('.swatch[data-option-index="' + escape(i) + '"] :radio[value="' + variant.options[i].replace(/\"/g,'\\"') +'"]');
        if (radioButton.length) {
          radioButton.get(0).checked = true;
          radioButton.closest('.swatch__list__item').addClass('active');
        }
      }
    
  }

  if (variant && variant.available == true) {

    var isVisualDiscEnabled = false;
    if(variant.price < variant.compare_at_price ){
      $('.was_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.compare_at_price, $('body').data('money-format')) + '</span>');

    } else if(isVisualDiscEnabled) {
      $('.was_price', $product).html('<span class="money">' + Shopify.formatMoney(variant.price, $('body').data('money-format')) + '</span>');
    }
    else {
      $('.was_price', $product).html('')
    }

    if (variant.inventory_management && variant.inventory_quantity > 0) {
      
      
        if(variant.inventory_policy == "deny") {
          $('.quantity', $product).attr('max', variant.inventory_quantity);
        }
      
    } else {
      $('.items_left', $product).text('');
      $('.quantity', $product).removeAttr('max');
    }

    $('.sold_out', $product).text('');
    if (variant.price > 0) {
      
        $('.current_price', $product).html('<span class="money test">' + Shopify.formatMoney(variant.price, $('body').data('money-format')) + '</span>');
      
    } else {
      $('.current_price', $product).html("Free");
    }
    $('.add_to_cart', $product).removeClass('disabled').removeAttr('disabled').find('span').text($('.add_to_cart', $product).data('label'));
    $('.add_2_to_cart', $product).removeClass('disabled').removeAttr('disabled').show();
    $('.shopify-payment-button', $product).show();
    $notify_form.hide();
  } else {
    var message = variant ? "Sold Out" : "Unavailable";
    $('.was_price', $product).html('');
    $('.current_price', $product).html('');
    $('.items_left', $product).text('');
    $('.quantity', $product).removeAttr('max');
    $('.sold_out', $product).text(message);
    $('.add_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').find('span').text(message);
    $('.add_2_to_cart', $product).addClass('disabled').attr('disabled', 'disabled').hide();
    $('.shopify-payment-button', $product).hide();
    $notify_form.fadeIn();
  }

  

  if (variant && variant.available == true)  {
    $('.purchase-details', $product).show();
  } else {
    $('.purchase-details', $product).hide();
  }

  if (firstTime) {
    firstTime = false;
  } else if (variant) {
    if (variant.name && variant.name.indexOf('Custom Coord') > -1) {
      if (!firstTime){
        $('.swatch_options').addClass('is-loading');
      } else {
        firstTime = false;
      }
      setTimeout(function() {
        // wait to leave enough time for the slider to initiliaze
        $('body').trigger( 'selectCallback', [ variant ] );
      }, 500);
    } else if (variant.name && variant.name.indexOf('Crossed Path') > -1) {
      setTimeout(function() {
        // wait to leave enough time for the slider to initiliaze
        $('body').trigger( 'selectCallback', [ variant ] );
      }, 200);
    } else {
      $('body').trigger( 'selectCallback', [ variant ] );
    }
  }

  $productForm.removeClass("init");
};

function htmlEncode(value){
    if (value) {
        return $('<div/>').text(value).html();
    } else {
        return '';
    }
}

String.prototype.clearEmojis = function() {
  return this.replace(/\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83E\uDDD1(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB-\uDFFE])|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83E\uDDD1(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC3B\u200D\u2744|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F\u200D[\u2640\u2642]|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E-\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3C-\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDF])\u200D[\u2640\u2642])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F?|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g, '');
}

String.prototype.clearEmojisKeepNumbers = function() {
  return this.replace(/\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83D[\uDC66\uDC67]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708])\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83E\uDDD1(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB-\uDFFE])|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69])(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83E\uDDD1(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC3B\u200D\u2744|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F\u200D[\u2640\u2642]|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642])|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E-\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3C-\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDF])\u200D[\u2640\u2642])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])|(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26A7\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDED5-\uDED7\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0C-\uDD3A\uDD3C-\uDD45\uDD47-\uDD78\uDD7A-\uDDCB\uDDCD-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6])\uFE0F?|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDC8F\uDC91\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1F\uDD26\uDD30-\uDD39\uDD3C-\uDD3E\uDD77\uDDB5\uDDB6\uDDB8\uDDB9\uDDBB\uDDCD-\uDDCF\uDDD1-\uDDDD])/g, '');
}

var destroySlider = function(slider) {
  if (slider && slider.data('flexslider')){
    var slider = slider.data('flexslider');
    var classNamespace = '.' + slider.vars.namespace; // Namespaced class selector
    if (slider.vars.controlNav) slider.controlNav.closest(classNamespace + 'control-nav').remove(); // Remove control elements if present
    if (slider.vars.directionNav) slider.directionNav.closest(classNamespace + 'direction-nav').remove(); // Remove direction-nav elements if present
    if (slider.vars.pausePlay) slider.pausePlay.closest(classNamespace + 'pauseplay').remove(); // Remove pauseplay elements if present
    slider.find('.clone').remove(); // Remove any flexslider clones
    slider.unbind(slider.vars.eventNamespace); // Remove events on slider
    if ( slider.vars.animation != "fade" ) slider.container.unwrap(); // Remove the .flex-viewport div
    slider.container.removeAttr('style') // Remove generated CSS (could collide with 3rd parties)
    slider.container.unbind(slider.vars.eventNamespace); // Remove events on slider
    slider.slides.removeAttr('style'); // Remove generated CSS (could collide with 3rd parties)
    slider.slides.filter(classNamespace + 'active-slide').removeClass(slider.vars.namespace + 'active-slide'); // Remove slide active class
    slider.slides.unbind(slider.vars.eventNamespace); // Remove events on slides
    $(document).unbind(slider.vars.eventNamespace + "-" + slider.id); // Remove events from document for this instance only
    $(window).unbind(slider.vars.eventNamespace + "-" + slider.id); // Remove events from window for this instance only
    slider.stop(); // Stop the interval
    slider.removeData('flexslider'); // Remove data
  }
}

document.addEventListener('shopify:block:select', function(e){

    var blockId = e.detail.blockId;
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.select(blockId, $parentSection)
    }

});


document.addEventListener('shopify:block:deselect', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('slideshow-section') || $parentSection.hasClass('testimonial-section')){
      sliderBlock.deselect($parentSection)
    }

});

document.addEventListener('shopify:section:load', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    header.init();

    if ($parentSection.hasClass('cart-section')){
      productFormListeners.init();
    }

    if ($parentSection.hasClass('faq-template-section')){
      faqAccordion.init();
    }

    if ($parentSection.hasClass('image-with-text-overlay-section')){
      banner.init();
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.init();
    }

    if ($parentSection.hasClass('map-section')){
      map.init();
    }

    if ($parentSection.hasClass('page-details-section')){
      map.init();
    }

    if ($parentSection.hasClass('contact-template-section')){
      map.init();
    }

    if ($parentSection.hasClass('featured-product-section')){
      product.init();
    }

    if ($parentSection.hasClass('featured-collection-section')){
      collection.init();
      product.init();
    }

    if ($parentSection.hasClass('video-section')){
      video.init();
    }

    if ($parentSection.hasClass('page-details-section')){
      video.init();
    }

    if ($parentSection.hasClass('product-template-section')){
      collection.init();
      product.init();
    }

    if ($parentSection.hasClass('collection-template-section')){
      collection.init();
      product.init();
    }

    if ($parentSection.hasClass('banner-template-section')){
       $('.banner-flexslider').flexslider({touch: false, controlNav: false, directionNav: false, animation: "fade" });
    }

    if ($parentSection.hasClass('search-template-section')){
      collection.init();
    }

    if ($parentSection.hasClass('testimonial-section')){
      testimonials.init();
    }

    if ($parentSection.hasClass('featured-products-section')){
      featuredProducts.init();
    }
});

document.addEventListener('shopify:section:unload', function(e){

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    banner.unload($target);

    if ($parentSection.hasClass('social-feeds-section')){
      $('.social-feeds-wrap').each(function (index, value) {
        social.unload($target);
      });
    }

    if ($parentSection.hasClass('slideshow-section')){
      slideshow.unload($target);
    }

    if ($parentSection.hasClass('featured-product-section')){
      product.unload($target);
    }

    if ($parentSection.hasClass('featured-collection-section')){
      collection.unload($target);
    }

    if ($parentSection.hasClass('product-template-section')){
      product.unload($target);
    }

    if ($parentSection.hasClass('collection-template-section')){
      collection.unload($target);
    }

});

document.addEventListener('shopify:section:select', function(e){

    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    if ($parentSection.hasClass('featured-collection-section')){
      collection.init();
      product.init();
    }
});
document.addEventListener('shopify:section:reorder', function(e){

    var $target = $(e.target);
    var $parentSection = $('#shopify-section-' + e.detail.sectionId);

    banner.unload($target);
    banner.init();

});

$(document).ready(function(){

  //remove help me shoose links if PDP not have image for popup
  if($('#mobileWovenSizePopup').length && !$('.sizeguide__mobile__configurator').length) {
    $('#mobileWovenSizePopup').remove();
  } 
  if($('#dekstopWovenSizePopup').length && !$('.sizeguide__desktop__configurator').length) {
    $('#dekstopWovenSizePopup').remove();
  }
  
  if($('#dekstopWovenSizePopup').length) {
   	$('.swatch_options').addClass('swatchPaddingFIx'); 
  }

  $('#mobileWovenSizePopup').click(function(e){
    e.preventDefault();
    $('.sizeguide__mobile__configurator').fancybox().trigger('click');
  })
  $( "body" ).on( "click", '#dekstopWovenSizePopup', function(e) {
    e.preventDefault();
    $('.sizeguide__desktop__configurator').fancybox().trigger('click');
    $('body').addClass('closeMove'); 
  })
  
  if($('template-product'.length)) {
    $('.swatch_options .swatch__list__item .color label').each(function(){
      var alternativeImgURL = $(this).attr('data-alternative-color');
      if(alternativeImgURL != null && alternativeImgURL != '') {
        if(isUrlExists(alternativeImgURL)) {
          $(this).attr('data-bg',alternativeImgURL);
          $(this).css('background-image','url(' + alternativeImgURL + ')');
        }
      }
    })
  }

  $('.mobile-mobile-configurator__nav__list .mobile-configurator__nav__label__thumbnail').each(function(){
    var alternativeImgURL = $(this).attr('data-alternative-color');
    if(alternativeImgURL != null && alternativeImgURL != '') {
      if(isUrlExists(alternativeImgURL)) {
        $(this).attr('src',alternativeImgURL);
        //$(this).css('background-image','url(' + alternativeImgURL + ')');
      }
    }
  })

  $('.mobile-configurator__panel .color label').each(function(){
    var alternativeImgURL = $(this).attr('data-alternative-color');
    if(alternativeImgURL != null && alternativeImgURL != '') {
      if(isUrlExists(alternativeImgURL)) {
        $(this).attr('data-bg',alternativeImgURL);
        $(this).css('background-image','url(' + alternativeImgURL + ')');
      }
    }
  })
  
  if($('body').hasClass('cart') && $(window).width() < 768 && $('.additional-checkout-buttons').length) {

    $("#sticky_cart_form").append($('.additional-checkout-buttons')); 

  }

  setTimeout(freeBannerPDPfix, 3000);
  
  /* Collection set */
  if($('.collection-sets').length) {

    $('.info').each(function(){
      var current = $(this);
      $.ajax({
        url: current.find('.collLink').attr('href'),
        success:function(res,statusText,jQxhr){

          var originPrice = $(res).find('.modal_price .money').text();
          if(parseInt($(res).find('.addNewBracelet').attr('data-products-count')) === 1) {
            originPrice = '';
          }
          
          var priceWithDiscount = $(res).find('.modal_price .discount_price').text();
          var discountPercent = $(res).find('.addNewBracelet').attr('data-discount-percent');

          if($(res).find('.customizerGiftBox').length) {

            originPrice = parseFloat(priceWithDiscount.replace('$',''));
            priceWithDiscount = parseFloat(priceWithDiscount.replace('$',''));

            var discountGB = $(res).find('.addNewBracelet').attr('data-gift-box-disc');
            var gbPrice = $(res).find('.customizerGiftBox .originalPrice').text();
            gbPrice = parseFloat(gbPrice.replace('$',''));
            var onePercent = gbPrice / 100;
            onePercent = onePercent.toFixed(2);
            var gbWithDiscount = gbPrice - discountGB * onePercent;
            priceWithDiscount = priceWithDiscount + gbWithDiscount;

            priceWithDiscount = '$'+priceWithDiscount.toFixed(2);
            originPrice = originPrice + gbPrice;
            originPrice = '$'+originPrice.toFixed(2);

            if(parseInt($(res).find('.addNewBracelet').attr('data-products-count')) === 0) {
              priceWithDiscount = '$'+gbPrice;
            }
              
          }

          if(parseInt($(res).find('.addNewBracelet').attr('data-products-count')) <= 1) {
            originPrice = '';
          }

          current.find('.priceOrigin').text(originPrice);
          current.find('.priceDiscount').text(priceWithDiscount);
          if(parseInt($(res).find('.addNewBracelet').attr('data-products-count')) <= 1) {
            current.find('.discountAmount').text('');
          } else {
            current.find('.discountAmount').text(discountPercent + '%');
          }
          if($(res).find('.customizerGiftBox').length) {
            current.find('.discountAmount').text('');
          }
          current.find('.setLink').text( $(res).find('.addNewBracelet').attr('data-cta-text'));
          current.show();
        }
      })
    })
  }

  if(($('.product-4791170826345').length || $('.product-6612775796915').length ) && $(window).width() < 768) {
      var keepboxTitle = $('.counter-excluded .keepsake-box__label').parent().addClass('giftBoxPadding');
      $('.mobile-configurator__nav').prepend(keepboxTitle)
  }

  $("#search input").on('keyup', function (e) {
      if (e.key === 'Enter' || e.keyCode === 13) {
          $('#search form').submit();
      }
  });

  /* engraved_frame PDP*/

  if($('.engraved_frame').length) {

    var checkExist = setInterval(function() {
          if ($('.uploadkit-injected').length) {
            $('.uploadkit-label').text('Step 2 of 2');
              clearInterval(checkExist);
          }
    }, 100);


    $('.purchase-details__quantity .minus').click(function(){
      if(parseInt($('.purchase-details__quantity input.quantity').val()) > 1) {
        $('.purchase-details__quantity input.quantity').val( parseInt($('.purchase-details__quantity input.quantity').val()) - 1)
      }
    })

    $('.purchase-details__quantity .plus').click(function(){
      $('.purchase-details__quantity input.quantity').val( parseInt($('.purchase-details__quantity input.quantity').val()) + 1)
    })

    $('body').on('click', '.uploadkit-button',function(){      
      setInterval(function() {
        if (!$('.uploadcare--dialog_status_active').length) {
          if($('.imgHolder .uploadkit-thumbnail').length) {
            if($('.imgHolder .uploadkit-thumbnail').attr('src') != $('.uploadkit-thumbnails .uploadkit-thumbnail').attr('src')) {
              $('.imgHolder .uploadkit-thumbnail').attr('src', $('.uploadkit-thumbnails .uploadkit-thumbnail').attr('src'))
            }
          } else {
            setTimeout( () => {
              $('.imgHolder').html($('.uploadkit-thumbnails').html())
              $('.frame_preview').show();
            }, 1000)
          }
            //clearInterval(timer2);
        }
      }, 1500);

    })

    $('#EngraveFox--product-template').on('change keyup', function(e) {
      var lines = $(this).val().split("\n");
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].length <= 30) continue;
        var j = 0; space = 30;
        while (j++ <= 30) {
          if (lines[i].charAt(j) === " ") space = j;
        }
        lines[i + 1] = lines[i].substring(space + 1) + (lines[i + 1] || "");
        lines[i] = lines[i].substring(0, space);
      }
      $(this).val(lines.slice(0, 5).join("\n"));
      $('.frame_preview').show();

    })

    $('.frameAdd2Cart').on('click', function(e){
      e.preventDefault();
      

      if(!$('.uploadkit-form').hasClass('uploadkit-invalid')) {
        $('.frame_preview').show();
        $(this).hide();
        $('.loadIcon').show();

        html2canvas($('.frame_preview')[0], {
          letterRendering: 1,
          allowTaint: true,
          useCORS: true,
        }).then(canvas => {
          var img = canvas.toDataURL("image/png");
          var output = encodeURIComponent(img);
      
          var randomProperty = new Date().toTimeString().slice(0, 8).replaceAll(":","") + getRandomInt(1,100);
          
          $('.previewParameter').val('https://w.sellry.com/engraved-frame-previews/images/' + randomProperty + '.png')

          var Parameters = "image=" + output + "&name=" + randomProperty;
          $.ajax({
              type: "POST",
              url: "https://w.sellry.com/engraved-frame-previews/",
              data: Parameters,
              success : function(data)
              {
                  console.log("screenshot done");
                  $('.product-container .action_button.add_to_cart').click();
                  $('.frameAdd2Cart').show();
                  $('.loadIcon').hide();
              }
          }).done(function() {
              //$('body').html(data);
          });
        });

      }

    })

    $('#EngraveFox--product-template').on('input propertychange paste keydown', function() {

      $('.shopify-product-form').addClass('entered_text');

      var val = $(this).val();

      if(val.length > 150) {
        val = val.substring(0, 150);
      }

      val = val.clearEmojisKeepNumbers().replace(/[^\x00-\x7F]/g, "")


      // Disallow any emoji input & arrow keys
      $('#EngraveFox--product-template').val(val);

      var remainLenght = 150 - val.length;

      console.log(remainLenght)

      $('.chars-limit em').text(remainLenght);

      $('.textHolder').text(val)

    })

  } 
  
  if($('.shopify-policy__body').length && window.location.href.includes('privacy-policy')) {
    $('.shopify-policy__body ol').each(function(index ) { 
      $(this).attr('start', index + 1 )  
    })
  }
  
  if($('.product-subscription').length && $('.shg-theme-text-content').length) {
    $('.shg-theme-text-content em').each(function(){
      if($(this).text() == 'monthlyclub@wandererbracelets.com') {
       	$(this).text('info@wandererbracelets.com'); 
      }
    })
  }
  
if($('.freegift_promo--bar').length) {

    var existCondition = setInterval(function() {
      if ($('.freegift_promo--bar:visible').length) {
        
         clearInterval(existCondition);

         if($(window).width() > 767 ) {
          var paddingVar = 40;
          $('.freegift_promo--bar').css({'top':'0px'});
        } else {
          if($('.promo_banner_mobile').length) {
            var paddingVar = parseInt($('.freegift_promo--bar').height()) + 20;
            $('.freegift_promo--bar').css({'top':'80px'});
          } else {
            var paddingVar = parseInt($('.freegift_promo--bar').height()) - 20;
            $('.freegift_promo--bar').css({'top':'40px'});
          }

        }

        if($('body').hasClass('index')) {
          if($(window).width() < 769 && $(window).width() > 396) {
            $('.main_content_area').css('padding-top', ''+ paddingVar +'px'); 
          }

          if($(window).width() < 395 ) {
            $('.main_content_area').css('padding-top', ''+ paddingVar +'px'); 
          }
        }
        
        if($('body').hasClass('product') ) {
          if($(window).width() > 767 ) {
            if($('.promo_banner_mobile').length) {
            paddingVar+= 50;
            $('.main_content_area').css('padding-top', ''+ paddingVar +'px'); 
            } else {
              paddingVar+= 15;
              $('.main_content_area').css('padding-top', ''+ paddingVar +'px'); 
            }
          } else {
              $('.main_content_area').css('padding-top', '0px'); 

          }
        }

      }
     }, 250);

  }
  
  if($('body').hasClass('product') && window.location.href.includes('collections/matching-bracelet-sets')) {
    if($('.shopify-product-form').length && $('.action_button.add_to_cart').length) {

      $('.shopify-product-form').append( "<input type='hidden' name='properties[One-For-Me-One-For-You]' value='yes' /> " );

    }
  }
  
  if($('.toCheckoutBtn').length) {
    $('.product .mobile-configurator__nav__item.mobile-configurator__add-to-cart').addClass('add2buy');
  }

  $('.toCheckoutBtn').click(function(e){
    e.preventDefault();
    $('<input type="hidden" name="return_to" value="/checkout/" />').appendTo($('.shopify-product-form'));
    $('.action_button.add_to_cart').click();
  })

  $('body').on('click', '.cart-subtotal .cart-action #checkout',function(e){
    
    e.preventDefault();

    $(".customizationConfirm .confirmImages").html('');

    $('.cartInnerContainer .cart_page_image img').each(function(){
      if($(this).attr('src').includes('w.sellry.com')) {
        $(this).clone().appendTo(".customizationConfirm .confirmImages");  
      }
    })

    $(' .cart_item  .discount--item-name ').each(function(){
      // check if we have Box or Gift Set in the cart
      if( $(this).text().includes('Jewelry Box') || $(this).text().includes('Gift Set') ) {

        var confirmDiv = "<div class='confirmBoxDiv'><img src=//www.wanderer.co/cdn/shop/t/469/assets/wood-box-confirm_775x.jpg?v=6017613766219491781762439791 />";

        console.log($(this).parent().parent().parent().find('.discount--item-property .propName').text())

        // if we have customizatino text
        if($(this).parent().parent().parent().find('.discount--item-property .propName').text() == 'Text:' ) {

          var bigTextClass = '';

          if($(this).parent().parent().parent().find('.discount--item-property .propVal').text().length > 190) {
            bigTextClass = 'bigText';
          }

          confirmDiv += '<div class="confirmationText ' + bigTextClass + '">' + $(this).parent().parent().parent().find('.discount--item-property .propVal').text() + '</div>'; 

        }

        confirmDiv += '</div>'; 

        $(confirmDiv).appendTo(".customizationConfirm .confirmImages");  

      }
      
    })

    if($('.customizationConfirm img').length) {
      $('.customizationConfirm').fancybox().trigger('click');
    } else {
      window.location.href = '/checkout';
    }

  })

  $('body').on('click', '.customizationConfirm .confirmClick', function(e){
    e.preventDefault();
    window.location.href = '/checkout';
  });
  
})



function isUrlExists(url)
{
    var http = new XMLHttpRequest();
    http.open('HEAD', url, false);
    http.send();
    return http.status!=404;
}

function freeBannerPDPfix() {
  if(('.freegift_promo--bar').length) {
    $('#shopify-section-product-template').addClass('promoDesktopFix');
  }
}

function isMobileVisitor() {
  let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
};


function fixTransofrmVal(el) {

  var slideTransform = el.attr('style').split(';');
  var styles = '';

  slideTransform.forEach( function(style){
      style = style.trim();
      if (style.startsWith('transform: translate3d')) {

      var split = style.split('translate3d(');

      var splitted = split[1].split(',');

      var fix = parseFloat(splitted[0]); 
      var amount = 0 - 40 * parseInt($('.addraceletSlider .braceletTypeItem').length) 
      if($('.addraceletSlider .braceletTypeItem').length > 5) {
        fix = amount - 160;
      } else {
        fix = amount + 20;
      }

      styles = 'translate3d(' + fix + 'px, ' + splitted[1] + ', ' + splitted[1] + ')!important';

      $('head').append('<style id="sliderFix" type="text/css">.addraceletSlider .slides { transform: ' + styles +  ' }</style>');
    }
  })

  return styles;

}

function resetTranformVal() {
  $('#sliderFix').remove();
}

function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min + 1)) + min;
}